import React from "react";
// CrystalCompositor v69 — EDITORIAL style: one line set huge, one axis, one accent, empty centre
// CrystalCompositor v68 — Mosaic fragments break at clause boundaries, not character counts
// CrystalCompositor v67 — Mosaic invert: words fill the plate and the mark is cut out of them
// CrystalCompositor v66 — Starlight/Star Map quotes fit the space beside each star instead of being shifted back over it
// CrystalCompositor v65 — constellation lines stop short of each star so quotes stop being crossed
// CrystalCompositor v64 — quotes pushed radially outward so they stop crossing the constellation lines
// CrystalCompositor v63 — Star Map + Starlight: quote blocks clamped to the trim edge
// CrystalCompositor v62 — Starlight: quote blocks clamped to the trim edge (was clipping)
// CrystalCompositor v61 — GRID style: one cell per contributor, scales 2-30 voices
// CrystalCompositor v60 — Mosaic: word field covers the whole plate, zodiac sized for descenders
// CrystalCompositor v59 — Mosaic: featured quote removed, shape reclaims the plate
// CrystalCompositor v58 — Mosaic: shuffled fragment deck (no visible loop), narrower adjectives
// CrystalCompositor v57 — Mosaic: cap-height-correct glyph sizing, custom shape letters, stronger field
// CrystalCompositor v56 — Mosaic: phrase-length fragments (less edge slicing) + one whole anchor quote
// CrystalCompositor v55 — MOSAIC style: words form initials, star sign, or an uploaded logo
// CrystalCompositor v54 — CUSTOM style: size controls, star marks, borders, fit-to-space wrapping
// CrystalCompositor v53 — CUSTOM style: user-picked background, text colour/texture, typeface, alignment
// CrystalCompositor v52 — Dynamic layout engine: radial outward quotes, scales 2-10+ stars, no overlap

var SERIF = '"Cormorant Garamond", Georgia, serif';
var PLAY = '"Playfair Display", Georgia, serif';
var SANS = '"Outfit", Helvetica, sans-serif';

function sr(seed) {
  var s = seed || 1;
  return function() { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; };
}

function makeDust(rand, count) {
  var d = [];
  for (var i = 0; i < count; i++) {
    var x = rand() * 36 + 32, y = rand() * 45 + 18;
    var r = rand() * 0.22 + 0.04;
    var o = rand() * 0.07 + 0.02;
    if (rand() > 0.93) { r *= 2; o *= 2; }
    d.push(React.createElement("circle", { key: "d" + i, cx: x, cy: y, r: r, fill: "white", opacity: o }));
  }
  return d;
}

function sharedDefs() {
  return React.createElement("defs", null,
    React.createElement("radialGradient", { id: "hg" },
      React.createElement("stop", { offset: "0%", stopColor: "#C9A96E", stopOpacity: .45 }),
      React.createElement("stop", { offset: "18%", stopColor: "#C9A96E", stopOpacity: .08 }),
      React.createElement("stop", { offset: "100%", stopColor: "#C9A96E", stopOpacity: 0 })
    ),
    React.createElement("radialGradient", { id: "wg" },
      React.createElement("stop", { offset: "0%", stopColor: "#fff", stopOpacity: .45 }),
      React.createElement("stop", { offset: "15%", stopColor: "#fff", stopOpacity: .08 }),
      React.createElement("stop", { offset: "100%", stopColor: "#fff", stopOpacity: 0 })
    ),
    React.createElement("filter", { id: "etch", x: "-30%", y: "-30%", width: "160%", height: "160%" },
      React.createElement("feGaussianBlur", { "in": "SourceGraphic", stdDeviation: "0.2", result: "glow" }),
      React.createElement("feColorMatrix", { "in": "glow", type: "matrix", values: "1.2 0 0 0 0.05  0 1.1 0 0 0.03  0 0 1.0 0 0.01  0 0 0 1.8 0", result: "warmGlow" }),
      React.createElement("feMerge", null,
        React.createElement("feMergeNode", { "in": "warmGlow" }),
        React.createElement("feMergeNode", { "in": "SourceGraphic" })
      )
    ),
    React.createElement("radialGradient", { id: "ledGlow", cx: "50%", cy: "95%", r: "60%", fx: "50%", fy: "95%" },
      React.createElement("stop", { offset: "0%", stopColor: "#C9A96E", stopOpacity: .08 }),
      React.createElement("stop", { offset: "40%", stopColor: "#C9A96E", stopOpacity: .03 }),
      React.createElement("stop", { offset: "100%", stopColor: "#C9A96E", stopOpacity: 0 })
    )
  );
}

function nameSz(n) { return n.length > 16 ? 2.6 : n.length > 12 ? 3.2 : n.length > 8 ? 3.8 : 4.2; }
function tagSz(h) { return h.length > 45 ? 0.95 : h.length > 35 ? 1.1 : 1.3; }

// ═══════════════════════════════════════════
// STYLE 1: INSCRIPTION — clean, engravable, medium-agnostic
// ═══════════════════════════════════════════
function renderInscription(data) {
  var stars = (data.stars || []).slice(0, 6);
  var name = data.personName || "";
  var headline = data.headline || "";
  var els = [];

  // ── Crown motif ──
  els.push(React.createElement("text", { key: "crown", x: 50, y: 16, textAnchor: "middle", fill: "#C9A96E", opacity: .30, fontSize: 2.2 }, "\u2726"));

  // ── Subtitle ──
  els.push(React.createElement("text", { key: "sub", x: 50, y: 19.5, textAnchor: "middle", fill: "#C9A96E", opacity: .22, fontSize: .75, letterSpacing: .4, fontWeight: "300", fontFamily: SERIF }, "BUILT BY THOSE WHO KNOW YOU"));

  // ── Top double coachline ──
  els.push(React.createElement("g", { key: "coach1", opacity: .22 },
    React.createElement("line", { x1: 30, y1: 22, x2: 48.5, y2: 22, stroke: "white", strokeWidth: .03 }),
    React.createElement("line", { x1: 30, y1: 22.5, x2: 48.5, y2: 22.5, stroke: "#C9A96E", strokeWidth: .015 }),
    React.createElement("rect", { x: 49.55, y: 21.75, width: .8, height: .8, fill: "#C9A96E", opacity: .5, transform: "rotate(45 49.95 22.15)" }),
    React.createElement("line", { x1: 51.4, y1: 22, x2: 70, y2: 22, stroke: "white", strokeWidth: .03 }),
    React.createElement("line", { x1: 51.4, y1: 22.5, x2: 70, y2: 22.5, stroke: "#C9A96E", strokeWidth: .015 })
  ));

  // ── Star labels — centered, evenly spaced ──
  var startY = 28;
  var spacing = stars.length <= 4 ? 7 : stars.length <= 5 ? 6.2 : 5.4;
  stars.forEach(function(star, i) {
    var y = startY + i * spacing;
    var op = i === 0 ? .72 : i < 3 ? .60 : .48;
    els.push(React.createElement("text", {
      key: "t" + i, x: 50, y: y, textAnchor: "middle",
      fill: "white", opacity: op, fontSize: 2.2,
      fontStyle: "italic", fontWeight: "300", fontFamily: SERIF,
    }, star.label));
    // Dot separator between labels
    if (i < stars.length - 1) {
      els.push(React.createElement("circle", { key: "dt" + i, cx: 50, cy: y + spacing * 0.45, r: .12, fill: "#C9A96E", opacity: .14 }));
    }
  });

  // ── Bottom double coachline ──
  var divY = startY + stars.length * spacing - spacing + 4;
  els.push(React.createElement("g", { key: "coach2", opacity: .22 },
    React.createElement("line", { x1: 28, y1: divY, x2: 48.5, y2: divY, stroke: "white", strokeWidth: .03 }),
    React.createElement("line", { x1: 28, y1: divY + .5, x2: 48.5, y2: divY + .5, stroke: "#C9A96E", strokeWidth: .015 }),
    React.createElement("rect", { x: 49.55, y: divY - .25, width: .8, height: .8, fill: "#C9A96E", opacity: .5, transform: "rotate(45 49.95 " + (divY + .15) + ")" }),
    React.createElement("line", { x1: 51.4, y1: divY, x2: 72, y2: divY, stroke: "white", strokeWidth: .03 }),
    React.createElement("line", { x1: 51.4, y1: divY + .5, x2: 72, y2: divY + .5, stroke: "#C9A96E", strokeWidth: .015 })
  ));

  // ── Name ──
  els.push(React.createElement("text", {
    key: "name", x: 50, y: divY + 5.5, textAnchor: "middle",
    fill: "white", opacity: .96, fontSize: nameSz(name),
    fontWeight: "400", letterSpacing: .35, fontFamily: PLAY,
  }, name));

  // ── Tagline ──
  els.push(React.createElement("text", {
    key: "tag", x: 50, y: divY + 9, textAnchor: "middle",
    fill: "#C9A96E", opacity: .42, fontSize: tagSz(headline),
    fontStyle: "italic", fontWeight: "300", fontFamily: SERIF, letterSpacing: .06,
  }, headline));

  return els;
}

// ═══════════════════════════════════════════
// STYLE 2: CROWN
// ═══════════════════════════════════════════
function renderCrown(data) {
  var stars = (data.stars || []).slice(0, 6);
  var name = data.personName || "";
  var headline = data.headline || "";
  var arc = [{ x: 50, y: 22 }, { x: 67, y: 30 }, { x: 33, y: 30 }, { x: 68, y: 44 }, { x: 32, y: 44 }, { x: 50, y: 53 }];
  var els = [];

  // Curved connections
  var curves = ["M50 22 Q62 23 72 30", "M50 22 Q38 23 28 30", "M72 30 Q76 37 75 46", "M28 30 Q24 37 25 46", "M75 46 Q64 52 50 56", "M25 46 Q36 52 50 56"];
  curves.forEach(function(d, i) {
    els.push(React.createElement("path", { key: "cv" + i, d: d, fill: "none", stroke: "#C9A96E", strokeWidth: .035, opacity: .10 }));
  });

  stars.forEach(function(star, i) {
    if (i >= arc.length) return;
    var p = arc[i];
    var isH = i === 0;
    els.push(React.createElement("circle", { key: "gw" + i, cx: p.x, cy: p.y, r: isH ? 4 : 2.5, fill: isH ? "url(#hg)" : "url(#wg)" }));
    els.push(React.createElement("rect", { key: "dm" + i, x: p.x - .25, y: p.y - .25, width: .5, height: .5, fill: "#C9A96E", opacity: isH ? .35 : .22, transform: "rotate(45 " + p.x + " " + p.y + ")" }));
    els.push(React.createElement("text", { key: "cl" + i, x: p.x, y: p.y - 2.2, textAnchor: "middle", fill: "white", opacity: isH ? .75 : .60, fontSize: isH ? 2.0 : 1.7, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, star.label));
  });

  els.push(React.createElement("g", { key: "div", opacity: .20 },
    React.createElement("line", { x1: 32, y1: 61, x2: 49, y2: 61, stroke: "#C9A96E", strokeWidth: .03 }),
    React.createElement("rect", { x: 49.6, y: 60.6, width: .7, height: .7, fill: "#C9A96E", transform: "rotate(45 49.95 61)" }),
    React.createElement("line", { x1: 51.3, y1: 61, x2: 68, y2: 61, stroke: "#C9A96E", strokeWidth: .03 })
  ));
  els.push(React.createElement("text", { key: "name", x: 50, y: 66, textAnchor: "middle", fill: "white", opacity: .94, fontSize: nameSz(name), fontWeight: "400", letterSpacing: .25, fontFamily: PLAY }, name));
  els.push(React.createElement("text", { key: "tag", x: 50, y: 69.5, textAnchor: "middle", fill: "white", opacity: .50, fontSize: tagSz(headline) * 1.15, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, headline));
  return els;
}

// ═══════════════════════════════════════════
// STYLE 3: POEM
// ═══════════════════════════════════════════
function renderPoem(data) {
  var name = data.personName || "";
  var headline = data.headline || "";
  var summary = data.summary || headline;
  var stars = (data.stars || []).slice(0, 6);
  var els = [];

  els.push(React.createElement("text", { key: "name", x: 50, y: 21, textAnchor: "middle", fill: "white", opacity: .94, fontSize: nameSz(name), fontWeight: "400", letterSpacing: .3, fontFamily: PLAY }, name));
  els.push(React.createElement("line", { key: "r", x1: 37, y1: 24, x2: 63, y2: 24, stroke: "#C9A96E", strokeWidth: .03, opacity: .16 }));

  var words = summary.split(" "); var lines = []; var cur = "";
  words.forEach(function(w) { if ((cur + " " + w).length > 28 && cur) { lines.push(cur); cur = w; } else { cur = cur ? cur + " " + w : w; } });
  if (cur) lines.push(cur);
  if (lines.length > 7) { lines = lines.slice(0, 7); lines[6] = lines[6].replace(/[.,;:!?\s]+$/, "") + "\u2026"; }

  lines.forEach(function(line, i) {
    els.push(React.createElement("text", { key: "p" + i, x: 50, y: 28 + i * 3.2, textAnchor: "middle", fill: "white", opacity: .60, fontSize: 1.7, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, line));
  });

  var tY = 28 + lines.length * 3.2 + 2.5;
  els.push(React.createElement("line", { key: "d1", x1: 28, y1: tY - 1.5, x2: 72, y2: tY - 1.5, stroke: "white", strokeWidth: .025, opacity: .12 }));
  var r1 = stars.slice(0, 3);
  r1.forEach(function(s, i) { els.push(React.createElement("text", { key: "r1" + i, x: 27 + i * 23, y: tY + 1.5, textAnchor: "middle", fill: "white", opacity: .42, fontSize: 1.4, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, s.label)); });
  var r2 = stars.slice(3, 6);
  r2.forEach(function(s, i) { els.push(React.createElement("text", { key: "r2" + i, x: 32 + i * 18, y: tY + 5, textAnchor: "middle", fill: "white", opacity: .35, fontSize: 1.4, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, s.label)); });
  els.push(React.createElement("line", { key: "d2", x1: 28, y1: tY + 7, x2: 72, y2: tY + 7, stroke: "white", strokeWidth: .025, opacity: .12 }));
  els.push(React.createElement("text", { key: "tag", x: 50, y: tY + 11, textAnchor: "middle", fill: "white", opacity: .62, fontSize: 1.5, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, headline));
  return els;
}

// ═══════════════════════════════════════════
// CREDIT LINE — every contributor is named.
// Never truncate: shrink to fit, then wrap to two lines.
// ═══════════════════════════════════════════
function creditLines(names, opts) {
  opts = opts || {};
  var maxW = opts.maxW || 86;
  var base = opts.base || 0.65;
  var sep = opts.sep || "  \u00B7  ";
  var min = 0.3;
  var list = (names || []).filter(Boolean);
  if (!list.length) return { lines: [], size: base };
  var W = 0.46; // rough serif advance per char, in viewBox units per fontSize
  var fit = function(str) { return maxW / (str.length * W); };
  var one = list.join(sep);
  if (one.length * base * W <= maxW) return { lines: [one], size: base };
  var shrunk = fit(one);
  if (shrunk >= min) return { lines: [one], size: shrunk };
  var half = Math.ceil(list.length / 2);
  var l1 = list.slice(0, half).join(sep);
  var l2 = list.slice(half).join(sep);
  var longest = l1.length > l2.length ? l1 : l2;
  return { lines: [l1, l2], size: Math.max(min, Math.min(base, fit(longest))) };
}

// ═══════════════════════════════════════════
// STYLE 4: TRIBUTE
// ═══════════════════════════════════════════
function renderTribute(data) {
  var name = data.personName || "";
  var headline = data.headline || "";
  var summary = data.summary || "";
  var contributors = data.contributors || [];
  var stars = (data.stars || []).slice(0, 6);
  var els = [];

  els.push(React.createElement("text", { key: "name", x: 50, y: 21, textAnchor: "middle", fill: "white", opacity: .95, fontSize: nameSz(name), fontWeight: "400", letterSpacing: .3, fontFamily: PLAY }, name));
  els.push(React.createElement("line", { key: "r", x1: 37, y1: 24, x2: 63, y2: 24, stroke: "#C9A96E", strokeWidth: .03, opacity: .16 }));

  // Main quote from summary
  var q = summary.length > 50 ? summary.substring(0, 47) + "\u2026" : summary;
  var qW = q.split(" "); var qL = []; var qC = "";
  qW.forEach(function(w) { if ((qC + " " + w).length > 24 && qC) { qL.push(qC); qC = w; } else { qC = qC ? qC + " " + w : w; } });
  if (qC) qL.push(qC);
  if (qL.length > 3) { qL = qL.slice(0, 3); qL[2] = qL[2].replace(/[.,;:!?\s]+$/, "") + "\u2026\u201D"; }

  qL.forEach(function(line, i) {
    els.push(React.createElement("text", { key: "q" + i, x: 50, y: 32 + i * 3.8, textAnchor: "middle", fill: "white", opacity: .62, fontSize: 1.8, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, (i === 0 ? "\u201C" : "") + line + (i === qL.length - 1 ? "\u201D" : "")));
  });
  var aY = 32 + qL.length * 3.8 + 2;
  if (contributors.length > 0) {
    els.push(React.createElement("text", { key: "attr", x: 50, y: aY, textAnchor: "middle", fill: "white", opacity: .40, fontSize: 1.3, fontWeight: "300", fontFamily: SERIF, letterSpacing: .1 }, "\u2014 " + contributors[0]));
  }

  els.push(React.createElement("circle", { key: "sep", cx: 50, cy: aY + 3, r: .1, fill: "white", opacity: .12 }));

  var tY = aY + 6;
  var r1 = stars.slice(0, 3);
  r1.forEach(function(s, i) { els.push(React.createElement("text", { key: "s1" + i, x: 27 + i * 23, y: tY, textAnchor: "middle", fill: "white", opacity: .42, fontSize: 1.4, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, s.label)); });
  var r2 = stars.slice(3, 6);
  r2.forEach(function(s, i) { els.push(React.createElement("text", { key: "s2" + i, x: 32 + i * 18, y: tY + 3.5, textAnchor: "middle", fill: "white", opacity: .35, fontSize: 1.4, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, s.label)); });

  els.push(React.createElement("g", { key: "div", opacity: .18 },
    React.createElement("line", { x1: 35, y1: tY + 7, x2: 49, y2: tY + 7, stroke: "white", strokeWidth: .03 }),
    React.createElement("rect", { x: 49.6, y: tY + 6.6, width: .6, height: .6, fill: "white", transform: "rotate(45 49.9 " + (tY + 7) + ")" }),
    React.createElement("line", { x1: 51.2, y1: tY + 7, x2: 65, y2: tY + 7, stroke: "white", strokeWidth: .03 })
  ));
  els.push(React.createElement("text", { key: "tag", x: 50, y: tY + 11, textAnchor: "middle", fill: "white", opacity: .62, fontSize: 1.45, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, headline));

  var trCred = creditLines(contributors, { base: 1.0 });
  trCred.lines.forEach(function(ln, i) {
    els.push(React.createElement("text", { key: "ft" + i, x: 50, y: tY + 15 + (i - (trCred.lines.length - 1)) * trCred.size * 1.35, textAnchor: "middle", fill: "white", opacity: .15, fontSize: trCred.size, letterSpacing: .15, fontWeight: "300", fontFamily: SERIF }, ln));
  });
  return els;
}

// ═══════════════════════════════════════════
// STYLE 5: VOICES — full quotes scattered
// ═══════════════════════════════════════════
function renderVoices(data) {
  var name = data.personName || "";
  var headline = data.headline || "";
  var stars = (data.stars || []).slice(0, 5);
  var contributors = data.contributors || [];
  var els = [];

  // Tighter positions — all well inside the face
  var spots = [
    { x: 50, y: 26, sz: 1.55, op: .62 },
    { x: 38, y: 36, sz: 1.45, op: .55 },
    { x: 62, y: 36, sz: 1.45, op: .55 },
    { x: 36, y: 46, sz: 1.35, op: .48 },
    { x: 64, y: 46, sz: 1.35, op: .48 },
  ];

  stars.forEach(function(star, i) {
    if (i >= spots.length) return;
    var s = spots[i];
    var contrib = star.starContributors && star.starContributors[0] ? star.starContributors[0] : (contributors[i % contributors.length] || "");
    var quote = star.decode || star.label;

    // Split quote into 2 lines max at ~25 chars
    var qWords = quote.split(" ");
    var line1 = ""; var line2 = "";
    qWords.forEach(function(w) {
      if (!line2 && (line1 + " " + w).length <= 26) { line1 = line1 ? line1 + " " + w : w; }
      else if (!line2 || (line2 + " " + w).length <= 26) { line2 = line2 ? line2 + " " + w : w; }
    });

    // Quote line 1
    els.push(React.createElement("text", {
      key: "vq1" + i, x: s.x, y: s.y, textAnchor: "middle",
      fill: "white", opacity: s.op, fontSize: s.sz,
      fontStyle: "italic", fontWeight: "300", fontFamily: SERIF,
    }, "\u201C" + line1 + (line2 ? "" : "\u201D")));

    // Quote line 2 (if exists)
    if (line2) {
      els.push(React.createElement("text", {
        key: "vq2" + i, x: s.x, y: s.y + 2.2, textAnchor: "middle",
        fill: "white", opacity: s.op * .9, fontSize: s.sz,
        fontStyle: "italic", fontWeight: "300", fontFamily: SERIF,
      }, line2 + "\u201D"));
    }

    // Attribution
    var attrY = line2 ? s.y + 4.2 : s.y + 2.2;
    els.push(React.createElement("text", {
      key: "va" + i, x: s.x, y: attrY, textAnchor: "middle",
      fill: "white", opacity: s.op * .45, fontSize: s.sz * .6,
      fontWeight: "300", fontFamily: SERIF, letterSpacing: .08,
    }, "\u2014 " + contrib));
  });

  // Divider
  els.push(React.createElement("g", { key: "div", opacity: .18 },
    React.createElement("line", { x1: 37, y1: 58, x2: 49, y2: 58, stroke: "white", strokeWidth: .03 }),
    React.createElement("rect", { x: 49.6, y: 57.6, width: .6, height: .6, fill: "white", transform: "rotate(45 49.9 58)" }),
    React.createElement("line", { x1: 51.2, y1: 58, x2: 63, y2: 58, stroke: "white", strokeWidth: .03 })
  ));

  // Name
  var nSz = name.length > 16 ? 2.6 : name.length > 12 ? 3.2 : name.length > 8 ? 3.8 : 4.2;
  els.push(React.createElement("text", { key: "name", x: 50, y: 63.5, textAnchor: "middle", fill: "white", opacity: .94, fontSize: nSz, fontWeight: "400", letterSpacing: .3, fontFamily: PLAY }, name));

  // Tagline
  els.push(React.createElement("text", { key: "tag", x: 50, y: 67, textAnchor: "middle", fill: "white", opacity: .50, fontSize: headline.length > 40 ? 1.0 : 1.25, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, headline));

  return els;
}

// ═══════════════════════════════════════════
// STYLE 6: MONUMENT — ceremonial, centered, medium-agnostic
// ═══════════════════════════════════════════
function splitLines(text, maxChars) {
  var words = text.split(" "); var lines = []; var cur = "";
  words.forEach(function(w) {
    if ((cur + " " + w).length > maxChars && cur) { lines.push(cur); cur = w; }
    else { cur = cur ? cur + " " + w : w; }
  });
  if (cur) lines.push(cur);
  return lines;
}

function renderMonument(data) {
  var name = data.personName || "";
  var headline = data.headline || "";
  var stars = (data.stars || []).slice(0, 5);
  var contributors = data.contributors || [];
  var els = [];

  // ── Crown motif ──
  els.push(React.createElement("text", { key: "crown", x: 50, y: 14, textAnchor: "middle", fill: "#C9A96E", opacity: .30, fontSize: 2.5 }, "\u2726"));

  // ── Name — monumental ──
  var nSz = name.length > 16 ? 2.8 : name.length > 12 ? 3.4 : name.length > 8 ? 4.0 : 4.5;
  els.push(React.createElement("text", { key: "name", x: 50, y: 21, textAnchor: "middle", fill: "white", opacity: .96, fontSize: nSz, fontWeight: "400", letterSpacing: .4, fontFamily: PLAY }, name));

  // ── Double coachline under name ──
  els.push(React.createElement("g", { key: "coach", opacity: .25 },
    React.createElement("line", { x1: 25, y1: 24, x2: 48.5, y2: 24, stroke: "white", strokeWidth: .04 }),
    React.createElement("line", { x1: 25, y1: 24.6, x2: 48.5, y2: 24.6, stroke: "#C9A96E", strokeWidth: .02 }),
    React.createElement("rect", { x: 49.55, y: 23.75, width: .9, height: .9, fill: "#C9A96E", opacity: .5, transform: "rotate(45 50 24.2)" }),
    React.createElement("line", { x1: 51.5, y1: 24, x2: 75, y2: 24, stroke: "white", strokeWidth: .04 }),
    React.createElement("line", { x1: 51.5, y1: 24.6, x2: 75, y2: 24.6, stroke: "#C9A96E", strokeWidth: .02 })
  ));

  // ── Tagline ──
  els.push(React.createElement("text", { key: "tag", x: 50, y: 28, textAnchor: "middle", fill: "#C9A96E", opacity: .40, fontSize: headline.length > 40 ? 1.0 : 1.2, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF, letterSpacing: .06 }, headline));

  // ── Starfield dot separator ──
  [35, 38, 41, 44, 47, 50, 53, 56, 59, 62, 65].forEach(function(dx, i) {
    els.push(React.createElement("circle", { key: "sep1_" + i, cx: dx, cy: 31.5, r: i === 5 ? .25 : .12, fill: "white", opacity: i === 5 ? .18 : .08 }));
  });

  // ── Primary quote (top center — the strongest voice) ──
  if (stars[0]) {
    var q0 = stars[0].decode || stars[0].label;
    var c0 = stars[0].starContributors && stars[0].starContributors[0] ? stars[0].starContributors[0] : (contributors[0] || "");
    var q0Lines = splitLines(q0, 30);
    q0Lines.forEach(function(line, li) {
      els.push(React.createElement("text", { key: "q0_" + li, x: 50, y: 36 + li * 2.2, textAnchor: "middle", fill: "white", opacity: .58, fontSize: 1.5, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF },
        (li === 0 ? "\u201C" : "") + line + (li === q0Lines.length - 1 ? "\u201D" : "")));
    });
    var a0Y = 36 + q0Lines.length * 2.2 + 1;
    els.push(React.createElement("text", { key: "a0", x: 50, y: a0Y, textAnchor: "middle", fill: "#C9A96E", opacity: .22, fontSize: .8, fontWeight: "300", fontFamily: SERIF, letterSpacing: .1 }, "\u2014 " + c0));
  }

  // ── Flanking quotes row 1 (left + right) ──
  var row1Y = 46;
  [1, 2].forEach(function(idx) {
    if (!stars[idx]) return;
    var xPos = idx === 1 ? 37 : 63;
    var q = stars[idx].decode || stars[idx].label;
    var c = stars[idx].starContributors && stars[idx].starContributors[0] ? stars[idx].starContributors[0] : (contributors[idx % contributors.length] || "");
    var qLines = splitLines(q, 22);
    qLines.forEach(function(line, li) {
      els.push(React.createElement("text", { key: "q" + idx + "_" + li, x: xPos, y: row1Y + li * 2, textAnchor: "middle", fill: "white", opacity: .45, fontSize: 1.25, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF },
        (li === 0 ? "\u201C" : "") + line + (li === qLines.length - 1 ? "\u201D" : "")));
    });
    var aY = row1Y + qLines.length * 2 + 0.8;
    els.push(React.createElement("text", { key: "a" + idx, x: xPos, y: aY, textAnchor: "middle", fill: "#C9A96E", opacity: .18, fontSize: .7, fontWeight: "300", fontFamily: SERIF, letterSpacing: .08 }, "\u2014 " + c));
  });

  // ── Flanking quotes row 2 (left + right) ──
  var row2Y = 56;
  [3, 4].forEach(function(idx) {
    if (!stars[idx]) return;
    var xPos = idx === 3 ? 37 : 63;
    var q = stars[idx].decode || stars[idx].label;
    var c = stars[idx].starContributors && stars[idx].starContributors[0] ? stars[idx].starContributors[0] : (contributors[idx % contributors.length] || "");
    var qLines = splitLines(q, 22);
    qLines.forEach(function(line, li) {
      els.push(React.createElement("text", { key: "q" + idx + "_" + li, x: xPos, y: row2Y + li * 2, textAnchor: "middle", fill: "white", opacity: .38, fontSize: 1.2, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF },
        (li === 0 ? "\u201C" : "") + line + (li === qLines.length - 1 ? "\u201D" : "")));
    });
    var aY = row2Y + qLines.length * 2 + 0.8;
    els.push(React.createElement("text", { key: "a" + idx, x: xPos, y: aY, textAnchor: "middle", fill: "#C9A96E", opacity: .15, fontSize: .7, fontWeight: "300", fontFamily: SERIF, letterSpacing: .08 }, "\u2014 " + c));
  });

  // ── Starfield dot separator ──
  [35, 38, 41, 44, 47, 50, 53, 56, 59, 62, 65].forEach(function(dx, i) {
    els.push(React.createElement("circle", { key: "sep2_" + i, cx: dx, cy: 67, r: i === 5 ? .25 : .12, fill: "white", opacity: i === 5 ? .18 : .08 }));
  });

  // ── Footer ──
  els.push(React.createElement("text", { key: "footer", x: 50, y: 71, textAnchor: "middle", fill: "white", opacity: .10, fontSize: .7, fontWeight: "300", fontFamily: SERIF, letterSpacing: .5 }, "YOURS   TRULY"));

  return els;
}

// ═══════════════════════════════════════════
// STYLE 7: GALLERY V2 — Rolls Royce minimal, night sky
// ═══════════════════════════════════════════
function renderGallery(data) {
  var name = data.personName || "";
  var headline = data.headline || "";
  var stars = (data.stars || []).slice(0, 6);
  var contributors = data.contributors || [];
  var els = [];

  // Subtle starfield background
  var seed = 31;
  for (var si = 0; si < 40; si++) {
    seed = (seed * 16807) % 2147483647;
    var sx = (seed % 10000) / 100;
    seed = (seed * 16807) % 2147483647;
    var sy = (seed % 10000) / 100;
    seed = (seed * 16807) % 2147483647;
    var sr2 = .05 + (seed % 100) / 800;
    els.push(React.createElement("circle", { key: "gs" + si, cx: sx, cy: sy, r: sr2, fill: "#C9A96E", opacity: .06 + (seed % 50) / 600 }));
  }

  // Crown motif
  els.push(React.createElement("text", { key: "gcrown", x: 50, y: 14, textAnchor: "middle", fill: "#C9A96E", opacity: .30, fontSize: 2.5 }, "\u2726"));
  els.push(React.createElement("text", { key: "gcrown2", x: 46, y: 14, textAnchor: "middle", fill: "#C9A96E", opacity: .15, fontSize: 1.2 }, "\u2727"));
  els.push(React.createElement("text", { key: "gcrown3", x: 54, y: 14, textAnchor: "middle", fill: "#C9A96E", opacity: .15, fontSize: 1.2 }, "\u2727"));

  // Name — MASSIVE
  var nameParts = name.split(" ");
  var nSz = name.length > 16 ? 8 : name.length > 12 ? 10 : name.length > 8 ? 12 : 14;

  if (nameParts.length > 1 && name.length > 10) {
    els.push(React.createElement("text", { key: "gn1", x: 50, y: 33, textAnchor: "middle", fill: "white", opacity: .98, fontSize: nSz, fontWeight: "400", letterSpacing: .8, fontFamily: PLAY }, nameParts[0]));
    els.push(React.createElement("text", { key: "gn2", x: 50, y: 33 + nSz * 1.15, textAnchor: "middle", fill: "white", opacity: .98, fontSize: nSz, fontWeight: "400", letterSpacing: .8, fontFamily: PLAY }, nameParts.slice(1).join(" ")));
  } else {
    els.push(React.createElement("text", { key: "gn1", x: 50, y: 38, textAnchor: "middle", fill: "white", opacity: .98, fontSize: nSz, fontWeight: "400", letterSpacing: .8, fontFamily: PLAY }, name));
  }

  var baseY = nameParts.length > 1 && name.length > 10 ? 33 + nSz * 1.15 + 3 : 43;

  // Ornate double coachline
  els.push(React.createElement("g", { key: "gcoach", opacity: .30 },
    React.createElement("line", { x1: 15, y1: baseY, x2: 48, y2: baseY, stroke: "white", strokeWidth: .04 }),
    React.createElement("line", { x1: 15, y1: baseY + .6, x2: 48, y2: baseY + .6, stroke: "#C9A96E", strokeWidth: .02 }),
    React.createElement("rect", { x: 49.5, y: baseY - .3, width: 1, height: 1, fill: "#C9A96E", opacity: .6, transform: "rotate(45 50 " + (baseY + .2) + ")" }),
    React.createElement("line", { x1: 52, y1: baseY, x2: 85, y2: baseY, stroke: "white", strokeWidth: .04 }),
    React.createElement("line", { x1: 52, y1: baseY + .6, x2: 85, y2: baseY + .6, stroke: "#C9A96E", strokeWidth: .02 })
  ));

  // Headline — prominent
  els.push(React.createElement("text", { key: "ghl", x: 50, y: baseY + 5.5, textAnchor: "middle", fill: "#C9A96E", opacity: .80, fontSize: 3, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, headline));

  // Quotes — bigger, cascading opacity, with glow dots
  var qStartY = baseY + 14;
  var maxQ = Math.min(stars.length, 4);
  for (var i = 0; i < maxQ; i++) {
    var q = stars[i].decode || stars[i].label;
    var ct = stars[i].starContributors && stars[i].starContributors[0] ? stars[i].starContributors[0] : (contributors[i % contributors.length] || "");
    var qOp = i === 0 ? .65 : i === 1 ? .55 : i === 2 ? .45 : .38;
    // Small glowing star before each quote
    els.push(React.createElement("circle", { key: "gqg" + i, cx: 50, cy: qStartY + i * 7 - 2.5, r: .15, fill: "#C9A96E", opacity: qOp }));
    els.push(React.createElement("circle", { key: "gqg2" + i, cx: 50, cy: qStartY + i * 7 - 2.5, r: .5, fill: "#C9A96E", opacity: qOp * .15 }));
    els.push(React.createElement("text", { key: "gq" + i, x: 50, y: qStartY + i * 7, textAnchor: "middle", fill: "white", opacity: qOp, fontSize: 1.8, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, "\u201C" + q + "\u201D"));
    els.push(React.createElement("text", { key: "ga" + i, x: 50, y: qStartY + i * 7 + 2.5, textAnchor: "middle", fill: "#C9A96E", opacity: qOp * .85, fontSize: .85, fontWeight: "300", fontFamily: SERIF, letterSpacing: .15 }, "\u2014 " + ct));
  }

  // Footer
  els.push(React.createElement("text", { key: "gft", x: 50, y: 97, textAnchor: "middle", fill: "#C9A96E", opacity: .15, fontSize: .65, fontWeight: "300", fontFamily: SERIF, letterSpacing: .8 }, "YOURS   TRULY"));

  return els;
}

// STYLE 8: FINGERPRINT — concentric text ridges
// ═══════════════════════════════════════════
function renderFingerprint(data) {
  var name = data.personName || "";
  var headline = data.headline || "";
  var stars = (data.stars || []).slice(0, 6);
  var els = [];

  var quotes = stars.map(function(s) { return s.decode || s.label; });
  while (quotes.length < 6) quotes.push(headline);
  var allTexts = [name, headline].concat(quotes);

  var rings = [
    { rx: 5, ry: 3, ox: 0, oy: 0 },
    { rx: 10, ry: 6.5, ox: .4, oy: .2 },
    { rx: 16, ry: 11, ox: .6, oy: -.2 },
    { rx: 22, ry: 15.5, ox: .3, oy: .3 },
    { rx: 28, ry: 20.5, ox: -.3, oy: -.2 },
    { rx: 35, ry: 26, ox: -.5, oy: .2 },
    { rx: 42, ry: 31, ox: .2, oy: .3 },
    { rx: 49, ry: 37, ox: -.2, oy: -.1 },
  ];

  var cx = 50, cy = 42;
  var defs = [];
  var texts = [];

  // Warm glow behind center
  els.push(React.createElement("circle", { key: "fpglow1", cx: cx, cy: cy, r: 18, fill: "#C9A96E", opacity: .04 }));
  els.push(React.createElement("circle", { key: "fpglow2", cx: cx, cy: cy, r: 10, fill: "#C9A96E", opacity: .06 }));
  els.push(React.createElement("circle", { key: "fpglow3", cx: cx, cy: cy, r: 4, fill: "#C9A96E", opacity: .08 }));

  rings.forEach(function(ring, i) {
    var id = "fp" + i;
    var x = cx + ring.ox, y = cy + ring.oy;
    var d = "M " + (x - ring.rx) + "," + y + " a " + ring.rx + "," + ring.ry + " " + (i % 3 - 1) + " 1 1 " + (ring.rx * 2) + ",0 a " + ring.rx + "," + ring.ry + " " + (i % 3 - 1) + " 1 1 " + (-ring.rx * 2) + ",0";
    defs.push(React.createElement("path", { key: "p" + id, id: id, d: d, fill: "none" }));

    // Faint structural ring
    texts.push(React.createElement("ellipse", { key: "fe" + i, cx: x, cy: y, rx: ring.rx + 1.5, ry: ring.ry + 1, fill: "none", stroke: "#C9A96E", strokeWidth: .03, opacity: .08 }));

    // Diamond markers at cardinal points of each ring
    var dmOp = i < 3 ? .25 : i < 6 ? .15 : .10;
    var dmSz = i < 3 ? .6 : .5;
    [0, 90, 180, 270].forEach(function(angle, ai) {
      var rad = angle * Math.PI / 180;
      var dx = x + ring.rx * Math.cos(rad);
      var dy = y + ring.ry * Math.sin(rad);
      els.push(React.createElement("rect", {
        key: "fdm" + i + "_" + ai,
        x: dx - dmSz/2, y: dy - dmSz/2,
        width: dmSz, height: dmSz,
        fill: "#C9A96E", opacity: dmOp,
        transform: "rotate(45 " + dx + " " + dy + ")"
      }));
    });

    var textIdx = i % allTexts.length;
    var txt = allTexts[textIdx];
    var circumf = Math.PI * 2 * ((ring.rx + ring.ry) / 2);
    var charW = i < 2 ? 1.6 : 1.0;
    var reps = Math.max(1, Math.ceil(circumf / (txt.length * charW)));
    var fullText = "";
    for (var r = 0; r < reps; r++) fullText += (r > 0 ? " \u00B7 " : "") + txt;

    var opacity = i === 0 ? .90 : i < 3 ? .75 : i < 5 ? .58 : .45;
    var fontSize = i === 0 ? 1.8 : i < 3 ? 1.6 : i < 5 ? 1.5 : 1.4;
    var colors = ["#F5F0EB", "#E8D5B8", "#D4B896", "#C9A96E", "#D4B896", "#C9A96E", "#B8967A", "#B8967A"];
    var fill = colors[i];
    var offset = ((i * 7) % 25) + "%";

    texts.push(React.createElement("text", { key: "t" + id, fill: fill, opacity: opacity, fontSize: fontSize, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF },
      React.createElement("textPath", { href: "#" + id, startOffset: offset }, fullText)
    ));
  });

  els.push(React.createElement("defs", { key: "fpdefs" }, defs));
  els = els.concat(texts);

  // Center initials
  var initials = name.split(" ").map(function(w) { return w[0] || ""; }).join("");
  els.push(React.createElement("text", { key: "fpinit", x: cx, y: cy + 1.2, textAnchor: "middle", fill: "#F5F0EB", opacity: .90, fontSize: 2.8, fontWeight: "400", letterSpacing: .2, fontFamily: PLAY }, initials));

  // Crown motif above fingerprint
  els.push(React.createElement("text", { key: "fpcrown", x: 50, y: 4, textAnchor: "middle", fill: "#C9A96E", opacity: .20, fontSize: 1.8 }, "\u2726"));

  // Name below
  els.push(React.createElement("text", { key: "fpname", x: 50, y: 87, textAnchor: "middle", fill: "white", opacity: .96, fontSize: nameSz(name) * 1.15, fontWeight: "400", letterSpacing: .35, fontFamily: PLAY }, name));

  // Double coachline
  els.push(React.createElement("g", { key: "fpcoach", opacity: .22 },
    React.createElement("line", { x1: 30, y1: 90, x2: 48.5, y2: 90, stroke: "white", strokeWidth: .03 }),
    React.createElement("line", { x1: 30, y1: 90.5, x2: 48.5, y2: 90.5, stroke: "#C9A96E", strokeWidth: .015 }),
    React.createElement("rect", { x: 49.55, y: 89.75, width: .8, height: .8, fill: "#C9A96E", opacity: .5, transform: "rotate(45 49.95 90.15)" }),
    React.createElement("line", { x1: 51.4, y1: 90, x2: 70, y2: 90, stroke: "white", strokeWidth: .03 }),
    React.createElement("line", { x1: 51.4, y1: 90.5, x2: 70, y2: 90.5, stroke: "#C9A96E", strokeWidth: .015 })
  ));

  // Tagline
  els.push(React.createElement("text", { key: "fptag", x: 50, y: 95, textAnchor: "middle", fill: "#C9A96E", opacity: .50, fontSize: tagSz(headline) * 1.1, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, headline));

  return els;
}

// STYLE 9: KALEIDOSCOPE — full-bleed text mandala
// ═══════════════════════════════════════════
function renderKaleidoscope(data) {
  var name = data.personName || "";
  var headline = data.headline || "";
  var stars = (data.stars || []).slice(0, 6);
  var els = [];

  var quotes = stars.map(function(s) { return s.decode || s.label; });
  while (quotes.length < 6) quotes.push(headline);

  var cx = 50, cy = 50;
  var radii = [4, 6.5, 9, 12, 15, 18, 21.5, 25, 29, 33, 37.5, 42, 47, 52.5, 59, 66, 74];
  var colors = ["#F5F0EB", "#B8967A", "#F5F0EB", "#C4A060", "#B8967A", "#F5F0EB", "#B8967A", "#C4A060", "#F5F0EB", "#B8967A", "#C48B9A", "#F5F0EB", "#B8967A", "#C4A060", "#B8967A", "#F5F0EB", "#C48B9A"];

  var defs = [];
  var texts = [];

  // Circular text rings
  radii.forEach(function(r, i) {
    var id = "kr" + i;
    var d = "M " + (cx - r) + "," + cy + " a " + r + "," + r + " 0 1 1 " + (r * 2) + ",0 a " + r + "," + r + " 0 1 1 " + (-r * 2) + ",0";
    defs.push(React.createElement("path", { key: "kp" + i, id: id, d: d, fill: "none" }));

    var textIdx = i < 2 ? 0 : (i - 2) % quotes.length;
    var txt = i < 2 ? name : quotes[textIdx];
    var circumf = Math.PI * 2 * r;
    var charW = i < 2 ? 1.0 : 0.55;
    var reps = Math.max(1, Math.ceil(circumf / (txt.length * charW)));
    var fullText = "";
    for (var j = 0; j < reps; j++) fullText += (j > 0 ? " \u00B7 " : "") + txt;

    var opacity = i < 2 ? .70 : i < 5 ? .55 : i < 8 ? .40 : i < 11 ? .28 : i < 14 ? .18 : .12;
    var fontSize = i < 2 ? .9 : i < 5 ? .85 : .8;
    var offset = ((i * 11 + 3) % 30) + "%";

    texts.push(React.createElement("text", { key: "kt" + i, fill: colors[i % colors.length], opacity: opacity, fontSize: fontSize, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF },
      React.createElement("textPath", { href: "#" + id, startOffset: offset }, fullText)
    ));
  });

  // Radial rays
  var rayAngles = [0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330];
  var rayColors = ["#B8967A", "#C4A060", "#F5F0EB", "#C48B9A", "#B8967A", "#F5F0EB", "#C4A060", "#B8967A", "#C48B9A", "#F5F0EB", "#B8967A", "#C4A060"];
  rayAngles.forEach(function(angle, i) {
    var rad = angle * Math.PI / 180;
    var ex = cx + 72 * Math.sin(rad);
    var ey = cy - 72 * Math.cos(rad);
    var rayId = "kray" + i;
    defs.push(React.createElement("path", { key: "krp" + i, id: rayId, d: "M " + cx + "," + cy + " L " + ex + "," + ey, fill: "none" }));

    var txt = quotes[i % quotes.length];
    var reps = 2;
    var fullText = "";
    for (var j = 0; j < reps; j++) fullText += (j > 0 ? " \u00B7 " : "") + txt;

    texts.push(React.createElement("text", { key: "krt" + i, fill: rayColors[i], opacity: .10, fontSize: .75, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF },
      React.createElement("textPath", { href: "#" + rayId, startOffset: "12%" }, fullText)
    ));

    // Faint structural lines
    els.push(React.createElement("line", { key: "krl" + i, x1: cx, y1: cy, x2: ex, y2: ey, stroke: "#B8967A", strokeWidth: .02, opacity: .04 }));
  });

  // Faint concentric structure circles
  [10, 20, 30, 40, 50, 60, 70].forEach(function(r, i) {
    els.push(React.createElement("circle", { key: "kc" + i, cx: cx, cy: cy, r: r, fill: "none", stroke: "#B8967A", strokeWidth: .02, opacity: .03 }));
  });

  els.push(React.createElement("defs", { key: "kdefs" }, defs));
  els = els.concat(texts);

  // Center initials
  var initials = name.split(" ").map(function(w) { return w[0]; }).join(".") + ".";
  els.push(React.createElement("circle", { key: "kcenter", cx: cx, cy: cy, r: 2.5, fill: "#0A0A0A", stroke: "#B8967A", strokeWidth: .06, opacity: .5 }));
  els.push(React.createElement("text", { key: "kinit", x: cx, y: cy + .5, textAnchor: "middle", fill: "#F5F0EB", opacity: .90, fontSize: 1.3, fontWeight: "400", letterSpacing: .15, fontFamily: PLAY }, initials));

  return els;
}

// ═══════════════════════════════════════════
// STYLE 10: STAR MAP V2 — night sky drama, glowing stars
// ═══════════════════════════════════════════
function renderStarMap(data) {
  var name = data.personName || "";
  var headline = data.headline || "";
  var stars = (data.stars || []).slice(0, 6);
  var contributors = data.contributors || [];
  var els = [];

  var cx = 50, cy = 38, radius = 30;

  // Subtle nebula glow behind the chart
  els.push(React.createElement("ellipse", { key: "smneb1", cx: 42, cy: 34, rx: 22, ry: 18, fill: "#2A1B3D", opacity: .25 }));
  els.push(React.createElement("ellipse", { key: "smneb2", cx: 58, cy: 42, rx: 20, ry: 14, fill: "#1B2A3D", opacity: .18 }));

  // Background scatter stars — varying sizes for depth
  var seed = 77;
  for (var si = 0; si < 60; si++) {
    seed = (seed * 16807) % 2147483647;
    var sx = (seed % 10000) / 100;
    seed = (seed * 16807) % 2147483647;
    var sy = (seed % 7000) / 100;
    seed = (seed * 16807) % 2147483647;
    var ssr = .04 + (seed % 100) / 1200;
    var sop = .04 + (seed % 60) / 700;
    var dist = Math.sqrt((sx - cx) * (sx - cx) + (sy - cy) * (sy - cy));
    if (dist < radius - 1) {
      els.push(React.createElement("circle", { key: "sms" + si, cx: sx, cy: sy, r: ssr, fill: "#F5F0EB", opacity: sop }));
    }
  }

  // Double ornate circle border
  els.push(React.createElement("circle", { key: "smr1", cx: cx, cy: cy, r: radius, fill: "none", stroke: "#C9A96E", strokeWidth: .15, opacity: .35 }));
  els.push(React.createElement("circle", { key: "smr2", cx: cx, cy: cy, r: radius + .6, fill: "none", stroke: "#C9A96E", strokeWidth: .04, opacity: .15 }));
  els.push(React.createElement("circle", { key: "smr3", cx: cx, cy: cy, r: radius - .5, fill: "none", stroke: "#C9A96E", strokeWidth: .02, opacity: .08 }));

  // Tick marks — more ornate
  for (var t = 0; t < 360; t += 10) {
    var rad = t * Math.PI / 180;
    var isMajor = t % 90 === 0;
    var isMid = t % 30 === 0 && !isMajor;
    var len = isMajor ? 2 : isMid ? 1.3 : .5;
    var tw = isMajor ? .08 : isMid ? .05 : .03;
    var top = isMajor ? .25 : isMid ? .15 : .08;
    els.push(React.createElement("line", {
      key: "smt" + t,
      x1: cx + radius * Math.sin(rad), y1: cy - radius * Math.cos(rad),
      x2: cx + (radius + len) * Math.sin(rad), y2: cy - (radius + len) * Math.cos(rad),
      stroke: "#C9A96E", strokeWidth: tw, opacity: top
    }));
  }

  // Dashed orbit rings
  [10, 20].forEach(function(r, ri) {
    els.push(React.createElement("circle", { key: "smo" + ri, cx: cx, cy: cy, r: r, fill: "none", stroke: "#C9A96E", strokeWidth: .03, opacity: .06, strokeDasharray: ".4 .8" }));
  });

  // Faint crosshairs
  els.push(React.createElement("line", { key: "smv", x1: cx, y1: cy - radius + 2, x2: cx, y2: cy + radius - 2, stroke: "#C9A96E", strokeWidth: .02, opacity: .05 }));
  els.push(React.createElement("line", { key: "smh", x1: cx - radius + 2, y1: cy, x2: cx + radius - 2, y2: cy, stroke: "#C9A96E", strokeWidth: .02, opacity: .05 }));

  // Star positions
  var angles = [-50, 15, 70, 135, 200, 260];
  var starPositions = [];
  stars.forEach(function(star, i) {
    var angle = angles[i % angles.length];
    var res = star.resonance || 3;
    var r = 25 - (res - 1) * 3;
    if (r < 10) r = 10;
    if (r > 25) r = 25;
    var srad = angle * Math.PI / 180;
    starPositions.push({ x: cx + r * Math.sin(srad), y: cy - r * Math.cos(srad), angle: angle });
  });

  // Constellation lines — bold with subtle glow
  for (var li = 0; li < starPositions.length; li++) {
    var next = (li + 1) % starPositions.length;
    // Glow line
    els.push(React.createElement("line", {
      key: "smlg" + li,
      x1: starPositions[li].x, y1: starPositions[li].y,
      x2: starPositions[next].x, y2: starPositions[next].y,
      stroke: "#C9A96E", strokeWidth: 1, opacity: .08
    }));
    // Core line
    els.push(React.createElement("line", {
      key: "sml" + li,
      x1: starPositions[li].x, y1: starPositions[li].y,
      x2: starPositions[next].x, y2: starPositions[next].y,
      stroke: "#C9A96E", strokeWidth: .2, opacity: .45
    }));
  }

  // Stars with DRAMATIC glow + diffraction spikes + quotes
  stars.forEach(function(star, i) {
    if (i >= starPositions.length) return;
    var sp = starPositions[i];
    var quote = star.decode || star.label;
    var contrib = star.starContributors && star.starContributors[0] ? star.starContributors[0] : (contributors[i % contributors.length] || "");
    var op = i === 0 ? .85 : i < 3 ? .70 : .55;

    // Star glow layers — dramatic
    els.push(React.createElement("circle", { key: "smg1" + i, cx: sp.x, cy: sp.y, r: 5, fill: "#C9A96E", opacity: .07 }));
    els.push(React.createElement("circle", { key: "smg2" + i, cx: sp.x, cy: sp.y, r: 3, fill: "#D4B896", opacity: .15 }));
    els.push(React.createElement("circle", { key: "smg3" + i, cx: sp.x, cy: sp.y, r: 1.5, fill: "#F5F0EB", opacity: .35 }));
    els.push(React.createElement("circle", { key: "smg4" + i, cx: sp.x, cy: sp.y, r: .6, fill: "#FFFFFF", opacity: .95 }));

    // Diffraction spikes — 4 point cross
    var spikeLen = i === 0 ? 5 : 3.5;
    var spikeOp = i === 0 ? .30 : .20;
    els.push(React.createElement("line", { key: "smsh" + i, x1: sp.x - spikeLen, y1: sp.y, x2: sp.x + spikeLen, y2: sp.y, stroke: "#F5F0EB", strokeWidth: .06, opacity: spikeOp }));
    els.push(React.createElement("line", { key: "smsv" + i, x1: sp.x, y1: sp.y - spikeLen, x2: sp.x, y2: sp.y + spikeLen, stroke: "#F5F0EB", strokeWidth: .06, opacity: spikeOp }));

    // Quote — bigger, bolder
    var isRight = sp.angle >= -90 && sp.angle < 90;
    var qx = isRight ? sp.x + 3 : sp.x - 3;
    var anchor = isRight ? "start" : "end";

    var words = quote.split(" ");
    var qLines = []; var cur = "";
    words.forEach(function(w) {
      if ((cur + " " + w).length > 20 && cur) { qLines.push(cur); cur = w; }
      else { cur = cur ? cur + " " + w : w; }
    });
    if (cur) qLines.push(cur);
    if (qLines.length > 2) qLines = qLines.slice(0, 2);

    qLines.forEach(function(line, li) {
      els.push(React.createElement("text", {
        key: "smq" + i + "_" + li, x: qx, y: sp.y - 1.5 + li * 2,
        textAnchor: anchor, fill: "white", opacity: op,
        fontSize: 2.0, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF
      }, (li === 0 ? "\u201C" : "") + line + (li === qLines.length - 1 ? "\u201D" : "")));
    });

    var attrY = sp.y - 1.5 + qLines.length * 2 + .8;
    els.push(React.createElement("text", {
      key: "sma" + i, x: qx, y: attrY,
      textAnchor: anchor, fill: "#C9A96E", opacity: op * .5,
      fontSize: .75, fontWeight: "300", fontFamily: SERIF, letterSpacing: .15
    }, "\u2014 " + contrib));
  });

  // Crown motif
  els.push(React.createElement("text", { key: "smcrown", x: 50, y: 5, textAnchor: "middle", fill: "#C9A96E", opacity: .22, fontSize: 2 }, "\u2726"));

  // Name — grand
  els.push(React.createElement("text", { key: "smname", x: 50, y: 80, textAnchor: "middle", fill: "white", opacity: .98, fontSize: nameSz(name) * 1.3, fontWeight: "400", letterSpacing: .5, fontFamily: PLAY }, name));

  // Ornate coachline
  els.push(React.createElement("g", { key: "smcoach", opacity: .28 },
    React.createElement("line", { x1: 18, y1: 83.5, x2: 48, y2: 93.5, stroke: "white", strokeWidth: .04 }),
    React.createElement("line", { x1: 18, y1: 84.1, x2: 48, y2: 84.1, stroke: "#C9A96E", strokeWidth: .02 }),
    React.createElement("rect", { x: 49.5, y: 93.2, width: 1, height: 1, fill: "#C9A96E", opacity: .6, transform: "rotate(45 50 93.7)" }),
    React.createElement("line", { x1: 52, y1: 93.5, x2: 82, y2: 93.5, stroke: "white", strokeWidth: .04 }),
    React.createElement("line", { x1: 52, y1: 84.1, x2: 82, y2: 84.1, stroke: "#C9A96E", strokeWidth: .02 })
  ));

  // Tagline
  els.push(React.createElement("text", { key: "smtag", x: 50, y: 89, textAnchor: "middle", fill: "#C9A96E", opacity: .55, fontSize: tagSz(headline) * 1.2, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, headline));

  // Contributors
  var smCred = creditLines(data.contributors, { base: .7 });
  smCred.lines.forEach(function(ln, i) {
    els.push(React.createElement("text", { key: "smcon" + i, x: 50, y: 93.5 + (i - (smCred.lines.length - 1)) * smCred.size * 1.35, textAnchor: "middle", fill: "#C9A96E", opacity: .22, fontSize: smCred.size, fontWeight: "300", fontFamily: SERIF, letterSpacing: .12 }, ln));
  });

  els.push(React.createElement("text", { key: "smft", x: 50, y: 98, textAnchor: "middle", fill: "#C9A96E", opacity: .12, fontSize: .6, fontWeight: "300", fontFamily: SERIF, letterSpacing: .6 }, "YOURS   TRULY"));

  return els;
}

// STYLE 11: OVERLAP V2 — luminous consensus circles
// ═══════════════════════════════════════════
function renderOverlap(data) {
  var name = data.personName || "";
  var headline = data.headline || "";
  var stars = (data.stars || []).slice(0, 6);
  var contributors = data.contributors || [];
  var els = [];
  var cx = 50, cy = 38;

  // Background starfield
  var seed = 53;
  for (var si = 0; si < 30; si++) {
    seed = (seed * 16807) % 2147483647;
    var sx = (seed % 10000) / 100;
    seed = (seed * 16807) % 2147483647;
    var sy = (seed % 6500) / 100;
    els.push(React.createElement("circle", { key: "os" + si, cx: sx, cy: sy, r: .06, fill: "#C9A96E", opacity: .05 }));
  }

  // Crown
  els.push(React.createElement("text", { key: "ocrown", x: 50, y: 6, textAnchor: "middle", fill: "#C9A96E", opacity: .22, fontSize: 2 }, "\u2726"));

  // Label
  els.push(React.createElement("text", { key: "olbl", x: 50, y: 11, textAnchor: "middle", fill: "#C9A96E", opacity: .20, fontSize: .7, letterSpacing: .5, fontWeight: "300", fontFamily: SERIF }, "WHERE   VOICES   OVERLAP"));

  // Contributor circles — large, luminous
  var circleColors = ["#C9A96E", "#D4B896", "#B8967A", "#E8D5B8", "#C48B9A", "#9B8AAA"];
  var offsets = [
    { dx: -13, dy: -10 }, { dx: 13, dy: -7 }, { dx: 15, dy: 9 },
    { dx: -10, dy: 13 }, { dx: -15, dy: 3 }, { dx: 10, dy: -13 }
  ];
  var numCircles = Math.min(contributors.length || 4, 6);
  if (numCircles < 3) numCircles = 4;

  for (var ci = 0; ci < numCircles; ci++) {
    var off = offsets[ci % offsets.length];
    var r = 20 + (ci % 3) * 3;
    // Multiple rings for luminosity
    els.push(React.createElement("circle", { key: "oc3" + ci, cx: cx + off.dx, cy: cy + off.dy, r: r + 1, fill: circleColors[ci], opacity: .02 }));
    els.push(React.createElement("circle", { key: "oc" + ci, cx: cx + off.dx, cy: cy + off.dy, r: r, fill: circleColors[ci], opacity: .06, stroke: circleColors[ci], strokeWidth: .1, strokeOpacity: .18 }));
    els.push(React.createElement("circle", { key: "oc2" + ci, cx: cx + off.dx, cy: cy + off.dy, r: r - .5, fill: "none", stroke: circleColors[ci], strokeWidth: .03, opacity: .10 }));
    // Contributor name — bigger, bolder
    var labelAngle = ((ci * 60) + 200) * Math.PI / 180;
    var lx = cx + off.dx + (r + 3.5) * Math.cos(labelAngle);
    var ly = cy + off.dy + (r + 3.5) * Math.sin(labelAngle);
    if (ci < contributors.length) {
      els.push(React.createElement("text", {
        key: "ocn" + ci, x: lx, y: ly, textAnchor: "middle",
        fill: circleColors[ci], opacity: .40, fontSize: 1.0,
        fontStyle: "italic", fontWeight: "300", fontFamily: SERIF
      }, contributors[ci]));
    }
  }

  // Center glow — dramatic, multi-layer
  els.push(React.createElement("circle", { key: "ocg1", cx: cx, cy: cy, r: 14, fill: "#C9A96E", opacity: .04 }));
  els.push(React.createElement("circle", { key: "ocg2", cx: cx, cy: cy, r: 8, fill: "#C9A96E", opacity: .06 }));
  els.push(React.createElement("circle", { key: "ocg3", cx: cx, cy: cy, r: 4, fill: "#D4B896", opacity: .08 }));
  els.push(React.createElement("circle", { key: "ocg4", cx: cx, cy: cy, r: 1.5, fill: "#F5F0EB", opacity: .12 }));

  // Quotes — sorted by resonance, highest at center
  var sortedStars = stars.slice().sort(function(a, b) { return (b.resonance || 3) - (a.resonance || 3); });
  var spots = [
    { x: cx, y: cy - 2, op: .85, sz: 2.0 },
    { x: cx, y: cy + 4, op: .75, sz: 1.9 },
    { x: cx + 14, y: cy - 8, op: .58, sz: 1.7 },
    { x: cx - 16, y: cy + 3, op: .52, sz: 1.6 },
    { x: cx + 10, y: cy + 13, op: .45, sz: 1.5 },
    { x: cx - 10, y: cy - 12, op: .40, sz: 1.5 },
  ];

  sortedStars.forEach(function(star, i) {
    if (i >= spots.length) return;
    var sp = spots[i];
    var quote = star.decode || star.label;
    var contrib = star.starContributors && star.starContributors[0] ? star.starContributors[0] : "";
    // Glowing dot
    els.push(React.createElement("circle", { key: "osg1" + i, cx: sp.x, cy: sp.y, r: i < 2 ? 1.2 : .8, fill: "#C9A96E", opacity: sp.op * .12 }));
    els.push(React.createElement("circle", { key: "osg2" + i, cx: sp.x, cy: sp.y, r: i < 2 ? .5 : .3, fill: "#F5F0EB", opacity: sp.op * .5 }));
    // Quote
    els.push(React.createElement("text", {
      key: "osq" + i, x: sp.x, y: sp.y + 3, textAnchor: "middle",
      fill: "white", opacity: sp.op, fontSize: sp.sz,
      fontStyle: "italic", fontWeight: "300", fontFamily: SERIF
    }, "\u201C" + quote + "\u201D"));
    if (contrib) {
      els.push(React.createElement("text", {
        key: "osa" + i, x: sp.x, y: sp.y + 5, textAnchor: "middle",
        fill: "#C9A96E", opacity: sp.op * .4, fontSize: .7,
        fontWeight: "300", fontFamily: SERIF
      }, "\u2014 " + contrib));
    }
  });

  // Name — grand
  els.push(React.createElement("text", { key: "oname", x: 50, y: 78, textAnchor: "middle", fill: "white", opacity: .98, fontSize: nameSz(name) * 1.3, fontWeight: "400", letterSpacing: .5, fontFamily: PLAY }, name));

  // Coachline
  els.push(React.createElement("g", { key: "ocoach", opacity: .28 },
    React.createElement("line", { x1: 18, y1: 81.5, x2: 48, y2: 81.5, stroke: "white", strokeWidth: .04 }),
    React.createElement("line", { x1: 18, y1: 82.1, x2: 48, y2: 82.1, stroke: "#C9A96E", strokeWidth: .02 }),
    React.createElement("rect", { x: 49.5, y: 81.2, width: 1, height: 1, fill: "#C9A96E", opacity: .6, transform: "rotate(45 50 81.7)" }),
    React.createElement("line", { x1: 52, y1: 81.5, x2: 82, y2: 81.5, stroke: "white", strokeWidth: .04 }),
    React.createElement("line", { x1: 52, y1: 82.1, x2: 82, y2: 82.1, stroke: "#C9A96E", strokeWidth: .02 })
  ));

  els.push(React.createElement("text", { key: "otag", x: 50, y: 87, textAnchor: "middle", fill: "#C9A96E", opacity: .55, fontSize: tagSz(headline) * 1.2, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, headline));
  els.push(React.createElement("text", { key: "oft", x: 50, y: 97, textAnchor: "middle", fill: "#C9A96E", opacity: .12, fontSize: .6, fontWeight: "300", fontFamily: SERIF, letterSpacing: .6 }, "YOURS   TRULY"));
  return els;
}

// STYLE 12: PRISM — light splitting into qualities
// ═══════════════════════════════════════════
function renderPrism(data) {
  var name = data.personName || "";
  var headline = data.headline || "";
  var stars = (data.stars || []).slice(0, 6);
  var contributors = data.contributors || [];
  var els = [];

  // Incoming white beam
  els.push(React.createElement("line", { key: "pbeam", x1: 5, y1: 42, x2: 38, y2: 42, stroke: "#F5F0EB", strokeWidth: .15, opacity: .35 }));
  els.push(React.createElement("line", { key: "pbeam2", x1: 5, y1: 42, x2: 38, y2: 42, stroke: "#F5F0EB", strokeWidth: .8, opacity: .04 }));

  // Prism triangle
  els.push(React.createElement("polygon", {
    key: "pprism", points: "38,30 38,54 52,42",
    fill: "none", stroke: "#C9A96E", strokeWidth: .2, opacity: .45
  }));
  els.push(React.createElement("polygon", {
    key: "pprismf", points: "38,30 38,54 52,42",
    fill: "#C9A96E", opacity: .03
  }));

  // Name inside prism
  els.push(React.createElement("text", {
    key: "ppname", x: 42, y: 43.5, textAnchor: "middle",
    fill: "#F5F0EB", opacity: .70, fontSize: 1.8,
    fontWeight: "400", fontFamily: PLAY, letterSpacing: .15
  }, name));

  // 6 rays exiting prism at different angles
  var rayColors = ["#F5F0EB", "#E8D5B8", "#D4B896", "#C9A96E", "#B8967A", "#9B8AAA"];
  var rayAngles = [-18, -10, -3, 4, 12, 20];

  stars.forEach(function(star, i) {
    var angle = rayAngles[i] * Math.PI / 180;
    var startX = 52, startY = 42;
    var endX = 95, endY = 42 + rayAngles[i] * 1.8;
    var quote = star.decode || star.label;
    var contrib = star.starContributors && star.starContributors[0] ? star.starContributors[0] : (contributors[i % contributors.length] || "");
    var op = i === 0 ? .65 : i < 3 ? .55 : .45;

    // Ray line
    els.push(React.createElement("line", {
      key: "pray" + i, x1: startX, y1: startY, x2: endX, y2: endY,
      stroke: rayColors[i], strokeWidth: .12, opacity: op * .7
    }));
    // Glow
    els.push(React.createElement("line", {
      key: "prayg" + i, x1: startX, y1: startY, x2: endX, y2: endY,
      stroke: rayColors[i], strokeWidth: .6, opacity: .03
    }));

    // Star dot at end of ray
    els.push(React.createElement("circle", { key: "psd" + i, cx: endX - 2, cy: endY, r: .25, fill: rayColors[i], opacity: op }));

    // Quote along ray — positioned at midpoint
    var midX = 68;
    var midY = 42 + rayAngles[i] * 1.1;
    els.push(React.createElement("text", {
      key: "prq" + i, x: midX, y: midY - .8, textAnchor: "start",
      fill: "white", opacity: op, fontSize: 1.2,
      fontStyle: "italic", fontWeight: "300", fontFamily: SERIF
    }, "\u201C" + quote + "\u201D"));
    els.push(React.createElement("text", {
      key: "pra" + i, x: midX, y: midY + 1, textAnchor: "start",
      fill: rayColors[i], opacity: op * .5, fontSize: .6,
      fontWeight: "300", fontFamily: SERIF, letterSpacing: .15
    }, "\u2014 " + contrib));
  });

  // Subtitle
  els.push(React.createElement("text", { key: "psub", x: 50, y: 10, textAnchor: "middle", fill: "#C9A96E", opacity: .15, fontSize: .6, letterSpacing: .4, fontWeight: "300", fontFamily: SERIF }, "ONE PERSON \u00B7 EVERY ANGLE"));

  // Bottom name + tagline
  els.push(React.createElement("text", { key: "pbname", x: 50, y: 78, textAnchor: "middle", fill: "white", opacity: .96, fontSize: nameSz(name) * 1.15, fontWeight: "400", letterSpacing: .35, fontFamily: PLAY }, name));
  els.push(React.createElement("g", { key: "pcoach", opacity: .22 },
    React.createElement("line", { x1: 28, y1: 81, x2: 48.5, y2: 81, stroke: "white", strokeWidth: .03 }),
    React.createElement("line", { x1: 28, y1: 81.5, x2: 48.5, y2: 81.5, stroke: "#C9A96E", strokeWidth: .015 }),
    React.createElement("rect", { x: 49.55, y: 80.75, width: .8, height: .8, fill: "#C9A96E", opacity: .5, transform: "rotate(45 49.95 81.15)" }),
    React.createElement("line", { x1: 51.4, y1: 81, x2: 72, y2: 81, stroke: "white", strokeWidth: .03 }),
    React.createElement("line", { x1: 51.4, y1: 81.5, x2: 72, y2: 81.5, stroke: "#C9A96E", strokeWidth: .015 })
  ));
  els.push(React.createElement("text", { key: "ptag", x: 50, y: 86, textAnchor: "middle", fill: "#C9A96E", opacity: .50, fontSize: tagSz(headline), fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, headline));
  els.push(React.createElement("text", { key: "pft", x: 50, y: 97, textAnchor: "middle", fill: "#C9A96E", opacity: .10, fontSize: .55, fontWeight: "300", fontFamily: SERIF, letterSpacing: .5 }, "YOURS   TRULY"));
  return els;
}

// ═══════════════════════════════════════════
// STYLE 13: DECODE — encrypted text resolving into clarity
// ═══════════════════════════════════════════
function renderDecode(data) {
  var name = data.personName || "";
  var headline = data.headline || "";
  var stars = (data.stars || []).slice(0, 6);
  var contributors = data.contributors || [];
  var els = [];

  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$%&*+=<>{}[]|~";
  var dseed = 73;
  function drand() { dseed = (dseed * 16807) % 2147483647; return (dseed - 1) / 2147483646; }
  function scramble(text, pct) {
    var result = "";
    for (var i = 0; i < text.length; i++) {
      if (text[i] === " ") { result += " "; }
      else if (drand() < pct) { result += chars[Math.floor(drand() * chars.length)]; }
      else { result += text[i]; }
    }
    return result;
  }

  // Key label
  els.push(React.createElement("text", { key: "dkey", x: 50, y: 8, textAnchor: "middle", fill: "#C9A96E", opacity: .15, fontSize: .55, letterSpacing: .5, fontWeight: "300", fontFamily: SERIF }, "DECRYPTION KEY: " + name.toUpperCase()));

  // Processing bar
  els.push(React.createElement("rect", { key: "dbar", x: 15, y: 10, width: 70, height: .15, fill: "#C9A96E", opacity: .08 }));
  els.push(React.createElement("rect", { key: "dbarf", x: 15, y: 10, width: 52, height: .15, fill: "#C9A96E", opacity: .25 }));
  els.push(React.createElement("text", { key: "dpct", x: 68, y: 10.8, textAnchor: "start", fill: "#C9A96E", opacity: .20, fontSize: .5, fontWeight: "300", fontFamily: SERIF }, "74%"));

  // Lines of text — from encrypted to decoded
  var allQuotes = stars.map(function(s) { return s.decode || s.label; });
  var contribs = stars.map(function(s, i) { return s.starContributors && s.starContributors[0] ? s.starContributors[0] : (contributors[i % contributors.length] || ""); });

  // Phase 1: Heavily encrypted (top section)
  var y = 17;
  for (var e = 0; e < 4; e++) {
    var srcText = allQuotes[e % allQuotes.length] + "  //  " + allQuotes[(e + 2) % allQuotes.length];
    var encrypted = scramble(srcText, 0.85);
    els.push(React.createElement("text", {
      key: "de" + e, x: 50, y: y + e * 3.5, textAnchor: "middle",
      fill: "#C9A96E", opacity: .12, fontSize: 1.1,
      fontWeight: "300", fontFamily: SERIF, letterSpacing: .08
    }, encrypted));
  }

  // Phase 2: Partially decoded (middle section)
  y = 35;
  for (var p = 0; p < 3; p++) {
    var partialText = allQuotes[(p + 1) % allQuotes.length];
    var partial = scramble(partialText, 0.4);
    var pop = .18 + p * .05;
    els.push(React.createElement("text", {
      key: "dp" + p, x: 50, y: y + p * 4.5, textAnchor: "middle",
      fill: "#D4B896", opacity: pop, fontSize: 1.3,
      fontStyle: "italic", fontWeight: "300", fontFamily: SERIF
    }, partial));
  }

  // Divider — the "crack" point
  els.push(React.createElement("line", { key: "dcrack", x1: 20, y1: 52, x2: 80, y2: 52, stroke: "#C9A96E", strokeWidth: .04, opacity: .20, strokeDasharray: ".3 .3" }));
  els.push(React.createElement("text", { key: "dcrackt", x: 50, y: 54, textAnchor: "middle", fill: "#C9A96E", opacity: .18, fontSize: .5, letterSpacing: .3, fontWeight: "300", fontFamily: SERIF }, "\u2726  DECODED  \u2726"));

  // Phase 3: Fully decoded quotes (bottom section)
  y = 59;
  var maxDecoded = Math.min(allQuotes.length, 4);
  for (var d = 0; d < maxDecoded; d++) {
    var qop = d === 0 ? .70 : d === 1 ? .60 : d === 2 ? .50 : .42;
    els.push(React.createElement("text", {
      key: "dd" + d, x: 50, y: y + d * 5, textAnchor: "middle",
      fill: "white", opacity: qop, fontSize: 1.5,
      fontStyle: "italic", fontWeight: "300", fontFamily: SERIF
    }, "\u201C" + allQuotes[d] + "\u201D"));
    els.push(React.createElement("text", {
      key: "dda" + d, x: 50, y: y + d * 5 + 2, textAnchor: "middle",
      fill: "#C9A96E", opacity: qop * .45, fontSize: .7,
      fontWeight: "300", fontFamily: SERIF, letterSpacing: .15
    }, "\u2014 " + contribs[d]));
  }

  // Name
  els.push(React.createElement("text", { key: "ddname", x: 50, y: 86, textAnchor: "middle", fill: "white", opacity: .96, fontSize: nameSz(name) * 1.15, fontWeight: "400", letterSpacing: .35, fontFamily: PLAY }, name));
  els.push(React.createElement("text", { key: "ddtag", x: 50, y: 91, textAnchor: "middle", fill: "#C9A96E", opacity: .45, fontSize: tagSz(headline), fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, headline));
  els.push(React.createElement("text", { key: "ddft", x: 50, y: 97, textAnchor: "middle", fill: "#C9A96E", opacity: .10, fontSize: .55, fontWeight: "300", fontFamily: SERIF, letterSpacing: .5 }, "YOURS   TRULY"));
  return els;
}

// ═══════════════════════════════════════════
// STYLE 14: BOTANICAL — scientific plant illustration
// ═══════════════════════════════════════════
function renderBotanical(data) {
  var name = data.personName || "";
  var headline = data.headline || "";
  var stars = (data.stars || []).slice(0, 6);
  var contributors = data.contributors || [];
  var els = [];

  // Latin classification header
  var genus = name.split(" ")[0];
  var species = name.split(" ").slice(1).join(" ") || "magnificus";
  var latin = genus.substring(0, 1).toUpperCase() + genus.substring(1).toLowerCase() + " " + species.toLowerCase().replace(/\s+/g, "");
  els.push(React.createElement("text", { key: "blatin", x: 50, y: 8, textAnchor: "middle", fill: "#C9A96E", opacity: .30, fontSize: 1.1, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF, letterSpacing: .1 }, latin));
  els.push(React.createElement("line", { key: "blatinl", x1: 25, y1: 10, x2: 75, y2: 10, stroke: "#C9A96E", strokeWidth: .02, opacity: .12 }));
  els.push(React.createElement("text", { key: "bfam", x: 50, y: 13, textAnchor: "middle", fill: "#C9A96E", opacity: .18, fontSize: .6, fontWeight: "300", fontFamily: SERIF, letterSpacing: .3 }, "FAMILY: EXTRAORDINARIUS  \u00B7  ORDER: YOURS TRULY"));

  // Main stem
  var stemTop = 20, stemBot = 72;
  els.push(React.createElement("line", { key: "bstem", x1: 50, y1: stemTop, x2: 50, y2: stemBot, stroke: "#C9A96E", strokeWidth: .08, opacity: .30 }));

  // Small nodes along stem
  [28, 36, 44, 52, 60].forEach(function(y, i) {
    els.push(React.createElement("circle", { key: "bnode" + i, cx: 50, cy: y, r: .3, fill: "#C9A96E", opacity: .25 }));
  });

  // Branches with quotes — alternating left and right
  var branches = [
    { y: 28, side: "right", curve: "M 50,28 C 55,26 60,24 68,22" },
    { y: 36, side: "left", curve: "M 50,36 C 45,34 40,32 32,30" },
    { y: 44, side: "right", curve: "M 50,44 C 55,42 62,40 70,39" },
    { y: 52, side: "left", curve: "M 50,52 C 45,50 38,49 30,48" },
    { y: 60, side: "right", curve: "M 50,60 C 55,58 60,57 67,56" },
    { y: 60, side: "left", curve: "M 50,60 C 45,59 40,58 33,58" },
  ];

  stars.forEach(function(star, i) {
    if (i >= branches.length) return;
    var b = branches[i];
    var quote = star.decode || star.label;
    var contrib = star.starContributors && star.starContributors[0] ? star.starContributors[0] : (contributors[i % contributors.length] || "");
    var isRight = b.side === "right";
    var op = i < 2 ? .60 : i < 4 ? .50 : .40;

    // Branch curve
    els.push(React.createElement("path", { key: "bbr" + i, d: b.curve, fill: "none", stroke: "#C9A96E", strokeWidth: .06, opacity: op * .5 }));

    // Leaf shape at end of branch
    var leafX = isRight ? 70 : 30;
    var leafY = b.y - (i < 4 ? 6 + i * 2 : 0) - (i >= 4 ? -2 : 0);
    if (i === 0) { leafX = 68; leafY = 22; }
    if (i === 1) { leafX = 32; leafY = 30; }
    if (i === 2) { leafX = 70; leafY = 39; }
    if (i === 3) { leafX = 30; leafY = 48; }
    if (i === 4) { leafX = 67; leafY = 56; }
    if (i === 5) { leafX = 33; leafY = 58; }

    // Leaf outline
    var leafW = 3, leafH = 1.5;
    if (isRight) {
      els.push(React.createElement("path", {
        key: "bleaf" + i,
        d: "M " + leafX + "," + leafY + " Q " + (leafX + leafW) + "," + (leafY - leafH) + " " + (leafX + leafW * 2) + "," + leafY + " Q " + (leafX + leafW) + "," + (leafY + leafH) + " " + leafX + "," + leafY,
        fill: "#C9A96E", opacity: .06, stroke: "#C9A96E", strokeWidth: .04, strokeOpacity: op * .4
      }));
    } else {
      els.push(React.createElement("path", {
        key: "bleaf" + i,
        d: "M " + leafX + "," + leafY + " Q " + (leafX - leafW) + "," + (leafY - leafH) + " " + (leafX - leafW * 2) + "," + leafY + " Q " + (leafX - leafW) + "," + (leafY + leafH) + " " + leafX + "," + leafY,
        fill: "#C9A96E", opacity: .06, stroke: "#C9A96E", strokeWidth: .04, strokeOpacity: op * .4
      }));
    }

    // Small bud/flower at leaf tip
    var budX = isRight ? leafX + leafW * 2 + .5 : leafX - leafW * 2 - .5;
    els.push(React.createElement("circle", { key: "bbud" + i, cx: budX, cy: leafY, r: .4, fill: "#C9A96E", opacity: op * .4 }));
    els.push(React.createElement("circle", { key: "bbud2" + i, cx: budX, cy: leafY, r: .2, fill: "#F5F0EB", opacity: op * .5 }));

    // Quote text — positioned near the leaf
    var qx = isRight ? leafX + 1 : leafX - 1;
    var qAnchor = isRight ? "start" : "end";
    var qy = leafY + 3;

    els.push(React.createElement("text", {
      key: "bq" + i, x: qx, y: qy, textAnchor: qAnchor,
      fill: "white", opacity: op, fontSize: 1.2,
      fontStyle: "italic", fontWeight: "300", fontFamily: SERIF
    }, "\u201C" + quote + "\u201D"));
    els.push(React.createElement("text", {
      key: "ba" + i, x: qx, y: qy + 1.8, textAnchor: qAnchor,
      fill: "#C9A96E", opacity: op * .45, fontSize: .6,
      fontWeight: "300", fontFamily: SERIF, letterSpacing: .12
    }, "\u2014 " + contrib));
  });

  // Flower at top of stem
  els.push(React.createElement("circle", { key: "bflower1", cx: 50, cy: stemTop, r: 1.5, fill: "#C9A96E", opacity: .06 }));
  els.push(React.createElement("circle", { key: "bflower2", cx: 50, cy: stemTop, r: .8, fill: "#C9A96E", opacity: .12 }));
  els.push(React.createElement("circle", { key: "bflower3", cx: 50, cy: stemTop, r: .35, fill: "#F5F0EB", opacity: .50 }));
  // Petals
  [0, 60, 120, 180, 240, 300].forEach(function(angle, pi) {
    var rad = angle * Math.PI / 180;
    var px = 50 + 2.2 * Math.cos(rad);
    var py = stemTop + 2.2 * Math.sin(rad);
    els.push(React.createElement("ellipse", {
      key: "bpetal" + pi, cx: px, cy: py, rx: 1.2, ry: .5,
      fill: "#C9A96E", opacity: .08,
      transform: "rotate(" + angle + " " + px + " " + py + ")"
    }));
  });

  // Roots at bottom
  var rootPaths = [
    "M 50,72 C 48,76 44,80 40,84",
    "M 50,72 C 50,76 50,80 50,86",
    "M 50,72 C 52,76 56,80 60,84",
    "M 50,72 C 47,74 42,76 38,78",
    "M 50,72 C 53,74 58,76 62,78",
  ];
  rootPaths.forEach(function(d, ri) {
    els.push(React.createElement("path", { key: "broot" + ri, d: d, fill: "none", stroke: "#C9A96E", strokeWidth: .05, opacity: .18 }));
  });

  // Root labels (trait labels at root tips)
  var rootLabels = stars.slice(0, 3).map(function(s) { return s.label; });
  [{ x: 38, y: 86 }, { x: 50, y: 88 }, { x: 62, y: 86 }].forEach(function(pos, ri) {
    if (ri < rootLabels.length) {
      els.push(React.createElement("text", {
        key: "brl" + ri, x: pos.x, y: pos.y, textAnchor: "middle",
        fill: "#C9A96E", opacity: .25, fontSize: .7,
        fontStyle: "italic", fontWeight: "300", fontFamily: SERIF
      }, rootLabels[ri]));
    }
  });

  // Name on stem
  els.push(React.createElement("text", { key: "bname", x: 53, y: 69, textAnchor: "start", fill: "white", opacity: .80, fontSize: nameSz(name), fontWeight: "400", letterSpacing: .2, fontFamily: PLAY, transform: "rotate(-90 53 69)" }, name));

  // Tagline at very bottom
  els.push(React.createElement("text", { key: "btag", x: 50, y: 93, textAnchor: "middle", fill: "#C9A96E", opacity: .40, fontSize: tagSz(headline), fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, headline));
  els.push(React.createElement("text", { key: "bft", x: 50, y: 97, textAnchor: "middle", fill: "#C9A96E", opacity: .10, fontSize: .55, fontWeight: "300", fontFamily: SERIF, letterSpacing: .5 }, "YOURS   TRULY"));

  return els;
}

// ═══════════════════════════════════════════
// ═══════════════════════════════════════════
// CONSTELLATION LAYOUT ENGINE — dynamic, any star count
// Quotes radiate OUTWARD from center so they never cross constellation lines
// ═══════════════════════════════════════════
// ── LAYOUT PRESETS ──
// ═══════════════════════════════════════════
// SHAPE LAYOUTS — stars distributed evenly along an outline.
// The silhouette carries the recognition, not the point count,
// so every contributor count works. No filler stars, no holes.
// ═══════════════════════════════════════════
var SHAPE_OUTLINES = {
  // Hand-authored silhouette, clockwise from the head. y is screen-down.
  butterfly: function() {
    var half = [
      [0.00, -0.30], [0.18, -0.62], [0.46, -0.98], [0.78, -0.92],
      [0.95, -0.62], [0.90, -0.28], [0.62, -0.12], [0.72, 0.10],
      [0.82, 0.44], [0.66, 0.76], [0.38, 0.86], [0.16, 0.62],
      [0.07, 0.28], [0.00, 0.46],
    ];
    var pts = [];
    for (var i = 0; i < half.length; i++) pts.push({ x: half[i][0], y: half[i][1] });
    for (var j = half.length - 2; j >= 1; j--) pts.push({ x: -half[j][0], y: half[j][1] });
    return pts;
  },
  heart: function() {
    var pts = [];
    for (var i = 0; i < 240; i++) {
      var t = (i / 240) * Math.PI * 2;
      pts.push({
        x: 16 * Math.pow(Math.sin(t), 3),
        y: -(13 * Math.cos(t) - 5 * Math.cos(2 * t) - 2 * Math.cos(3 * t) - Math.cos(4 * t)),
      });
    }
    return pts;
  },
  // Bernoulli lemniscate — two loops joined. Reads as "the two of you".
  infinity: function() {
    var pts = [];
    for (var i = 0; i < 240; i++) {
      var t = (i / 240) * Math.PI * 2;
      var d = 1 + Math.sin(t) * Math.sin(t);
      pts.push({ x: Math.cos(t) / d, y: (Math.sin(t) * Math.cos(t)) / d });
    }
    return pts;
  },
};

// Walk a closed outline and drop n points at equal arc-length intervals.
function resampleClosed(dense, n) {
  var segs = [], total = 0, i;
  for (i = 0; i < dense.length; i++) {
    var a = dense[i], b = dense[(i + 1) % dense.length];
    var d = Math.sqrt((b.x - a.x) * (b.x - a.x) + (b.y - a.y) * (b.y - a.y));
    segs.push({ a: a, b: b, d: d, start: total });
    total += d;
  }
  if (!total) return dense.slice(0, n);
  var out = [];
  for (var k = 0; k < n; k++) {
    var target = (k / n) * total;
    for (var j = 0; j < segs.length; j++) {
      var sg = segs[j];
      if (target <= sg.start + sg.d || j === segs.length - 1) {
        var t = sg.d ? (target - sg.start) / sg.d : 0;
        out.push({ x: sg.a.x + (sg.b.x - sg.a.x) * t, y: sg.a.y + (sg.b.y - sg.a.y) * t });
        break;
      }
    }
  }
  return out;
}

// Below this many stars a silhouette stops reading as anything.
var SHAPE_MIN_STARS = 6;

function shapeLayout(shapeId) {
  return function(n, cx, cy, r) {
    if (n < SHAPE_MIN_STARS) return LAYOUT_PRESETS.scattered(n, cx, cy, r);
    var dense = SHAPE_OUTLINES[shapeId]();
    var minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
    for (var i = 0; i < dense.length; i++) {
      if (dense[i].x < minX) minX = dense[i].x;
      if (dense[i].x > maxX) maxX = dense[i].x;
      if (dense[i].y < minY) minY = dense[i].y;
      if (dense[i].y > maxY) maxY = dense[i].y;
    }
    var w = (maxX - minX) || 1, h = (maxY - minY) || 1;
    var scale = (r * 2) / Math.max(w, h);
    var ox = (minX + maxX) / 2, oy = (minY + maxY) / 2;
    return resampleClosed(dense, n).map(function(pt) {
      return { x: cx + (pt.x - ox) * scale, y: cy + (pt.y - oy) * scale };
    });
  };
}

var LAYOUT_PRESETS = {
  scattered: function(n, cx, cy, r) {
    // Original organic layout — resonance-based radii
    var step = 360 / n, start = -70;
    return Array.from({ length: n }, function(_, i) {
      var angle = start + i * step;
      var rad = angle * Math.PI / 180;
      var ri = r - (i % 3) * (r * 0.07);
      if (ri < r * 0.45) ri = r * 0.45;
      return { x: cx + ri * Math.sin(rad), y: cy - ri * Math.cos(rad) };
    });
  },
  circle: function(n, cx, cy, r) {
    var step = 360 / n, start = -90;
    return Array.from({ length: n }, function(_, i) {
      var angle = start + i * step;
      var rad = angle * Math.PI / 180;
      return { x: cx + r * Math.sin(rad), y: cy - r * Math.cos(rad) };
    });
  },
  diamond: function(n, cx, cy, r) {
    // Diamond shape — top, sides, bottom
    var positions = [];
    if (n <= 2) return LAYOUT_PRESETS.circle(n, cx, cy, r);
    positions.push({ x: cx, y: cy - r }); // top
    var sides = n - 2;
    var leftCount = Math.ceil(sides / 2);
    var rightCount = sides - leftCount;
    for (var li = 0; li < leftCount; li++) {
      var t = (li + 1) / (leftCount + 1);
      positions.push({ x: cx - r * 0.8 * (1 - Math.abs(t * 2 - 1)), y: cy - r + t * 2 * r });
    }
    for (var ri = 0; ri < rightCount; ri++) {
      var t2 = (ri + 1) / (rightCount + 1);
      positions.push({ x: cx + r * 0.8 * (1 - Math.abs(t2 * 2 - 1)), y: cy - r + t2 * 2 * r });
    }
    positions.push({ x: cx, y: cy + r }); // bottom
    return positions.slice(0, n);
  },
  arc: function(n, cx, cy, r) {
    // Graceful arc from left to right
    var startAngle = -140, endAngle = -40;
    var step = n > 1 ? (endAngle - startAngle) / (n - 1) : 0;
    return Array.from({ length: n }, function(_, i) {
      var angle = startAngle + i * step;
      var rad = angle * Math.PI / 180;
      return { x: cx + r * 1.2 * Math.cos(rad), y: cy - r * 0.6 * Math.sin(rad) - r * 0.2 };
    });
  },
  butterfly: shapeLayout("butterfly"),
  heart: shapeLayout("heart"),
  infinity: shapeLayout("infinity"),
  linear: function(n, cx, cy, r) {
    // Vertical cascade with slight wave
    var totalH = r * 1.8;
    var startY = cy - totalH / 2;
    var step = n > 1 ? totalH / (n - 1) : 0;
    return Array.from({ length: n }, function(_, i) {
      var wave = Math.sin(i * 1.2) * r * 0.25;
      return { x: cx + wave, y: startY + i * step };
    });
  },
};

// Trim both ends of a connecting line so it stops short of the stars it joins
function trimLine(x1, y1, x2, y2, gap) {
  var dx = x2 - x1, dy = y2 - y1;
  var len = Math.sqrt(dx * dx + dy * dy);
  if (len <= gap * 2.2) return null;
  var ux = dx / len, uy = dy / len;
  return { x1: x1 + ux * gap, y1: y1 + uy * gap, x2: x2 - ux * gap, y2: y2 - uy * gap };
}

function layoutConstellation(stars, cx, cy, baseRadius, preset, customPositions, customQuotePositions) {
  var numStars = stars.length;
  if (numStars === 0) return [];

  // Get base positions from preset
  var presetFn = LAYOUT_PRESETS[preset] || LAYOUT_PRESETS.scattered;
  var basePositions = presetFn(numStars, cx, cy, baseRadius);

  var positioned = [];
  stars.forEach(function(star, i) {
    var bp = basePositions[i] || { x: cx, y: cy };
    // Apply custom position override if exists
    var x = bp.x, y = bp.y;
    if (customPositions && customPositions[i]) {
      x = customPositions[i].x;
      y = customPositions[i].y;
    }

    // Push the quote RADIALLY outward from the centre, not just sideways.
    // A flat left/right offset sent the top and bottom stars' text straight
    // across the shape, where it crossed the constellation lines.
    var dx = x - cx, dy = y - cy;
    var dlen = Math.sqrt(dx * dx + dy * dy) || 1;
    var ux = dx / dlen, uy = dy / dlen;
    var isRight = x >= cx;
    var qx = x + ux * 9 + (isRight ? 1.5 : -1.5);
    var qy = y + uy * 6.5 - 1;
    var anchor = isRight ? "start" : "end";

    // Apply custom quote position if exists
    if (customQuotePositions && customQuotePositions[i]) {
      qx = customQuotePositions[i].x;
      qy = customQuotePositions[i].y;
      anchor = qx >= x ? "start" : "end";
    }

    positioned.push({ star: star, x: x, y: y, qx: qx, qy: qy, anchor: anchor, angle: 0, index: i });
  });

  return positioned;
}

// ═══════════════════════════════════════════
// STYLE V2: STAR MAP II — real gaussian blur glow
// ═══════════════════════════════════════════
function renderStarMap2(data) {
  var name = data.personName || "";
  var headline = data.headline || "";
  var stars = data.stars || [];
  var contributors = data.contributors || [];
  var els = [];
  var cx = 50, cy = 42, radius = 36;

  // Metallic gold gradient — premium sheen
  els.push(React.createElement("defs", { key: "sm2defs" },
    React.createElement("linearGradient", { id: "goldSheen", x1: "0%", y1: "0%", x2: "100%", y2: "100%" },
      React.createElement("stop", { offset: "0%", stopColor: "#BF953F" }),
      React.createElement("stop", { offset: "22%", stopColor: "#FCF6BA" }),
      React.createElement("stop", { offset: "45%", stopColor: "#B38728" }),
      React.createElement("stop", { offset: "67%", stopColor: "#FBF5B7" }),
      React.createElement("stop", { offset: "100%", stopColor: "#AA771C" })
    )
  ));

  // Clean night sky — no nebula, let the constellation breathe
  els.push(React.createElement("style", { key: "sm2style" }, "@keyframes twinkle { 0%,100% { opacity: 0.2; } 50% { opacity: 0.8; } }"));

  // Background stars — sparse, dim, just enough to say "night sky"
  var seed = 99;
  for (var si = 0; si < 80; si++) {
    seed = (seed * 16807) % 2147483647;
    var sx = (seed % 10000) / 100;
    seed = (seed * 16807) % 2147483647;
    var sy = (seed % 10000) / 100;
    seed = (seed * 16807) % 2147483647;

    var sr2 = 0.04 + (seed % 100) / 1200;
    var sop = 0.06 + (seed % 60) / 600;

    els.push(React.createElement("circle", { key: "sm2s" + si, cx: sx, cy: sy, r: sr2, fill: "url(#goldSheen)", opacity: sop }));

    if (si % 20 === 0) {
      els.push(React.createElement("circle", { key: "sm2sb" + si, cx: sx, cy: sy, r: sr2 * 2.5, fill: "url(#goldSheen)", opacity: sop * 1.5 }));
    }
  }

  // No circle border — constellation floats in space

  // Dynamic layout — compact constellation, quotes in outer ring
  var preset = data.layoutPreset || "scattered";
  var customPositions = data.customPositions || null;
  var positioned = layoutConstellation(stars, cx, cy, 24, preset, customPositions, data.customQuotePositions || null);

  // Constellation lines
  for (var li = 0; li < positioned.length; li++) {
    var next = (li + 1) % positioned.length;
    var smSeg = trimLine(positioned[li].x, positioned[li].y, positioned[next].x, positioned[next].y, 3.2);
    if (smSeg) els.push(React.createElement("line", {
      key: "sm2l" + li,
      x1: smSeg.x1, y1: smSeg.y1, x2: smSeg.x2, y2: smSeg.y2,
      stroke: "url(#goldSheen)", strokeWidth: .12, opacity: .40
    }));
  }

  // Stars + quotes — compact center, quotes in spacious outer ring
  var numStars = positioned.length;
  let qFontSize = numStars <= 4 ? 2.0 : numStars <= 6 ? 1.8 : 1.5;
  var qLineH = numStars <= 4 ? 2.4 : numStars <= 6 ? 2.2 : 1.8;
  var maxChars = numStars <= 4 ? 28 : numStars <= 6 ? 24 : 20;

  positioned.forEach(function(sp, i) {
    var quote = sp.star.decode || sp.star.label;
    var contrib = sp.star.starContributors && sp.star.starContributors[0] ? sp.star.starContributors[0] : (contributors[i % contributors.length] || "");
    var op = numStars <= 4 ? .85 : (i === 0 ? .85 : i < 3 ? .75 : .60);

    els.push(React.createElement("circle", { key: "sm2g3" + i, cx: sp.x, cy: sp.y, r: .55, fill: "url(#goldSheen)", opacity: .95 }));
    els.push(React.createElement("circle", { key: "sm2g1" + i, cx: sp.x, cy: sp.y, r: 1.4, fill: "url(#goldSheen)", opacity: .12 }));

    // Fit to the space between star and edge, same as Starlight
    var SM_EDGE = 5;
    var smAvail = sp.anchor === "start" ? (100 - SM_EDGE - sp.qx) : (sp.qx - SM_EDGE);
    smAvail = Math.max(14, smAvail);
    var smFit = custFit(quote, smAvail, qFontSize, 0.46, 0.3, 4);
    var qLines = smFit.lines;
    var smSize = smFit.size;
    var smLineH = smSize * 1.2;

    qLines.forEach(function(line, li) {
      els.push(React.createElement("text", {
        key: "sm2q" + i + "_" + li, x: sp.qx, y: sp.qy + li * smLineH,
        textAnchor: sp.anchor, fill: "url(#goldSheen)", opacity: op,
        fontSize: smSize, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF, letterSpacing: .3,
        stroke: "#0A0A0A", strokeWidth: 0.4, paintOrder: "stroke"
      }, (li === 0 ? "\u201C" : "") + line + (li === qLines.length - 1 ? "\u201D" : "")));
    });
    // Attribution — always bottom-left of quote block
    var attrX = sp.anchor === "end" ? sp.qx - smFit.width : sp.qx;
    els.push(React.createElement("text", {
      key: "sm2a" + i, x: attrX, y: sp.qy + qLines.length * smLineH + 1.5,
      textAnchor: "start", fill: "url(#goldSheen)", opacity: op * .85,
      fontSize: numStars <= 6 ? 1.1 : .9, fontWeight: "300", fontFamily: SERIF,
      stroke: "#0A0A0A", strokeWidth: 0.5, paintOrder: "stroke"
    }, "\u2014 " + contrib));
  });

  // Crown
  els.push(React.createElement("text", { key: "sm2crown", x: 50, y: 5, textAnchor: "middle", fill: "url(#goldSheen)", opacity: .25, fontSize: 2 }, "\u2726"));

  // Name — metallic gradient
  els.push(React.createElement("text", { key: "sm2name", x: 50, y: 85, textAnchor: "middle", fill: "url(#goldSheen)", opacity: .98, fontSize: nameSz(name) * 1.3, fontWeight: "400", letterSpacing: .5, fontFamily: PLAY, stroke: "#0A0A0A", strokeWidth: .4, paintOrder: "stroke" }, name));

  // F2: Adjective subtitle — top adjective(s) under name
  var adjFreqSM = data.adjectiveFreq || [];
  if (adjFreqSM.length > 0) {
    var topAdjs = adjFreqSM.slice(0, 3).map(function(a) { return a.word; }).join(", ");
    els.push(React.createElement("text", { key: "sm2adj", x: 50, y: 89, textAnchor: "middle", fill: "url(#goldSheen)", opacity: .50, fontSize: 1.3, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF, letterSpacing: .2, stroke: "#0A0A0A", strokeWidth: .3, paintOrder: "stroke" }, topAdjs));
  }

  els.push(React.createElement("g", { key: "sm2coach", opacity: .32 },
    React.createElement("line", { x1: 18, y1: 91.5, x2: 48, y2: 91.5, stroke: "url(#goldSheen)", strokeWidth: .04 }),
    React.createElement("line", { x1: 52, y1: 91.5, x2: 82, y2: 91.5, stroke: "url(#goldSheen)", strokeWidth: .04 }),
    React.createElement("rect", { x: 49.5, y: 91.2, width: 1, height: 1, fill: "url(#goldSheen)", opacity: .6, transform: "rotate(45 50 91.7)" })
  ));
  els.push(React.createElement("text", { key: "sm2tag", x: 50, y: 95, textAnchor: "middle", fill: "url(#goldSheen)", opacity: .60, fontSize: tagSz(headline) * 1.2, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, headline));
  var sm2Cred = creditLines(data.contributors, { base: .7 });
  sm2Cred.lines.forEach(function(ln, i) {
    els.push(React.createElement("text", { key: "sm2con" + i, x: 50, y: 97.5 + (i - (sm2Cred.lines.length - 1)) * sm2Cred.size * 1.35, textAnchor: "middle", fill: "url(#goldSheen)", opacity: .22, fontSize: sm2Cred.size, fontWeight: "300", fontFamily: SERIF }, ln));
  });
  return els;
}

// ═══════════════════════════════════════════
// STYLE: STARLIGHT — Rolls Royce Spirit of Ecstasy
// Galactic background, platinum/silver constellation
// ═══════════════════════════════════════════
function renderStarlight(data) {
  var name = data.personName || "";
  var headline = data.headline || "";
  var stars = data.stars || [];
  var contributors = data.contributors || [];
  var els = [];
  var cx = 50, cy = 40, radius = 38;

  // Clean midnight background — no image, just the constellation floating
  els.push(React.createElement("rect", { key: "slbg", width: 100, height: 100, fill: "#050510" }));

  // Platinum/silver metallic gradient
  els.push(React.createElement("defs", { key: "sldefs" },
    React.createElement("linearGradient", { id: "platSheen", x1: "0%", y1: "0%", x2: "100%", y2: "100%" },
      React.createElement("stop", { offset: "0%", stopColor: "#808080" }),
      React.createElement("stop", { offset: "20%", stopColor: "#E8E8E8" }),
      React.createElement("stop", { offset: "45%", stopColor: "#A0A0A0" }),
      React.createElement("stop", { offset: "70%", stopColor: "#F0F0F0" }),
      React.createElement("stop", { offset: "100%", stopColor: "#909090" })
    )
  ));

  // Subtle silver starfield — delicate, not busy
  var seed = 127;
  for (var si = 0; si < 60; si++) {
    seed = (seed * 16807) % 2147483647;
    var sx = (seed % 10000) / 100;
    seed = (seed * 16807) % 2147483647;
    var sy = (seed % 10000) / 100;
    seed = (seed * 16807) % 2147483647;
    var sr2 = 0.03 + (seed % 100) / 2500;
    var sop = 0.05 + (seed % 60) / 800;
    els.push(React.createElement("circle", { key: "sls" + si, cx: sx, cy: sy, r: sr2, fill: "#C0C0C0", opacity: sop }));
  }

  // No circle border — constellation floats

  // Dynamic layout — works for 2 to 10+ stars
  var presetSL = data.layoutPreset || "scattered";
  var customPosSL = data.customPositions || null;
  var positioned = layoutConstellation(stars, cx, cy, 24, presetSL, customPosSL, data.customQuotePositions || null);
  var numStars = positioned.length;

  // Constellation lines
  for (var li = 0; li < positioned.length; li++) {
    var next = (li + 1) % positioned.length;
    var slSeg = trimLine(positioned[li].x, positioned[li].y, positioned[next].x, positioned[next].y, 3.2);
    if (slSeg) els.push(React.createElement("line", {
      key: "sll" + li,
      x1: slSeg.x1, y1: slSeg.y1, x2: slSeg.x2, y2: slSeg.y2,
      stroke: "url(#platSheen)", strokeWidth: .12, opacity: .40
    }));
  }

  // Stars + quotes — quotes radiate outward, never cross lines
  let qFontSize = numStars <= 4 ? 2.2 : numStars <= 6 ? 2.0 : 1.6;
  let qLineH = numStars <= 4 ? 2.6 : numStars <= 6 ? 2.4 : 2.0;
  var maxChars = numStars <= 4 ? 26 : numStars <= 6 ? 22 : 18;

  positioned.forEach(function(sp, i) {
    var quote = sp.star.decode || sp.star.label;
    var contrib = sp.star.starContributors && sp.star.starContributors[0] ? sp.star.starContributors[0] : (contributors[i % contributors.length] || "");
    var op = numStars <= 4 ? .90 : (i === 0 ? .90 : i < 3 ? .80 : .70);

    // Fit the quote to the space between the star and the edge. Shifting the
    // block inward instead would drag it back over the star dot.
    var SL_EDGE = 5;
    var slAvail = sp.anchor === "start" ? (100 - SL_EDGE - sp.qx) : (sp.qx - SL_EDGE);
    slAvail = Math.max(14, slAvail);
    var slFit = custFit(quote, slAvail, qFontSize, 0.46, 0.3, 4);
    var qLines = slFit.lines;
    var slSize = slFit.size;
    var slLineH = slSize * 1.2;

    // Star dots
    els.push(React.createElement("circle", { key: "slg" + i, cx: sp.x, cy: sp.y, r: .6, fill: "#FFFFFF", opacity: .95 }));
    els.push(React.createElement("circle", { key: "slg2" + i, cx: sp.x, cy: sp.y, r: 1.3, fill: "#C0C0C0", opacity: .10 }));

    qLines.forEach(function(line, li) {
      els.push(React.createElement("text", {
        key: "slq" + i + "_" + li, x: sp.qx, y: sp.qy + li * slLineH,
        textAnchor: sp.anchor, fill: "#FFFFFF", opacity: op,
        fontSize: slSize, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF, letterSpacing: .3,
        stroke: "#050510", strokeWidth: 0.4, paintOrder: "stroke"
      }, (li === 0 ? "\u201C" : "") + line + (li === qLines.length - 1 ? "\u201D" : "")));
    });
    // Attribution — always bottom-left of quote block
    var attrX2 = sp.anchor === "end" ? sp.qx - slFit.width : sp.qx;
    els.push(React.createElement("text", {
      key: "sla" + i, x: attrX2, y: sp.qy + qLines.length * slLineH + 1.5,
      textAnchor: "start", fill: "#C0C0C0", opacity: op * .85,
      fontSize: numStars <= 6 ? 1.1 : .9, fontWeight: "300", fontFamily: SERIF,
      stroke: "#050510", strokeWidth: 0.5, paintOrder: "stroke"
    }, "\u2014 " + contrib));
  });

  // Crown
  els.push(React.createElement("text", { key: "slcrown", x: 50, y: 5, textAnchor: "middle", fill: "url(#platSheen)", opacity: .20, fontSize: 1.5 }, "\u2726"));

  // Name — pure white
  els.push(React.createElement("text", { key: "slname", x: 50, y: 85, textAnchor: "middle", fill: "#FFFFFF", opacity: 1, fontSize: nameSz(name) * 1.5, fontWeight: "400", letterSpacing: 1.5, fontFamily: PLAY }, name));

  // F2: Adjective subtitle
  var adjFreqSL = data.adjectiveFreq || [];
  if (adjFreqSL.length > 0) {
    var topAdjsSL = adjFreqSL.slice(0, 3).map(function(a) { return a.word; }).join(", ");
    els.push(React.createElement("text", { key: "sladj", x: 50, y: 89, textAnchor: "middle", fill: "#C0C0C0", opacity: .55, fontSize: 1.3, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF, letterSpacing: .2 }, topAdjsSL));
  }

  // Thin silver line
  els.push(React.createElement("line", { key: "slline", x1: 22, y1: 91, x2: 78, y2: 91, stroke: "#C0C0C0", strokeWidth: .04, opacity: .30 }));

  // Tagline — white
  els.push(React.createElement("text", { key: "sltag", x: 50, y: 95, textAnchor: "middle", fill: "#FFFFFF", opacity: .80, fontSize: tagSz(headline) * 1.3, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF, letterSpacing: .3 }, headline));

  // Contributors — silver
  var slCred = creditLines(data.contributors, { base: .65, sep: "    \u00B7    " });
  slCred.lines.forEach(function(ln, i) {
    els.push(React.createElement("text", { key: "slcon" + i, x: 50, y: 98 + (i - (slCred.lines.length - 1)) * slCred.size * 1.35, textAnchor: "middle", fill: "#C0C0C0", opacity: .20, fontSize: slCred.size, fontWeight: "300", fontFamily: SERIF, letterSpacing: .2 }, ln));
  });

  return els;
}


// ═══════════════════════════════════════════
// STYLE: EDITORIAL — one line set huge, everything else whispered
// Scale contrast ~10x. One axis. One accent, spent once.
// The centre-right of the plate is deliberately empty.
// ═══════════════════════════════════════════
function editorialHero(data) {
  // The shortest real line wins: only a short line can be set enormous.
  var best = null, bestLen = Infinity;
  (data.stars || []).forEach(function(st) {
    var q = (st.decode || st.label || "").trim();
    var who = (st.starContributors && st.starContributors[0]) || "";
    if (q.length > 10 && q.length < bestLen) { bestLen = q.length; best = { text: q, who: who }; }
  });
  if (!best) {
    (data.rawQuotes || []).forEach(function(q) {
      var txt = (q.text || "").trim();
      if (txt.length > 10 && txt.length < bestLen) { bestLen = txt.length; best = { text: txt, who: q.contributor || "" }; }
    });
  }
  if (!best) {
    var f = (data.stars || [])[0];
    best = { text: f ? (f.decode || f.label || "") : (data.headline || ""), who: "" };
  }
  return best;
}

function renderEditorial(data) {
  var name = data.personName || "";
  var stars = data.stars || [];
  var contributors = (data.contributors || []).filter(Boolean);
  var els = [];

  var INK   = "#0D0D11";           // near-black, warm
  var PAPER = "#EFEAE0";           // the reading colour
  var GOLD  = "#C9A96E";           // spent exactly twice: one rule, one star
  var MUTE  = "rgba(239,234,224,0.40)";
  var FAINT = "rgba(239,234,224,0.18)";
  var L = 12;                      // the single left axis everything hangs off

  els.push(React.createElement("rect", { key: "edbg", width: 100, height: 100, fill: INK }));

  // ── the constellation, pushed into the opposite corner ──
  var n = stars.length || 1;
  var rnd = sr(101 + name.length * 7);
  var pts = [];
  for (var i = 0; i < n; i++) {
    var tt = n === 1 ? 0.5 : i / (n - 1);
    pts.push({
      x: 69 + tt * 20 + (rnd() - 0.5) * 4.5,
      y: 10 + Math.sin(tt * Math.PI * 0.85) * 10 + (rnd() - 0.5) * 2.6,
    });
  }
  for (var li = 0; li < pts.length - 1; li++) {
    var seg = trimLine(pts[li].x, pts[li].y, pts[li + 1].x, pts[li + 1].y, 1.5);
    if (seg) els.push(React.createElement("line", {
      key: "edl" + li, x1: seg.x1, y1: seg.y1, x2: seg.x2, y2: seg.y2,
      stroke: PAPER, strokeWidth: .07, opacity: .28,
    }));
  }

  var hero = editorialHero(data);
  var heroIdx = 0;
  stars.forEach(function(st, k) {
    var q = (st.decode || st.label || "").trim();
    if (q === hero.text) heroIdx = k;
  });

  pts.forEach(function(p, k) {
    var isHero = (k === heroIdx);
    els.push(React.createElement("circle", {
      key: "eds" + k, cx: p.x, cy: p.y, r: isHero ? .62 : .34,
      fill: isHero ? GOLD : PAPER, opacity: isHero ? 1 : .62,
    }));
    if (isHero) els.push(React.createElement("circle", {
      key: "edsh" + k, cx: p.x, cy: p.y, r: 2.1, fill: "none",
      stroke: GOLD, strokeWidth: .07, opacity: .40,
    }));
  });

  // ── the one gold rule ──
  els.push(React.createElement("line", {
    key: "edrule", x1: L, y1: 33, x2: L + 7, y2: 33,
    stroke: GOLD, strokeWidth: .22, opacity: .95,
  }));

  // ── the hero line — the whole point of the style ──
  var txt = hero.text.replace(/\s+/g, " ").trim();
  var start = txt.length < 26 ? 11.5 : txt.length < 44 ? 9 : txt.length < 70 ? 7 : 5.6;
  var fit = custFit(txt, 70, start, 0.50, 0.05, 4);
  var lh = fit.size * 1.12;
  var top = 41;

  fit.lines.forEach(function(line, k) {
    els.push(React.createElement("text", {
      key: "edq" + k, x: L, y: top + k * lh, textAnchor: "start",
      fill: PAPER, fontSize: fit.size, fontFamily: PLAY,
      fontWeight: "400", fontStyle: "italic", letterSpacing: -0.05,
    }, (k === 0 ? "\u201C" : "") + line + (k === fit.lines.length - 1 ? "\u201D" : "")));
  });

  var afterQuote = top + (fit.lines.length - 1) * lh;
  if (hero.who) {
    els.push(React.createElement("text", {
      key: "edattr", x: L, y: afterQuote + fit.size * 0.95 + 2.4, textAnchor: "start",
      fill: GOLD, opacity: .85, fontSize: 1.15, fontFamily: SANS,
      fontWeight: "400", letterSpacing: 1.8,
    }, hero.who.toUpperCase()));
  }

  // ── the name, quiet, bottom-left on the same axis ──
  var nmFS = nameSz(name) * 0.88;
  var nmTrack = 1.1;
  var guard = 0;
  while (custLineW(name, nmFS, 0.58, nmTrack) > 62 && guard < 60) { nmFS *= 0.95; guard++; }
  els.push(React.createElement("text", {
    key: "edname", x: L, y: 82, textAnchor: "start",
    fill: PAPER, opacity: .95, fontSize: nmFS, fontFamily: PLAY,
    fontWeight: "400", letterSpacing: nmTrack,
  }, name));

  var adj = data.adjectiveFreq || [];
  if (adj.length) {
    els.push(React.createElement("text", {
      key: "edadj", x: L, y: 86.4, textAnchor: "start",
      fill: MUTE, fontSize: 1.05, fontFamily: SANS,
      fontWeight: "400", letterSpacing: 2.6,
    }, adj.slice(0, 3).map(function(a) { return String(a.word).toUpperCase(); }).join("   \u00B7   ")));
  }

  // ── the promise at the foot: there are more of us ──
  els.push(React.createElement("line", {
    key: "edfoot", x1: L, y1: 91.5, x2: 88, y2: 91.5,
    stroke: PAPER, strokeWidth: .04, opacity: .16,
  }));
  if (contributors.length) {
    var cred = creditLines(contributors, { base: .82, sep: "   \u00B7   ", maxW: 74 });
    cred.lines.forEach(function(ln, k) {
      els.push(React.createElement("text", {
        key: "edcred" + k, x: L, y: 95 + k * cred.size * 1.5, textAnchor: "start",
        fill: FAINT, fontSize: cred.size, fontFamily: SANS,
        fontWeight: "400", letterSpacing: 1.2,
      }, (k === 0 ? "WORDS BY   " : "") + ln.toUpperCase()));
    });
  }

  return els;
}

// ═══════════════════════════════════════════
// STYLE V2: OVERLAP II — gaussian blur circles
// ═══════════════════════════════════════════
function renderOverlap2(data) {
  var name = data.personName || "";
  var headline = data.headline || "";
  var stars = (data.stars || []).slice(0, 6);
  var contributors = data.contributors || [];
  var els = [];
  var cx = 50, cy = 42;

  // Metallic gold gradient
  els.push(React.createElement("defs", { key: "ov2defs" },
    React.createElement("linearGradient", { id: "goldSheen2", x1: "0%", y1: "0%", x2: "100%", y2: "100%" },
      React.createElement("stop", { offset: "0%", stopColor: "#BF953F" }),
      React.createElement("stop", { offset: "22%", stopColor: "#FCF6BA" }),
      React.createElement("stop", { offset: "45%", stopColor: "#B38728" }),
      React.createElement("stop", { offset: "67%", stopColor: "#FBF5B7" }),
      React.createElement("stop", { offset: "100%", stopColor: "#AA771C" })
    )
  ));
  // Crown
  els.push(React.createElement("text", { key: "ov2crown", x: 50, y: 6, textAnchor: "middle", fill: "url(#goldSheen2)", opacity: .25, fontSize: 2 }, "\u2726"));
  els.push(React.createElement("text", { key: "ov2lbl", x: 50, y: 11, textAnchor: "middle", fill: "url(#goldSheen2)", opacity: .20, fontSize: .7, letterSpacing: .5, fontWeight: "300", fontFamily: SERIF }, "WHERE   VOICES   OVERLAP"));

  // Contributor circles — larger, spread wider
  var offsets = [
    { dx: -16, dy: -14 }, { dx: 16, dy: -10 }, { dx: 19, dy: 12 },
    { dx: -13, dy: 16 }, { dx: -19, dy: 4 }, { dx: 13, dy: -16 }
  ];
  var numCircles = Math.min(contributors.length || 4, 6);
  if (numCircles < 3) numCircles = 4;

  for (var ci = 0; ci < numCircles; ci++) {
    var off = offsets[ci % offsets.length];
    var r = 22 + (ci % 3) * 4;
    els.push(React.createElement("circle", {
      key: "ov2c" + ci, cx: cx + off.dx, cy: cy + off.dy, r: r,
      fill: "none", stroke: "url(#goldSheen2)", strokeWidth: .06, opacity: .15
    }));
    var labelAngle = ((ci * 60) + 200) * Math.PI / 180;
    var lx = cx + off.dx + (r + 4) * Math.cos(labelAngle);
    var ly = cy + off.dy + (r + 4) * Math.sin(labelAngle);
    if (ci < contributors.length) {
      els.push(React.createElement("text", {
        key: "ov2n" + ci, x: lx, y: ly, textAnchor: "middle",
        fill: "url(#goldSheen2)", opacity: .35, fontSize: 1.1,
        fontStyle: "italic", fontWeight: "300", fontFamily: SERIF
      }, contributors[ci]));
    }
  }

  // FREE-FOR-ALL COLLAGE — quotes italic, adjectives CAPS, inside jokes scattered
  var adjFreq = data.adjectiveFreq || [];
  var insideJokes = data.insideJokes || [];
  var oseed = 37;
  function orand() { oseed = (oseed * 16807) % 2147483647; return (oseed - 1) / 2147483646; }

  // Adjectives in CAPS — scattered across the canvas at varying sizes
  var topAdj = adjFreq.slice(0, 10);
  var adjMax = topAdj.length > 0 ? topAdj[0].count : 1;
  var adjSpots = [
    { x: 25, y: 22 }, { x: 75, y: 18 }, { x: 50, y: 32 },
    { x: 18, y: 42 }, { x: 82, y: 38 }, { x: 35, y: 52 },
    { x: 70, y: 55 }, { x: 50, y: 15 }, { x: 28, y: 62 }, { x: 72, y: 65 }
  ];
  topAdj.forEach(function(a, i) {
    if (i >= adjSpots.length) return;
    var ratio = a.count / adjMax;
    var sz = 1.8 + ratio * 4;
    var op = 0.25 + ratio * 0.45;
    var rot = orand() * 30 - 15;
    els.push(React.createElement("text", {
      key: "ov2adj" + i, x: adjSpots[i].x + orand() * 8 - 4, y: adjSpots[i].y + orand() * 6 - 3,
      textAnchor: "middle", fill: "url(#goldSheen2)", opacity: op,
      fontSize: sz, fontWeight: ratio > 0.6 ? "700" : "400", fontFamily: SANS,
      letterSpacing: sz > 4 ? .5 : .2, transform: "rotate(" + rot.toFixed(1) + " " + adjSpots[i].x + " " + adjSpots[i].y + ")"
    }, a.word.toUpperCase()));
  });

  // Quotes — italic, scattered at different angles and opacities
  var sortedStars = stars.slice().sort(function(a, b) { return (b.resonance || 3) - (a.resonance || 3); });
  var qSpots = [
    { x: cx - 8, y: cy - 8, op: .80, sz: 2.2 },
    { x: cx + 10, y: cy + 4, op: .70, sz: 2.0 },
    { x: cx - 15, y: cy + 14, op: .58, sz: 1.8 },
    { x: cx + 16, y: cy - 14, op: .52, sz: 1.7 },
    { x: cx + 5, y: cy + 22, op: .45, sz: 1.6 },
    { x: cx - 18, y: cy - 2, op: .40, sz: 1.5 },
  ];
  sortedStars.forEach(function(star, i) {
    if (i >= qSpots.length) return;
    var sp = qSpots[i];
    var quote = star.decode || star.label;
    var rot = orand() * 12 - 6;
    els.push(React.createElement("text", {
      key: "ov2q" + i, x: sp.x + orand() * 4 - 2, y: sp.y + orand() * 4 - 2, textAnchor: "middle",
      fill: "url(#goldSheen2)", opacity: sp.op, fontSize: sp.sz,
      fontStyle: "italic", fontWeight: "300", fontFamily: SERIF,
      transform: "rotate(" + rot.toFixed(1) + " " + sp.x + " " + sp.y + ")"
    }, "\u201C" + quote + "\u201D"));
  });

  // Inside jokes — small, scattered in gaps
  insideJokes.slice(0, 3).forEach(function(j, i) {
    var joke = j.text;
    var jx = 20 + i * 25 + orand() * 10;
    var jy = 68 + orand() * 8;
    var rot = orand() * 20 - 10;
    els.push(React.createElement("text", {
      key: "ov2j" + i, x: jx, y: jy, textAnchor: "middle",
      fill: "url(#goldSheen2)", opacity: .30, fontSize: 1.2,
      fontWeight: "300", fontFamily: SANS, fontStyle: "italic",
      transform: "rotate(" + rot.toFixed(1) + " " + jx + " " + jy + ")"
    }, joke));
  });

  // Name — metallic gradient
  els.push(React.createElement("text", { key: "ov2name", x: 50, y: 78, textAnchor: "middle", fill: "url(#goldSheen2)", opacity: .98, fontSize: nameSz(name) * 1.3, fontWeight: "400", letterSpacing: .5, fontFamily: PLAY }, name));
  els.push(React.createElement("g", { key: "ov2coach", opacity: .28 },
    React.createElement("line", { x1: 18, y1: 81.5, x2: 48, y2: 81.5, stroke: "url(#goldSheen2)", strokeWidth: .04 }),
    React.createElement("line", { x1: 52, y1: 81.5, x2: 82, y2: 81.5, stroke: "url(#goldSheen2)", strokeWidth: .04 }),
    React.createElement("rect", { x: 49.5, y: 81.2, width: 1, height: 1, fill: "url(#goldSheen2)", opacity: .6, transform: "rotate(45 50 81.7)" })
  ));
  els.push(React.createElement("text", { key: "ov2tag", x: 50, y: 87, textAnchor: "middle", fill: "url(#goldSheen2)", opacity: .55, fontSize: tagSz(headline) * 1.2, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, headline));
  els.push(React.createElement("text", { key: "ov2ft", x: 50, y: 97, textAnchor: "middle", fill: "url(#goldSheen2)", opacity: .12, fontSize: .6, fontWeight: "300", fontFamily: SERIF, letterSpacing: .6 }, "YOURS   TRULY"));
  return els;
}

// ═══════════════════════════════════════════
// STYLE V2: GALLERY II — dramatic starfield, glowing quotes
// ═══════════════════════════════════════════
function renderGallery2(data) {
  var name = data.personName || "";
  var headline = data.headline || "";
  var stars = (data.stars || []).slice(0, 6);
  var contributors = data.contributors || [];
  var els = [];

  // Metallic gold gradient
  els.push(React.createElement("defs", { key: "gv2defs" },
    React.createElement("linearGradient", { id: "goldSheen3", x1: "0%", y1: "0%", x2: "100%", y2: "100%" },
      React.createElement("stop", { offset: "0%", stopColor: "#BF953F" }),
      React.createElement("stop", { offset: "22%", stopColor: "#FCF6BA" }),
      React.createElement("stop", { offset: "45%", stopColor: "#B38728" }),
      React.createElement("stop", { offset: "67%", stopColor: "#FBF5B7" }),
      React.createElement("stop", { offset: "100%", stopColor: "#AA771C" })
    )
  ));

  // Sparse golden starfield
  var seed = 41;
  for (var si = 0; si < 40; si++) {
    seed = (seed * 16807) % 2147483647;
    var sx = (seed % 10000) / 100;
    seed = (seed * 16807) % 2147483647;
    var sy = (seed % 10000) / 100;
    seed = (seed * 16807) % 2147483647;
    var ssr = .04 + (seed % 100) / 800;
    els.push(React.createElement("circle", { key: "gv2s" + si, cx: sx, cy: sy, r: ssr, fill: "url(#goldSheen3)", opacity: .04 + (seed % 40) / 600 }));
  }

  // Crown motif
  els.push(React.createElement("text", { key: "gv2crown", x: 50, y: 12, textAnchor: "middle", fill: "url(#goldSheen3)", opacity: .35, fontSize: 3 }, "\u2726"));

  // Name — MASSIVE
  var nameParts = name.split(" ");
  var nSz = name.length > 16 ? 10 : name.length > 12 ? 12 : name.length > 8 ? 15 : 17;

  if (nameParts.length > 1 && name.length > 10) {
    els.push(React.createElement("text", { key: "gv2n1", x: 50, y: 30, textAnchor: "middle", fill: "url(#goldSheen3)", opacity: .98, fontSize: nSz, fontWeight: "400", letterSpacing: 1.2, fontFamily: PLAY }, nameParts[0]));
    els.push(React.createElement("text", { key: "gv2n2", x: 50, y: 30 + nSz * 1.15, textAnchor: "middle", fill: "url(#goldSheen3)", opacity: .98, fontSize: nSz, fontWeight: "400", letterSpacing: 1.2, fontFamily: PLAY }, nameParts.slice(1).join(" ")));
  } else {
    els.push(React.createElement("text", { key: "gv2n1", x: 50, y: 35, textAnchor: "middle", fill: "url(#goldSheen3)", opacity: .98, fontSize: nSz, fontWeight: "400", letterSpacing: 1.2, fontFamily: PLAY }, name));
  }

  var baseY = nameParts.length > 1 && name.length > 10 ? 30 + nSz * 1.15 + 4 : 42;

  // Coachline — wider
  els.push(React.createElement("g", { key: "gv2coach", opacity: .35 },
    React.createElement("line", { x1: 8, y1: baseY, x2: 48, y2: baseY, stroke: "url(#goldSheen3)", strokeWidth: .05 }),
    React.createElement("line", { x1: 8, y1: baseY + .6, x2: 48, y2: baseY + .6, stroke: "url(#goldSheen3)", strokeWidth: .02 }),
    React.createElement("rect", { x: 49.5, y: baseY - .3, width: 1, height: 1, fill: "url(#goldSheen3)", opacity: .6, transform: "rotate(45 50 " + (baseY + .2) + ")" }),
    React.createElement("line", { x1: 52, y1: baseY, x2: 92, y2: baseY, stroke: "url(#goldSheen3)", strokeWidth: .05 }),
    React.createElement("line", { x1: 52, y1: baseY + .6, x2: 92, y2: baseY + .6, stroke: "url(#goldSheen3)", strokeWidth: .02 })
  ));

  // Headline — bigger
  els.push(React.createElement("text", { key: "gv2hl", x: 50, y: baseY + 7, textAnchor: "middle", fill: "url(#goldSheen3)", opacity: .85, fontSize: 3.5, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, headline));

  // Quotes — wider spacing, larger text
  var qStartY = baseY + 17;
  var maxQ = Math.min(stars.length, 4);
  for (var i = 0; i < maxQ; i++) {
    var q = stars[i].decode || stars[i].label;
    var ct = stars[i].starContributors && stars[i].starContributors[0] ? stars[i].starContributors[0] : (contributors[i % contributors.length] || "");
    var qOp = i === 0 ? .75 : i === 1 ? .65 : i === 2 ? .55 : .45;
    els.push(React.createElement("circle", { key: "gv2qd" + i, cx: 50, cy: qStartY + i * 9 - 3.5, r: .25, fill: "url(#goldSheen3)", opacity: qOp }));
    els.push(React.createElement("text", { key: "gv2q" + i, x: 50, y: qStartY + i * 9, textAnchor: "middle", fill: "url(#goldSheen3)", opacity: qOp, fontSize: 2.2, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, "\u201C" + q + "\u201D"));
    els.push(React.createElement("text", { key: "gv2a" + i, x: 50, y: qStartY + i * 9 + 3, textAnchor: "middle", fill: "url(#goldSheen3)", opacity: qOp * .85, fontSize: 1.0, fontWeight: "300", fontFamily: SERIF }, "\u2014 " + ct));
  }

  els.push(React.createElement("text", { key: "gv2ft", x: 50, y: 97, textAnchor: "middle", fill: "url(#goldSheen3)", opacity: .15, fontSize: .65, fontWeight: "300", fontFamily: SERIF, letterSpacing: .8 }, "YOURS   TRULY"));
  return els;
}

// ═══════════════════════════════════════════
// STYLE: EMBER — dark oil painting bg, warm centered text
// ═══════════════════════════════════════════
function renderEmber(data) {
  var name = data.personName || "";
  var headline = data.headline || "";
  var stars = (data.stars || []).slice(0, 6);
  var contributors = data.contributors || [];
  var els = [];

  // Background image
  els.push(React.createElement("image", { key: "emberbg", href: "/ember-bg.png", x: 0, y: 0, width: 100, height: 100, preserveAspectRatio: "xMidYMid slice" }));

  // Gradient overlay — dark at top and bottom, transparent in middle
  els.push(React.createElement("defs", { key: "edefs" },
    React.createElement("linearGradient", { id: "emberTop", x1: "0", y1: "0", x2: "0", y2: "1" },
      React.createElement("stop", { offset: "0%", stopColor: "#000000", stopOpacity: "0.6" }),
      React.createElement("stop", { offset: "100%", stopColor: "#000000", stopOpacity: "0" })
    ),
    React.createElement("linearGradient", { id: "emberBot", x1: "0", y1: "0", x2: "0", y2: "1" },
      React.createElement("stop", { offset: "0%", stopColor: "#000000", stopOpacity: "0" }),
      React.createElement("stop", { offset: "100%", stopColor: "#000000", stopOpacity: "0.7" })
    )
  ));
  els.push(React.createElement("rect", { key: "etop", x: 0, y: 0, width: 100, height: 25, fill: "url(#emberTop)" }));
  els.push(React.createElement("rect", { key: "ebot", x: 0, y: 50, width: 100, height: 50, fill: "url(#emberBot)" }));

  // Crown
  els.push(React.createElement("text", { key: "ecrown", x: 50, y: 8, textAnchor: "middle", fill: "#C9A96E", opacity: .35, fontSize: 2 }, "\u2726"));

  // Name — upper area, centered
  var nSz = name.length > 16 ? 7 : name.length > 12 ? 9 : name.length > 8 ? 11 : 13;
  var nameParts = name.split(" ");
  if (nameParts.length > 1 && name.length > 10) {
    els.push(React.createElement("text", { key: "en1", x: 50, y: 20, textAnchor: "middle", fill: "#F5F0EB", opacity: .95, fontSize: nSz, fontWeight: "400", letterSpacing: .6, fontFamily: PLAY }, nameParts[0]));
    els.push(React.createElement("text", { key: "en2", x: 50, y: 20 + nSz * 1.15, textAnchor: "middle", fill: "#F5F0EB", opacity: .95, fontSize: nSz, fontWeight: "400", letterSpacing: .6, fontFamily: PLAY }, nameParts.slice(1).join(" ")));
  } else {
    els.push(React.createElement("text", { key: "en1", x: 50, y: 22, textAnchor: "middle", fill: "#F5F0EB", opacity: .95, fontSize: nSz, fontWeight: "400", letterSpacing: .6, fontFamily: PLAY }, name));
  }

  // Headline
  var baseY = nameParts.length > 1 && name.length > 10 ? 20 + nSz * 1.15 + 4 : 28;
  els.push(React.createElement("text", { key: "ehl", x: 50, y: baseY, textAnchor: "middle", fill: "#C9A96E", opacity: .70, fontSize: 2.5, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, headline));

  // Quotes — centered, stacked in the lower area over the dark gradient
  var qStartY = 62;
  var maxQ = Math.min(stars.length, 5);
  for (var i = 0; i < maxQ; i++) {
    var q = stars[i].decode || stars[i].label;
    var ct = stars[i].starContributors && stars[i].starContributors[0] ? stars[i].starContributors[0] : (contributors[i % contributors.length] || "");
    var qOp = i === 0 ? .80 : i === 1 ? .70 : i === 2 ? .60 : i === 3 ? .50 : .40;

    els.push(React.createElement("text", { key: "eq" + i, x: 50, y: qStartY + i * 6.5, textAnchor: "middle", fill: "#F5F0EB", opacity: qOp, fontSize: 1.7, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, "\u201C" + q + "\u201D"));
    els.push(React.createElement("text", { key: "ea" + i, x: 50, y: qStartY + i * 6.5 + 2.3, textAnchor: "middle", fill: "#C9A96E", opacity: qOp * .85, fontSize: .75, fontWeight: "300", fontFamily: SERIF }, "\u2014 " + ct));
  }

  els.push(React.createElement("text", { key: "eft", x: 50, y: 97, textAnchor: "middle", fill: "#C9A96E", opacity: .12, fontSize: .55, fontWeight: "300", fontFamily: SERIF, letterSpacing: .6 }, "YOURS   TRULY"));
  return els;
}

// STYLE: BLOOM — watercolor bg, dark elegant text
// ═══════════════════════════════════════════
function renderBloom(data) {
  var name = data.personName || "";
  var headline = data.headline || "";
  var stars = (data.stars || []).slice(0, 6);
  var contributors = data.contributors || [];
  var els = [];

  // Background image — full bleed
  els.push(React.createElement("image", { key: "bloombg", href: "/bloom-bg.png?v=2", x: 0, y: 0, width: 100, height: 100, preserveAspectRatio: "xMidYMid slice" }));

  // NO overlay box — let the watercolor breathe

  // Name — large, dark, elegant
  var nameParts = name.split(" ");
  var nSz = name.length > 16 ? 8 : name.length > 12 ? 10 : name.length > 8 ? 12 : 14;

  if (nameParts.length > 1 && name.length > 10) {
    els.push(React.createElement("text", { key: "bn1", x: 50, y: 30, textAnchor: "middle", fill: "#000000", opacity: 1, fontSize: nSz, fontWeight: "400", letterSpacing: .8, fontFamily: PLAY }, nameParts[0]));
    els.push(React.createElement("text", { key: "bn2", x: 50, y: 30 + nSz * 1.15, textAnchor: "middle", fill: "#000000", opacity: 1, fontSize: nSz, fontWeight: "400", letterSpacing: .8, fontFamily: PLAY }, nameParts.slice(1).join(" ")));
  } else {
    els.push(React.createElement("text", { key: "bn1", x: 50, y: 35, textAnchor: "middle", fill: "#000000", opacity: 1, fontSize: nSz, fontWeight: "400", letterSpacing: .8, fontFamily: PLAY }, name));
  }

  var baseY = nameParts.length > 1 && name.length > 10 ? 30 + nSz * 1.15 + 3 : 40;

  // Thin line — dark rose
  els.push(React.createElement("line", { key: "bline1", x1: 25, y1: baseY, x2: 48, y2: baseY, stroke: "#3D1A2A", strokeWidth: .05, opacity: .35 }));
  els.push(React.createElement("line", { key: "bline2", x1: 52, y1: baseY, x2: 75, y2: baseY, stroke: "#3D1A2A", strokeWidth: .05, opacity: .35 }));

  // Headline — full black
  els.push(React.createElement("text", { key: "bhl", x: 50, y: baseY + 5, textAnchor: "middle", fill: "#000000", opacity: 1, fontSize: 3, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, headline));

  // Quotes — dark, readable
  var qStartY = baseY + 14;
  var maxQ = Math.min(stars.length, 4);
  for (var i = 0; i < maxQ; i++) {
    var q = stars[i].decode || stars[i].label;
    var ct = stars[i].starContributors && stars[i].starContributors[0] ? stars[i].starContributors[0] : (contributors[i % contributors.length] || "");
    var qOp = i === 0 ? .95 : i === 1 ? .90 : i === 2 ? .85 : .80;

    els.push(React.createElement("text", { key: "bq" + i, x: 50, y: qStartY + i * 7.5, textAnchor: "middle", fill: "#000000", opacity: qOp, fontSize: 2, fontStyle: "italic", fontWeight: "300", fontFamily: SERIF }, "\u201C" + q + "\u201D"));
    els.push(React.createElement("text", { key: "ba" + i, x: 50, y: qStartY + i * 7.5 + 2.5, textAnchor: "middle", fill: "#000000", opacity: qOp * .90, fontSize: .85, fontWeight: "300", fontFamily: SERIF }, "\u2014 " + ct));
  }

  // Footer — subtle
  els.push(React.createElement("text", { key: "bft", x: 50, y: 96, textAnchor: "middle", fill: "#3D2A4A", opacity: .12, fontSize: .6, fontWeight: "300", fontFamily: SERIF, letterSpacing: .8 }, "YOURS   TRULY"));
  return els;
}

// ═══════════════════════════════════════════
// STYLE: STATEMENT — Newspaper cutout / scrapbook collage
// Mixed typefaces, torn edges, rotations, cream newsprint bg
// ═══════════════════════════════════════════
function renderStatement(data) {
  var name = data.personName || "";
  var headline = data.headline || "";
  var adjFreq = data.adjectiveFreq || [];
  var insideJokes = data.insideJokes || [];
  var stars = data.stars || [];
  var contributors = data.contributors || [];
  var els = [];

  var dseed = 42;
  function drand() { dseed = (dseed * 16807) % 2147483647; return (dseed - 1) / 2147483646; }

  // Newsprint background — warm off-white with subtle texture
  els.push(React.createElement("rect", { key: "bg", width: 100, height: 100, fill: "#F5F0E6" }));

  // Paper texture — faint lines and grain
  for (var ti = 0; ti < 30; ti++) {
    var tx = drand() * 100, ty = drand() * 100;
    els.push(React.createElement("line", { key: "grain" + ti, x1: tx, y1: ty, x2: tx + drand() * 8, y2: ty + drand() * .5, stroke: "#D4C8B0", strokeWidth: .015, opacity: drand() * .12 + .03 }));
  }

  // Coffee ring stain — subtle
  els.push(React.createElement("circle", { key: "stain", cx: 78, cy: 22, r: 7, fill: "none", stroke: "#C8B090", strokeWidth: .12, opacity: .06 }));
  els.push(React.createElement("circle", { key: "stain2", cx: 78, cy: 22, r: 6.6, fill: "none", stroke: "#C8B090", strokeWidth: .06, opacity: .04 }));

  // Fonts for cutout variety
  var cutFonts = [PLAY, SERIF, SANS, '"Georgia", serif', '"Times New Roman", serif'];
  var cutWeights = ["400", "700", "300", "800", "500"];

  // Helper: create a "cutout" text element with paper backing
  function cutout(key, x, y, text, fontSize, opts) {
    opts = opts || {};
    var rot = opts.rot || (drand() * 6 - 3);
    var font = opts.font || cutFonts[Math.floor(drand() * cutFonts.length)];
    var weight = opts.weight || cutWeights[Math.floor(drand() * cutWeights.length)];
    var fill = opts.fill || "#1A1410";
    var paperFill = opts.paper || (drand() > .5 ? "#FFF8EE" : "#F0E8D8");
    var padX = fontSize * 0.3 + 0.5;
    var padY = fontSize * 0.2 + 0.3;
    var approxW = text.length * fontSize * 0.52 + padX * 2;
    var approxH = fontSize * 1.2 + padY * 2;
    var transform = "rotate(" + rot.toFixed(1) + " " + x.toFixed(1) + " " + y.toFixed(1) + ")";
    var result = [];
    // Paper backing with slight shadow
    result.push(React.createElement("rect", {
      key: key + "sh", x: x - approxW / 2 + .15, y: y - approxH / 2 + fontSize * 0.1 + .15,
      width: approxW, height: approxH, fill: "#000", opacity: .06, transform: transform
    }));
    result.push(React.createElement("rect", {
      key: key + "bg", x: x - approxW / 2, y: y - approxH / 2 + fontSize * 0.1,
      width: approxW, height: approxH, fill: paperFill, transform: transform,
      stroke: drand() > .6 ? "#C8B898" : "none", strokeWidth: .04, opacity: .90
    }));
    // Torn edge effect — rough top or bottom
    if (drand() > .5) {
      var tearY = y - approxH / 2 + fontSize * 0.1;
      var tearPath = "M" + (x - approxW / 2) + " " + tearY;
      for (var tp = 0; tp < 6; tp++) {
        tearPath += " L" + (x - approxW / 2 + (tp + 1) * approxW / 6) + " " + (tearY + (drand() * .4 - .2));
      }
      result.push(React.createElement("path", { key: key + "tear", d: tearPath, fill: "none", stroke: paperFill, strokeWidth: .2, transform: transform, opacity: .8 }));
    }
    // Text
    result.push(React.createElement("text", {
      key: key + "t", x: x, y: y + fontSize * 0.35, textAnchor: "middle",
      fill: fill, fontSize: fontSize, fontWeight: weight, fontFamily: font,
      transform: transform, letterSpacing: fontSize > 5 ? .1 : .02,
      fontStyle: opts.italic ? "italic" : "normal"
    }, text));
    return result;
  }

  // ── NAME — biggest cutout, spanning the top ──
  var nameParts = name.toUpperCase().split(" ");
  if (nameParts.length > 1) {
    var n1 = cutout("name1", 50 + (drand() * 4 - 2), 14, nameParts[0], 11, { rot: drand() * 3 - 1.5, font: PLAY, weight: "400", paper: "#FFF8EE" });
    var n2 = cutout("name2", 50 + (drand() * 4 - 2), 28, nameParts.slice(1).join(" "), 11, { rot: drand() * 3 - 1.5, font: PLAY, weight: "400", paper: "#FFFDF5" });
    n1.concat(n2).forEach(function(e) { els.push(e); });
  } else {
    cutout("name1", 50, 18, name.toUpperCase(), 12, { rot: drand() * 2 - 1, font: PLAY, weight: "400", paper: "#FFF8EE" }).forEach(function(e) { els.push(e); });
  }

  // ── ADJECTIVES — word cutouts scattered in the middle ──
  var topAdj = adjFreq.slice(0, 8);
  var maxCount = topAdj.length > 0 ? topAdj[0].count : 1;
  var adjPositions = [
    { x: 28, y: 40 }, { x: 68, y: 38 }, { x: 44, y: 48 },
    { x: 72, y: 50 }, { x: 24, y: 56 }, { x: 56, y: 58 },
    { x: 38, y: 64 }, { x: 76, y: 62 }
  ];
  topAdj.forEach(function(a, i) {
    if (i >= adjPositions.length) return;
    var p = adjPositions[i];
    var ratio = a.count / maxCount;
    var sz = 2.5 + ratio * 5;
    var w = ratio > 0.6 ? "800" : ratio > 0.3 ? "600" : "400";
    cutout("adj" + i, p.x + drand() * 6 - 3, p.y + drand() * 4 - 2, a.word.toUpperCase(), sz, {
      rot: drand() * 12 - 6, weight: w, font: drand() > .5 ? SANS : PLAY,
      paper: drand() > .5 ? "#FFF8EE" : "#F5ECD8"
    }).forEach(function(e) { els.push(e); });
  });

  // ── QUOTES — headline strip cutouts ──
  var quoteStars = stars.slice(0, 4);
  var qPositions = [
    { x: 48, y: 72 }, { x: 52, y: 78 }, { x: 46, y: 84 }, { x: 54, y: 90 }
  ];
  quoteStars.forEach(function(s, i) {
    if (i >= qPositions.length) return;
    var text = s.decode || s.label;
    var contrib = s.starContributors && s.starContributors[0] ? s.starContributors[0] : (contributors[i % contributors.length] || "");
    var p = qPositions[i];
    cutout("q" + i, p.x + drand() * 6 - 3, p.y + drand() * 2 - 1,
      "\u201C" + text + "\u201D" + (contrib ? " \u2014" + contrib : ""), 1.6, {
      rot: drand() * 8 - 4, italic: true, font: SERIF, weight: "300",
      paper: "#FFFDF5"
    }).forEach(function(e) { els.push(e); });
  });

  // ── INSIDE JOKES — small torn scraps ──
  insideJokes.slice(0, 2).forEach(function(j, i) {
    var joke = j.text;
    cutout("joke" + i, 30 + i * 40 + drand() * 10, 94 + drand() * 2, joke, 1.2, {
      rot: drand() * 15 - 7.5, font: SANS, weight: "300",
      paper: "rgba(200,180,140,0.3)", fill: "#6A5A4A", italic: true
    }).forEach(function(e) { els.push(e); });
  });

  // ── Tape strips — crossing some cutouts ──
  [{ x: 42, y: 16, rot: -12, w: 12 }, { x: 62, y: 46, rot: 8, w: 10 }].forEach(function(tape, i) {
    els.push(React.createElement("rect", {
      key: "tape" + i, x: tape.x - tape.w / 2, y: tape.y - .8, width: tape.w, height: 1.6,
      fill: "rgba(220,200,160,0.25)", transform: "rotate(" + tape.rot + " " + tape.x + " " + tape.y + ")",
      stroke: "rgba(200,180,140,0.15)", strokeWidth: .02
    }));
  });

  return els;
}

// ═══════════════════════════════════════════
// STYLE: TEXTS — iMessage chat bubble poster
// Quotes as iOS-style chat bubbles on dark bg
// ═══════════════════════════════════════════
function renderTexts(data) {
  var name = data.personName || "";
  var stars = data.stars || [];
  var insideJokes = data.insideJokes || [];
  var els = [];

  // ── MATTE BLACK BACKGROUND ──
  els.push(React.createElement("defs", { key: "tdefs" },
    React.createElement("filter", { id: "frost", x: "-10%", y: "-10%", width: "120%", height: "120%" },
      React.createElement("feGaussianBlur", { "in": "SourceGraphic", stdDeviation: "0.3" })
    )
  ));

  els.push(React.createElement("rect", { key: "bg1", width: 100, height: 100, fill: "#0A0A0A" }));

  // Clean matte black — no light spots

  // ── PERSON NAME — conversation header style ──
  var nSz = name.length > 14 ? 2.2 : name.length > 8 ? 2.8 : 3.2;
  els.push(React.createElement("text", {
    key: "name", x: 50, y: 7, textAnchor: "middle",
    fill: "#FFFFFF", opacity: .50, fontSize: nSz, fontWeight: "500", fontFamily: SANS, letterSpacing: .3
  }, name));
  // Thin separator
  els.push(React.createElement("line", { key: "sep", x1: 20, y1: 10, x2: 80, y2: 10, stroke: "#FFFFFF", strokeWidth: .03, opacity: .08 }));

  // ── CHAT BUBBLES — iMessage style with sender names ──
  var allBubbles = stars.slice(0, 6).map(function(s) {
    var contrib = s.starContributors && s.starContributors[0] ? s.starContributors[0] : "";
    return { text: s.decode || s.label, sender: contrib, isJoke: false };
  });

  // Add inside jokes as different style
  insideJokes.slice(0, 1).forEach(function(j) {
    var joke = j.text;
    allBubbles.push({ text: joke, sender: j.contributor || "", isJoke: true });
  });

  // Bubble colors — translucent frosted on matte black
  var bubbleColors = [
    "rgba(255,255,255,0.10)",
    "rgba(255,255,255,0.08)",
    "rgba(255,255,255,0.12)",
    "rgba(255,255,255,0.09)",
    "rgba(255,255,255,0.11)",
    "rgba(255,255,255,0.07)",
  ];

  var startY = 14;
  var endY = 94;
  var totalSpace = endY - startY;
  var numB = allBubbles.length;
  var slotH = numB > 0 ? totalSpace / numB : 10;
  if (slotH > 14) slotH = 14;

  allBubbles.forEach(function(q, i) {
    var text = q.text;

    // Word wrap
    var maxChars = 40;
    var words = text.split(" ");
    var lines = []; var cur = "";
    words.forEach(function(w) {
      if ((cur + " " + w).length > maxChars && cur) { lines.push(cur); cur = w; }
      else { cur = cur ? cur + " " + w : w; }
    });
    if (cur) lines.push(cur);
    if (lines.length > 3) lines = lines.slice(0, 3);

    var fontSize = 2.0;
    var lineH = 2.8;
    var padX = 2.5;
    var padY = 1.8;

    // Variable width
    var longestLine = Math.max.apply(null, lines.map(function(l) { return l.length; }));
    var bubbleW = longestLine * fontSize * 0.5 + padX * 2;
    if (bubbleW < 16) bubbleW = 16;
    if (bubbleW > 75) bubbleW = 75;
    var bubbleH = lines.length * lineH + padY * 2;

    // Stagger left/right like a real thread
    var isLeft = i % 2 === 0;
    var bubbleX = isLeft ? 6 : (94 - bubbleW);
    var bubbleY = startY + i * slotH;

    var bubbleColor = q.isJoke ? "rgba(120,160,130,0.45)" : bubbleColors[i % bubbleColors.length];
    var bubbleRadius = 2.2;

    // ── SENDER NAME — small, above bubble ──
    if (q.sender) {
      els.push(React.createElement("text", {
        key: "sn" + i, x: isLeft ? bubbleX + 1.5 : bubbleX + bubbleW - 1.5,
        y: bubbleY - 1, textAnchor: isLeft ? "start" : "end",
        fill: "#FFFFFF", opacity: .35, fontSize: 1.1, fontWeight: "400", fontFamily: SANS, letterSpacing: .1
      }, q.sender));
    }

    // Bubble — rounded rect with iOS-style radius
    els.push(React.createElement("rect", {
      key: "b" + i, x: bubbleX, y: bubbleY,
      width: bubbleW, height: bubbleH,
      rx: bubbleRadius, ry: bubbleRadius,
      fill: bubbleColor
    }));

    // Tail — proper iMessage tail shape
    if (isLeft) {
      els.push(React.createElement("path", {
        key: "tail" + i,
        d: "M" + (bubbleX + 1.2) + " " + (bubbleY + bubbleH - 1.5) +
           " Q" + (bubbleX - .8) + " " + (bubbleY + bubbleH + .5) +
           " " + (bubbleX - .3) + " " + (bubbleY + bubbleH + 1) +
           " Q" + (bubbleX + .5) + " " + (bubbleY + bubbleH - .2) +
           " " + (bubbleX + 2) + " " + (bubbleY + bubbleH - .4),
        fill: bubbleColor
      }));
    } else {
      var rx = bubbleX + bubbleW;
      els.push(React.createElement("path", {
        key: "tail" + i,
        d: "M" + (rx - 1.2) + " " + (bubbleY + bubbleH - 1.5) +
           " Q" + (rx + .8) + " " + (bubbleY + bubbleH + .5) +
           " " + (rx + .3) + " " + (bubbleY + bubbleH + 1) +
           " Q" + (rx - .5) + " " + (bubbleY + bubbleH - .2) +
           " " + (rx - 2) + " " + (bubbleY + bubbleH - .4),
        fill: bubbleColor
      }));
    }

    // Text — white
    lines.forEach(function(line, li) {
      els.push(React.createElement("text", {
        key: "bt" + i + "_" + li,
        x: bubbleX + padX, y: bubbleY + padY + 1.4 + li * lineH,
        fill: "#FFFFFF",
        fontSize: fontSize, fontWeight: "400", fontFamily: SANS, letterSpacing: .03,
        opacity: .95
      }, line));
    });

    // ── Delivered / Read receipt on last bubble ──
    if (i === allBubbles.length - 1 && !isLeft) {
      els.push(React.createElement("text", {
        key: "read", x: bubbleX + bubbleW - 1, y: bubbleY + bubbleH + 2.5,
        textAnchor: "end", fill: "#FFFFFF", opacity: .20,
        fontSize: .9, fontWeight: "300", fontFamily: SANS
      }, "Read"));
    }
  });

  return els;
}

// ═══════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════
// ═══════════════════════════════════════════
// STYLE: CUSTOM — user-designed poster
// Background, text colour/texture, typeface, alignment
// ═══════════════════════════════════════════

var MONO = '"Courier New", Courier, monospace';

// ── Colour maths ──────────────────────────
function hx2rgb(h) {
  h = (h || "#000000").replace("#", "");
  if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
  return [parseInt(h.substr(0, 2), 16), parseInt(h.substr(2, 2), 16), parseInt(h.substr(4, 2), 16)];
}
function rgb2hx(r, g, b) {
  function c(v) { v = Math.max(0, Math.min(255, Math.round(v))); var s = v.toString(16); return s.length === 1 ? "0" + s : s; }
  return "#" + c(r) + c(g) + c(b);
}
export function luminance(hex) {
  var p = hx2rgb(hex).map(function(v) {
    v = v / 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * p[0] + 0.7152 * p[1] + 0.0722 * p[2];
}
export function contrastRatio(a, b) {
  var la = luminance(a), lb = luminance(b);
  var hi = Math.max(la, lb), lo = Math.min(la, lb);
  return (hi + 0.05) / (lo + 0.05);
}
export function autoTextColor(bg) {
  return luminance(bg) > 0.42 ? "#141014" : "#F7F3EC";
}
// amt > 0 lightens toward white, amt < 0 darkens toward black
function shade(hex, amt) {
  var c = hx2rgb(hex);
  if (amt >= 0) return rgb2hx(c[0] + (255 - c[0]) * amt, c[1] + (255 - c[1]) * amt, c[2] + (255 - c[2]) * amt);
  return rgb2hx(c[0] * (1 + amt), c[1] * (1 + amt), c[2] * (1 + amt));
}

// ── Option catalogues (consumed by the designer panel) ──
export var CUSTOM_BACKGROUNDS = [
  { id: "midnight", label: "Midnight", color: "#050510" },
  { id: "ink", label: "Ink", color: "#0E0B18" },
  { id: "charcoal", label: "Charcoal", color: "#1A1A1A" },
  { id: "navy", label: "Navy", color: "#0B1B2B" },
  { id: "forest", label: "Forest", color: "#0F2018" },
  { id: "oxblood", label: "Oxblood", color: "#2B0F14" },
  { id: "terracotta", label: "Terracotta", color: "#B4674C" },
  { id: "antique", label: "Antique Gold", color: "#B0925F" },
  { id: "sage", label: "Sage", color: "#D5DCCB" },
  { id: "blush", label: "Blush", color: "#F1E1E1" },
  { id: "bone", label: "Bone", color: "#EDE7DC" },
  { id: "cream", label: "Cream", color: "#F6F1E6" },
];

export var CUSTOM_TEXT_COLORS = [
  { id: "auto", label: "Auto", color: null },
  { id: "white", label: "White", color: "#FFFFFF" },
  { id: "ivory", label: "Ivory", color: "#F5F0E6" },
  { id: "gold", label: "Gold", color: "#C9A96E" },
  { id: "silver", label: "Silver", color: "#C4C4C4" },
  { id: "rose", label: "Rose Gold", color: "#B8967A" },
  { id: "ink", label: "Ink", color: "#141014" },
  { id: "oxblood", label: "Oxblood", color: "#5A1520" },
];

export var CUSTOM_TEXTURES = [
  { id: "solid", label: "Solid", hint: "Flat, even weight" },
  { id: "foil", label: "Foil", hint: "Metallic sheen" },
  { id: "letterpress", label: "Letterpress", hint: "Pressed into the paper" },
  { id: "outline", label: "Outline", hint: "Hollow name" },
  { id: "translucent", label: "Translucent", hint: "Softened, veiled" },
];

export var CUSTOM_FINISHES = [
  { id: "flat", label: "Flat" },
  { id: "grain", label: "Grain" },
  { id: "gradient", label: "Gradient" },
  { id: "vignette", label: "Vignette" },
];

export var CUSTOM_TYPE_SETS = [
  { id: "editorial", label: "Editorial", hint: "Playfair + Cormorant" },
  { id: "modern", label: "Modern", hint: "Outfit" },
  { id: "classic", label: "Classic", hint: "Cormorant" },
  { id: "typewriter", label: "Typewriter", hint: "Courier" },
];

export var CUSTOM_NAME_PLACEMENTS = [
  { id: "bottom", label: "Name below" },
  { id: "top", label: "Name above" },
  { id: "center", label: "Name centred" },
];

export var CUSTOM_QUOTE_ALIGNS = [
  { id: "radial", label: "Radial", hint: "Quotes fan outward from each star" },
  { id: "left", label: "Left", hint: "Quotes run as a column, constellation sits right" },
  { id: "center", label: "Centred", hint: "Quotes stack under their star" },
];

export var CUSTOM_STAR_MARKS = [
  { id: "dot", label: "Dot", icon: "\u25CF" },
  { id: "diamond", label: "Diamond", icon: "\u2727" },
  { id: "ring", label: "Ring", icon: "\u25CB" },
  { id: "none", label: "None", icon: "\u00B7" },
];

export var CUSTOM_BORDERS = [
  { id: "none", label: "None" },
  { id: "hairline", label: "Hairline" },
  { id: "double", label: "Double rule" },
];

export var CUSTOM_NAME_CASES = [
  { id: "asTyped", label: "As typed" },
  { id: "upper", label: "Uppercase" },
];

export var CUSTOM_DEFAULTS = {
  bg: "#050510",
  finish: "flat",
  textColor: "auto",
  texture: "solid",
  typeSet: "editorial",
  namePlacement: "bottom",
  quoteAlign: "radial",
  starMark: "dot",
  showLines: true,
  border: "none",
  nameCase: "asTyped",
  scale: 1,
  nameScale: 1,
  trackingScale: 1,
  quoteScale: 1,
};

var TYPE_SET_MAP = {
  editorial: { display: PLAY, body: SERIF, italic: true, nameWeight: "400", nameSpacing: 1.5, nameScale: 1.5, charW: 0.46, dispW: 0.58 },
  modern: { display: SANS, body: SANS, italic: false, nameWeight: "300", nameSpacing: 4, nameScale: 1.25, charW: 0.56, dispW: 0.62 },
  classic: { display: SERIF, body: SERIF, italic: true, nameWeight: "300", nameSpacing: 3, nameScale: 1.6, charW: 0.45, dispW: 0.57 },
  typewriter: { display: MONO, body: MONO, italic: false, nameWeight: "400", nameSpacing: 1.2, nameScale: 1.15, charW: 0.62, dispW: 0.62 },
};

function clampNum(v, lo, hi, dflt) {
  var n = typeof v === "number" ? v : dflt;
  return Math.max(lo, Math.min(hi, n));
}

export function resolveCustomStyle(data) {
  var c = (data && data.customStyle) || {};
  var bg = c.bg || CUSTOM_DEFAULTS.bg;
  var picked = c.textColor || CUSTOM_DEFAULTS.textColor;
  return {
    bg: bg,
    finish: c.finish || CUSTOM_DEFAULTS.finish,
    textColor: (!picked || picked === "auto") ? autoTextColor(bg) : picked,
    texture: c.texture || CUSTOM_DEFAULTS.texture,
    typeSet: c.typeSet || CUSTOM_DEFAULTS.typeSet,
    namePlacement: c.namePlacement || CUSTOM_DEFAULTS.namePlacement,
    quoteAlign: c.quoteAlign || CUSTOM_DEFAULTS.quoteAlign,
    starMark: c.starMark || CUSTOM_DEFAULTS.starMark,
    showLines: c.showLines !== false,
    border: c.border || CUSTOM_DEFAULTS.border,
    nameCase: c.nameCase || CUSTOM_DEFAULTS.nameCase,
    scale: clampNum(c.scale, 0.7, 1.3, 1),
    nameScale: clampNum(c.nameScale, 0.6, 1.6, 1),
    trackingScale: clampNum(c.trackingScale, 0, 3, 1),
    quoteScale: clampNum(c.quoteScale, 0.7, 1.5, 1),
  };
}

// Where the constellation, the name and the text column sit
export function customGeom(cfg) {
  var leftCol = cfg.quoteAlign === "left";
  var g;
  if (cfg.namePlacement === "top") g = { cx: 50, cy: 57, radius: 24, nameY: 16, adjY: 21 };
  else if (cfg.namePlacement === "center") g = { cx: 50, cy: 50, radius: 27, nameY: 51, adjY: 56 };
  else g = { cx: 50, cy: 40, radius: 24, nameY: 85, adjY: 89 };

  g.nameX = 50;
  g.jokeY = 92;
  g.footY = 95.5;

  if (leftCol) {
    // Editorial split — quotes run down the left, constellation sits right
    g.cx = 70;
    g.radius = 17;
    g.colX = 7;
    g.colW = 40;
    g.colTop = cfg.namePlacement === "top" ? 27 : 13;
    g.colBottom = cfg.namePlacement === "bottom" ? 78 : 87;
    if (cfg.namePlacement === "center") { g.nameX = 70; g.cy = 50; }
  }

  g.radius = g.radius * (cfg.scale || 1);
  return g;
}

// Text element factory — applies the chosen texture.
// Outline is a display treatment only; body copy stays solid so it survives print.
function custText(cfg, key, attrs, content) {
  var a = Object.assign({}, attrs);
  var op = a.opacity == null ? 1 : a.opacity;
  var isDisplay = a["data-display"] === true;
  delete a["data-display"];
  delete a.opacity;
  delete a.fill;

  if (cfg.texture === "outline" && isDisplay) {
    return [React.createElement("text", Object.assign({}, a, {
      key: key, fill: "none", stroke: cfg.textColor, strokeWidth: 0.22, opacity: op,
    }), content)];
  }

  var halo = { stroke: cfg.bg, strokeWidth: isDisplay ? 0.5 : 0.35, paintOrder: "stroke" };

  if (cfg.texture === "letterpress") {
    var press = luminance(cfg.bg) > 0.42 ? shade(cfg.bg, 0.85) : shade(cfg.bg, -0.6);
    return [
      React.createElement("text", Object.assign({}, a, {
        key: key + "_press", y: (a.y || 0) + 0.22, fill: press, opacity: op * 0.7,
      }), content),
      React.createElement("text", Object.assign({}, a, {
        key: key, fill: cfg.textColor, opacity: op,
      }), content),
    ];
  }

  if (cfg.texture === "foil") {
    return [React.createElement("text", Object.assign({}, a, halo, {
      key: key, fill: "url(#custFoil)", opacity: op,
    }), content)];
  }

  if (cfg.texture === "translucent") {
    return [React.createElement("text", Object.assign({}, a, {
      key: key, fill: cfg.textColor, opacity: op * 0.55,
    }), content)];
  }

  return [React.createElement("text", Object.assign({}, a, halo, {
    key: key, fill: cfg.textColor, opacity: op,
  }), content)];
}

// Rendered width of a line, in viewBox units.
// Deliberately runs ~8% wide: overestimating shrinks type a little, underestimating
// puts ink past the trim edge on a real print.
function custWidthFactor(text, baseW) {
  var len = (text || "").length || 1;
  var upper = ((text || "").match(/[A-Z]/g) || []).length;
  return baseW * (1 + 0.3 * (upper / len)) * 1.08;
}
function custLineW(text, size, baseW, tracking) {
  var len = (text || "").length;
  return len * size * custWidthFactor(text, baseW) + Math.max(0, len - 1) * tracking;
}

function custWrapWords(text, maxChars) {
  var words = (text || "").split(" ");
  var lines = [], cur = "";
  words.forEach(function(w) {
    if ((cur + " " + w).length > maxChars && cur) { lines.push(cur); cur = w; }
    else { cur = cur ? cur + " " + w : w; }
  });
  if (cur) lines.push(cur);
  return lines;
}

// Fit a quote into an available width and a line budget WITHOUT dropping words —
// shrink the type instead of truncating.
function custFit(text, availW, size, charW, tracking, maxLines) {
  var wf = custWidthFactor(text, charW);
  var s = size;
  for (var attempt = 0; attempt < 8; attempt++) {
    var perChar = s * wf + tracking;
    var maxChars = Math.max(6, Math.floor((availW + tracking) / perChar));
    var lines = custWrapWords(text, maxChars);
    var widest = 0;
    lines.forEach(function(l) { widest = Math.max(widest, custLineW(l, s, charW, tracking)); });
    if (lines.length <= maxLines && widest <= availW) return { lines: lines, size: s, width: widest };
    s = s * 0.9;
  }
  var finalChars = Math.max(6, Math.floor((availW + tracking) / (s * wf + tracking)));
  var finalLines = custWrapWords(text, finalChars);
  var fw = 0;
  finalLines.forEach(function(l) { fw = Math.max(fw, custLineW(l, s, charW, tracking)); });
  return { lines: finalLines, size: s, width: Math.min(fw, availW) };
}

function renderCustom(data) {
  var cfg = resolveCustomStyle(data);
  var geom = customGeom(cfg);
  var type = TYPE_SET_MAP[cfg.typeSet] || TYPE_SET_MAP.editorial;
  var name = data.personName || "";
  if (cfg.nameCase === "upper") name = name.toUpperCase();
  var stars = data.stars || [];
  var contributors = data.contributors || [];
  var isLightBg = luminance(cfg.bg) > 0.42;
  var els = [];

  var accent = isLightBg ? shade(cfg.textColor, -0.1) : shade(cfg.textColor, 0.1);
  var MARGIN = 5;
  var TRACK = 0.3;

  // ── Defs ──
  var defs = [];
  defs.push(React.createElement("linearGradient", { key: "foil", id: "custFoil", x1: "0%", y1: "0%", x2: "100%", y2: "100%" },
    React.createElement("stop", { offset: "0%", stopColor: shade(cfg.textColor, -0.35) }),
    React.createElement("stop", { offset: "22%", stopColor: shade(cfg.textColor, 0.5) }),
    React.createElement("stop", { offset: "46%", stopColor: shade(cfg.textColor, -0.18) }),
    React.createElement("stop", { offset: "70%", stopColor: shade(cfg.textColor, 0.55) }),
    React.createElement("stop", { offset: "100%", stopColor: shade(cfg.textColor, -0.3) })
  ));
  defs.push(React.createElement("linearGradient", { key: "bgg", id: "custBgGrad", x1: "0%", y1: "0%", x2: "0%", y2: "100%" },
    React.createElement("stop", { offset: "0%", stopColor: shade(cfg.bg, isLightBg ? 0.35 : 0.16) }),
    React.createElement("stop", { offset: "100%", stopColor: shade(cfg.bg, isLightBg ? -0.12 : -0.45) })
  ));
  defs.push(React.createElement("radialGradient", { key: "vig", id: "custVig", cx: "50%", cy: "45%", r: "72%" },
    React.createElement("stop", { offset: "55%", stopColor: "#000000", stopOpacity: 0 }),
    React.createElement("stop", { offset: "100%", stopColor: "#000000", stopOpacity: isLightBg ? 0.22 : 0.55 })
  ));
  defs.push(React.createElement("filter", { key: "grf", id: "custGrain", x: "0%", y: "0%", width: "100%", height: "100%" },
    React.createElement("feTurbulence", { type: "fractalNoise", baseFrequency: "0.85", numOctaves: "3", stitchTiles: "stitch" }),
    React.createElement("feColorMatrix", { type: "saturate", values: "0" })
  ));
  els.push(React.createElement("defs", { key: "custdefs" }, defs));

  // ── Background ──
  els.push(React.createElement("rect", { key: "custbg", width: 100, height: 100, fill: cfg.bg }));
  if (cfg.finish === "gradient") {
    els.push(React.createElement("rect", { key: "custbg2", width: 100, height: 100, fill: "url(#custBgGrad)" }));
  }
  if (cfg.finish === "grain") {
    els.push(React.createElement("rect", {
      key: "custgrain", width: 100, height: 100, filter: "url(#custGrain)",
      opacity: isLightBg ? 0.10 : 0.14, style: { mixBlendMode: "overlay" },
    }));
  }
  if (cfg.finish === "vignette") {
    els.push(React.createElement("rect", { key: "custvig", width: 100, height: 100, fill: "url(#custVig)" }));
  }

  // ── Border ──
  if (cfg.border === "hairline") {
    els.push(React.createElement("rect", { key: "custbord", x: 4, y: 4, width: 92, height: 92, fill: "none", stroke: accent, strokeWidth: 0.15, opacity: 0.45 }));
  } else if (cfg.border === "double") {
    els.push(React.createElement("rect", { key: "custbord1", x: 3.4, y: 3.4, width: 93.2, height: 93.2, fill: "none", stroke: accent, strokeWidth: 0.22, opacity: 0.5 }));
    els.push(React.createElement("rect", { key: "custbord2", x: 5.4, y: 5.4, width: 89.2, height: 89.2, fill: "none", stroke: accent, strokeWidth: 0.08, opacity: 0.35 }));
  }
  var edge = cfg.border === "none" ? MARGIN : (cfg.border === "double" ? 8 : 7);

  // ── Constellation ──
  var positioned = layoutConstellation(
    stars, geom.cx, geom.cy, geom.radius,
    data.layoutPreset || "scattered",
    data.customPositions || null,
    data.customQuotePositions || null
  );
  var n = positioned.length;

  if (cfg.showLines) {
    for (var li = 0; li < n; li++) {
      var nx = (li + 1) % n;
      var cuSeg = trimLine(positioned[li].x, positioned[li].y, positioned[nx].x, positioned[nx].y, 3.2);
      if (cuSeg) els.push(React.createElement("line", {
        key: "custl" + li,
        x1: cuSeg.x1, y1: cuSeg.y1, x2: cuSeg.x2, y2: cuSeg.y2,
        stroke: accent, strokeWidth: 0.12, opacity: cfg.quoteAlign === "left" ? 0.5 : 0.35,
      }));
    }
  }

  // Base type sizing per alignment mode, then the user's size multiplier
  var baseQ = cfg.quoteAlign === "left"
    ? (n <= 6 ? 1.9 : 1.6)
    : (n <= 4 ? 2.2 : n <= 6 ? 2.0 : 1.6);
  var qSize = baseQ * cfg.quoteScale;
  var maxLines = cfg.quoteAlign === "radial" ? 4 : 3;
  var slotH = n > 0 ? (geom.colBottom - geom.colTop) / n : 0;

  positioned.forEach(function(sp, i) {
    var quote = sp.star.decode || sp.star.label || "";
    var contrib = (sp.star.starContributors && sp.star.starContributors[0])
      ? sp.star.starContributors[0]
      : (contributors[i % (contributors.length || 1)] || "");
    var op = n <= 4 ? 0.92 : (i === 0 ? 0.92 : i < 3 ? 0.82 : 0.72);

    // ── Star mark ──
    if (cfg.starMark === "dot") {
      els.push(React.createElement("circle", { key: "custs" + i, cx: sp.x, cy: sp.y, r: 0.6, fill: cfg.textColor, opacity: 0.95 }));
      els.push(React.createElement("circle", { key: "custs2" + i, cx: sp.x, cy: sp.y, r: 1.3, fill: accent, opacity: 0.12 }));
    } else if (cfg.starMark === "diamond") {
      els.push(React.createElement("text", {
        key: "custs" + i, x: sp.x, y: sp.y + 0.85, textAnchor: "middle",
        fill: cfg.textColor, opacity: 0.95, fontSize: 2.6,
      }, "\u2727"));
    } else if (cfg.starMark === "ring") {
      els.push(React.createElement("circle", { key: "custs" + i, cx: sp.x, cy: sp.y, r: 1.0, fill: "none", stroke: cfg.textColor, strokeWidth: 0.2, opacity: 0.9 }));
      els.push(React.createElement("circle", { key: "custs2" + i, cx: sp.x, cy: sp.y, r: 0.22, fill: cfg.textColor, opacity: 0.9 }));
    }

    // ── Available width, then fit the quote into it ──
    var anchor = sp.anchor, qx = sp.qx, qy = sp.qy, availW;
    if (cfg.quoteAlign === "left") {
      anchor = "start"; qx = geom.colX;
      availW = geom.colW;
    } else if (cfg.quoteAlign === "center") {
      anchor = "middle"; qx = sp.x;
      availW = 2 * Math.min(qx - edge, 100 - edge - qx);
    } else {
      availW = anchor === "start" ? (100 - edge - qx) : (qx - edge);
    }
    availW = Math.max(16, availW);

    var fit = custFit(quote, availW, qSize, type.charW, TRACK, maxLines);
    var lines = fit.lines, size = fit.size, blockW = fit.width;
    var lineH = size * 1.24;

    if (cfg.quoteAlign === "left") {
      qy = geom.colTop + i * slotH + (slotH - lines.length * lineH) / 2 + size;
    } else if (cfg.quoteAlign === "center") {
      qy = sp.y + 3.2;
    }

    // Backstop clamp — should never fire now, but keeps ink off the trim edge
    if (anchor === "start" && qx + blockW > 100 - edge) qx = 100 - edge - blockW;
    if (anchor === "end" && qx - blockW < edge) qx = edge + blockW;
    if (anchor === "middle") {
      if (qx - blockW / 2 < edge) qx = edge + blockW / 2;
      if (qx + blockW / 2 > 100 - edge) qx = 100 - edge - blockW / 2;
    }

    lines.forEach(function(line, k) {
      els = els.concat(custText(cfg, "custq" + i + "_" + k, {
        x: qx, y: qy + k * lineH, textAnchor: anchor, opacity: op,
        fontSize: size, fontStyle: type.italic ? "italic" : "normal",
        fontWeight: "300", fontFamily: type.body, letterSpacing: TRACK,
      }, (k === 0 ? "\u201C" : "") + line + (k === lines.length - 1 ? "\u201D" : "")));
    });

    // Attribution — bottom-left of the quote block
    var ax = qx, aAnchor = "start";
    if (anchor === "end") ax = qx - blockW;
    if (anchor === "middle") aAnchor = "middle";
    els = els.concat(custText(cfg, "custa" + i, {
      x: ax, y: qy + lines.length * lineH + 1.4, textAnchor: aAnchor, opacity: op * 0.75,
      fontSize: Math.max(0.8, size * 0.52), fontWeight: "300", fontFamily: type.body,
    }, "\u2014 " + contrib));
  });

  // ── Name ── (shrink to fit the plate width)
  var nameSize = nameSz(name) * type.nameScale * cfg.nameScale * (cfg.namePlacement === "center" ? 1.15 : 1);
  var tracking = type.nameSpacing * cfg.trackingScale;
  var maxNameW = 100 - edge * 2;
  var guard = 0;
  while (custLineW(name, nameSize, type.dispW, tracking) > maxNameW && guard < 60) {
    nameSize = nameSize * 0.95; tracking = tracking * 0.95; guard++;
  }
  els = els.concat(custText(cfg, "custname", {
    x: geom.nameX, y: geom.nameY, textAnchor: "middle", opacity: 1,
    fontSize: nameSize, fontWeight: type.nameWeight,
    letterSpacing: tracking, fontFamily: type.display,
    "data-display": true,
  }, name));

  // ── Adjective subtitle ──
  var adj = data.adjectiveFreq || [];
  if (adj.length > 0) {
    var top3 = adj.slice(0, 3).map(function(a) { return a.word; }).join(", ");
    els = els.concat(custText(cfg, "custadj", {
      x: geom.nameX, y: geom.adjY, textAnchor: "middle", opacity: 0.6,
      fontSize: 1.3 * cfg.nameScale, fontStyle: type.italic ? "italic" : "normal",
      fontWeight: "300", fontFamily: type.body, letterSpacing: 0.2,
    }, top3));
  }

  // ── Inside joke ──
  var jokes = data.insideJokes || [];
  if (jokes.length > 0 && jokes[0].text) {
    els = els.concat(custText(cfg, "custjoke", {
      x: 50, y: geom.jokeY, textAnchor: "middle", opacity: 0.45,
      fontSize: 1.1, fontStyle: "italic", fontWeight: "300", fontFamily: type.body,
    }, jokes[0].text));
  }

  // ── Divider + contributor footer ──
  els.push(React.createElement("line", {
    key: "custdiv", x1: 34, y1: geom.footY - 2.4, x2: 66, y2: geom.footY - 2.4,
    stroke: accent, strokeWidth: 0.05, opacity: 0.3,
  }));
  var cuCred = creditLines(contributors, { base: 0.65, sep: "    \u00B7    " });
  cuCred.lines.forEach(function(ln, i) {
    els = els.concat(custText(cfg, "custcon" + i, {
      x: 50, y: geom.footY + (i - (cuCred.lines.length - 1)) * cuCred.size * 1.35, textAnchor: "middle", opacity: 0.28,
      fontSize: cuCred.size, fontWeight: "300", fontFamily: type.body, letterSpacing: 0.2,
    }, ln));
  });

  return els;
}

// ═══════════════════════════════════════════
// STYLE: MOSAIC — the words form the shape
// From across the room it reads as a mark. Up close it's what people wrote.
// Shape modes: initials | zodiac | logo
// ═══════════════════════════════════════════

export var MOSAIC_SHAPES = [
  { id: "initials", label: "Initials", hint: "Their initials, filled with the words" },
  { id: "zodiac", label: "Star sign", hint: "Their sign, filled with the words" },
  { id: "logo", label: "Logo", hint: "Upload a company mark" },
];

export var MOSAIC_ZODIAC = [
  { id: "aries", label: "Aries", glyph: "\u2648", dates: "Mar 21 \u2013 Apr 19" },
  { id: "taurus", label: "Taurus", glyph: "\u2649", dates: "Apr 20 \u2013 May 20" },
  { id: "gemini", label: "Gemini", glyph: "\u264A", dates: "May 21 \u2013 Jun 20" },
  { id: "cancer", label: "Cancer", glyph: "\u264B", dates: "Jun 21 \u2013 Jul 22" },
  { id: "leo", label: "Leo", glyph: "\u264C", dates: "Jul 23 \u2013 Aug 22" },
  { id: "virgo", label: "Virgo", glyph: "\u264D", dates: "Aug 23 \u2013 Sep 22" },
  { id: "libra", label: "Libra", glyph: "\u264E", dates: "Sep 23 \u2013 Oct 22" },
  { id: "scorpio", label: "Scorpio", glyph: "\u264F", dates: "Oct 23 \u2013 Nov 21" },
  { id: "sagittarius", label: "Sagittarius", glyph: "\u2650", dates: "Nov 22 \u2013 Dec 21" },
  { id: "capricorn", label: "Capricorn", glyph: "\u2651", dates: "Dec 22 \u2013 Jan 19" },
  { id: "aquarius", label: "Aquarius", glyph: "\u2652", dates: "Jan 20 \u2013 Feb 18" },
  { id: "pisces", label: "Pisces", glyph: "\u2653", dates: "Feb 19 \u2013 Mar 20" },
];

export var MOSAIC_INKS = [
  { id: "gold", label: "Gold", color: "#C9A96E" },
  { id: "champagne", label: "Champagne", color: "#E4CFA3" },
  { id: "silver", label: "Silver", color: "#C6C9CE" },
  { id: "ivory", label: "Ivory", color: "#F2EDE3" },
  { id: "rose", label: "Rose Gold", color: "#C69A82" },
];

export var MOSAIC_GROUNDS = [
  { id: "black", label: "Black", color: "#080808" },
  { id: "midnight", label: "Midnight", color: "#050510" },
  { id: "ink", label: "Ink", color: "#0E0B18" },
  { id: "navy", label: "Navy", color: "#081420" },
  { id: "bone", label: "Bone", color: "#EDE7DC" },
  { id: "cream", label: "Cream", color: "#F6F1E6" },
];

export var MOSAIC_DEFAULTS = {
  shape: "initials",
  zodiac: "leo",
  logoData: null,
  logoInvert: true,
  ink: "#C9A96E",
  ground: "#080808",
  density: 1,
  invert: false,
  showCredit: true,
  shapeText: "",
};

export function resolveMosaic(data) {
  var m = (data && data.mosaicStyle) || {};
  return {
    shape: m.shape || MOSAIC_DEFAULTS.shape,
    zodiac: m.zodiac || MOSAIC_DEFAULTS.zodiac,
    logoData: m.logoData || null,
    logoInvert: m.logoInvert !== false,
    ink: m.ink || MOSAIC_DEFAULTS.ink,
    ground: m.ground || MOSAIC_DEFAULTS.ground,
    density: clampNum(m.density, 0.7, 1.4, 1),
    invert: m.invert === true,
    showCredit: m.showCredit !== false,
    shapeText: m.shapeText || "",
  };
}

// Initials from a name — up to three letters
function mosaicInitials(name) {
  var parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  return parts.slice(0, 3).map(function(p) { return p.charAt(0).toUpperCase(); }).join("");
}

// Break a sentence into fragments that still MEAN something on their own.
// Splitting on character count produced things like "and taking ownership of",
// so break only at real clause boundaries: punctuation first, then conjunctions.
var MOSAIC_JOINTS = [" and ", " but ", " so ", " because ", " when ", " while ",
  " until ", " after ", " before ", " though ", " which ", " who ", " that "];

function mosaicSplitAtJoint(text, maxLen) {
  if (text.length <= maxLen) return [text];
  // find the conjunction nearest the middle so both halves stay substantial
  var mid = text.length / 2, best = -1, bestJoint = "", bestDist = 1e9;
  MOSAIC_JOINTS.forEach(function(j) {
    var from = 0, at;
    while ((at = text.indexOf(j, from)) !== -1) {
      var d = Math.abs(at - mid);
      if (at > 8 && text.length - at > 8 && d < bestDist) { bestDist = d; best = at; bestJoint = j; }
      from = at + 1;
    }
  });
  if (best === -1) return [text];
  var head = text.slice(0, best).trim();
  // drop a dangling coordinating conjunction off the front of the tail
  var tail = text.slice(best + 1).trim().replace(/^(and|but|so|or)\s+/i, "");
  return mosaicSplitAtJoint(head, maxLen).concat(mosaicSplitAtJoint(tail, maxLen));
}

function mosaicChunks(text, maxLen) {
  var out = [];
  var parts = (text || "").split(/[,;:\u2014\u2013]+|\.\s+/)
    .map(function(p) { return p.trim().replace(/[.,;:]+$/, ""); })
    .filter(Boolean);
  parts.forEach(function(p) {
    mosaicSplitAtJoint(p, maxLen).forEach(function(c) {
      if (c && c.length > 2) out.push(c);
    });
  });
  return out.length ? out : [(text || "").trim()].filter(Boolean);
}

// Every fragment that goes into the field, weighted by how much it should stand out
function mosaicCorpus(data) {
  var frags = [];
  function addQuote(txt) {
    mosaicChunks(txt, 44).forEach(function(c) { frags.push({ text: c, weight: 1 }); });
  }
  (data.stars || []).forEach(function(s) {
    var q = (s.decode || s.label || "").trim();
    if (q) addQuote(q);
  });
  (data.rawQuotes || []).forEach(function(q) {
    var txt = (q.text || q.quote || "").trim();
    if (txt) addQuote(txt);
  });
  (data.adjectiveFreq || []).forEach(function(a) {
    if (a.word) frags.push({ text: a.word.toUpperCase(), weight: 0.42, caps: true });
  });
  (data.insideJokes || []).forEach(function(j) {
    var txt = (j.text || "").trim();
    if (txt) mosaicChunks(txt, 34).forEach(function(c) { frags.push({ text: c, weight: 0.5 }); });
  });
  if (!frags.length) frags.push({ text: data.personName || "\u2014", weight: 1 });
  return frags;
}

function renderMosaic(data) {
  var cfg = resolveMosaic(data);
  var name = data.personName || "";
  var contributors = data.contributors || [];
  var isLightGround = luminance(cfg.ground) > 0.42;
  var els = [];
  var maskId = "mosMask", threshId = "mosThresh", glowId = "mosGlow";

  // Shape occupies the upper plate; name and credit sit beneath
  var box = { x: 12, y: 13, w: 76, h: 61 };
  var nameY = 84;
  var ruleY = nameY + 4.5;
  var credY = nameY + 8.5;
  var cx = box.x + box.w / 2, cy = box.y + box.h / 2;

  // ── The shape, drawn once as a reusable element ──
  function shapeEl(key, fill, extra) {
    var common = Object.assign({ key: key }, extra || {});
    if (cfg.shape === "logo" && cfg.logoData) {
      return React.createElement("image", Object.assign({}, common, {
        href: cfg.logoData,
        x: box.x, y: box.y, width: box.w, height: box.h,
        preserveAspectRatio: "xMidYMid meet",
        filter: "url(#" + threshId + ")",
      }));
    }
    if (cfg.shape === "zodiac") {
      var z = MOSAIC_ZODIAC.filter(function(s) { return s.id === cfg.zodiac; })[0] || MOSAIC_ZODIAC[4];
      // Astrological glyphs run about 0.95 em tall including descenders (Leo's
      // tail). Size for the whole glyph box or it overruns the plate.
      var zfs = Math.min(box.h / 0.95, box.w / 0.95);
      return React.createElement("text", Object.assign({}, common, {
        x: cx, y: cy + zfs * 0.276, textAnchor: "middle",
        fontSize: zfs, fill: fill, fontFamily: SANS,
      }), z.glyph + "\uFE0E");
    }
    // Cap height is ~0.70 em, not 1.0 — sizing to the box height directly left the
    // mark at 70% of the plate, which reads as small and lost. Fit to whichever
    // dimension actually binds.
    var letters = (cfg.shapeText || "").trim() || mosaicInitials(name);
    var CAP = 0.70, CAPW = 0.72, TRACK = -0.02;
    var fs = box.h / CAP;
    var wide = letters.length * fs * (CAPW + TRACK);
    if (wide > box.w) fs = box.w / (letters.length * (CAPW + TRACK));
    return React.createElement("text", Object.assign({}, common, {
      x: cx, y: cy + fs * CAP * 0.5, textAnchor: "middle",
      fontSize: fs, fill: fill, fontFamily: PLAY, fontWeight: "700", letterSpacing: TRACK * fs,
    }), letters);
  }

  // ── Defs: threshold filter, soft glow, the mask itself ──
  // XOR: inverting the mask must also invert how a logo is thresholded
  var thresholdFlip = cfg.logoInvert !== cfg.invert;
  var thresh = React.createElement("filter", { key: "th", id: threshId, x: "-10%", y: "-10%", width: "120%", height: "120%" },
    React.createElement("feColorMatrix", { type: "saturate", values: "0" }),
    React.createElement("feComponentTransfer", null,
      React.createElement("feFuncR", { type: "linear", slope: thresholdFlip ? -5 : 5, intercept: thresholdFlip ? 2.6 : -1.6 }),
      React.createElement("feFuncG", { type: "linear", slope: thresholdFlip ? -5 : 5, intercept: thresholdFlip ? 2.6 : -1.6 }),
      React.createElement("feFuncB", { type: "linear", slope: thresholdFlip ? -5 : 5, intercept: thresholdFlip ? 2.6 : -1.6 })
    )
  );
  var glow = React.createElement("filter", { key: "gl", id: glowId, x: "-20%", y: "-20%", width: "140%", height: "140%" },
    React.createElement("feGaussianBlur", { stdDeviation: 1.1 })
  );
  // Inverted: the plate fills with words and the shape is cut OUT of them,
  // so the mark reads as negative space instead of as text.
  var mask = React.createElement("mask", { key: "mk", id: maskId },
    React.createElement("rect", { x: 0, y: 0, width: 100, height: 100, fill: cfg.invert ? "#FFFFFF" : "#000000" }),
    shapeEl("maskshape", cfg.invert ? "#000000" : "#FFFFFF")
  );
  els.push(React.createElement("defs", { key: "mosdefs" }, thresh, glow, mask));

  // ── Ground ──
  els.push(React.createElement("rect", { key: "mosbg", width: 100, height: 100, fill: cfg.ground }));

  // ── Soft silhouette behind the words, so the mark holds at a distance ──
  els.push(React.createElement("g", { key: "mossil", filter: "url(#" + glowId + ")", opacity: cfg.invert ? (isLightGround ? 0.16 : 0.22) : (isLightGround ? 0.11 : 0.16) },
    shapeEl("silshape", cfg.ink)
  ));

  // ── The text field, clipped to the shape ──
  var corpus = mosaicCorpus(data);
  var rows = [];
  var baseSize = 1.05 / cfg.density;
  var rowH = baseSize * 1.16;
  var seed = 91;
  function rnd() { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; }

  var deck = [], deckIdx = 0;
  function nextFrag() {
    if (deckIdx >= deck.length) {
      deck = corpus.slice();
      for (var d = deck.length - 1; d > 0; d--) {
        var j = Math.floor(rnd() * (d + 1));
        var tmp = deck[d]; deck[d] = deck[j]; deck[j] = tmp;
      }
      deckIdx = 0;
    }
    return deck[deckIdx++];
  }

  // Lay the field across the whole plate, not just the shape box — the mask
  // clips it, and anything the shape reaches that the field doesn't would
  // otherwise render as bare glow with no words in it.
  var field = cfg.invert
    ? { x: 2, y: 4, w: 96, h: (box.y + box.h + 6) - 4 }
    : { x: 2, y: box.y - 6, w: 96, h: box.h + 12 };
  for (var y = field.y; y < field.y + field.h; y += rowH) {
    var rowSize = baseSize * (0.86 + rnd() * 0.34);
    var x = field.x;
    var guard = 0;
    while (x < field.x + field.w && guard < 80) {
      guard++;
      var frag = nextFrag();
      var isAdj = frag.caps === true;
      var size = rowSize * (0.8 + frag.weight * 0.45);
      var w = custLineW(frag.text, size, isAdj ? 0.62 : 0.5, isAdj ? 0.16 : 0.06);
      rows.push({
        x: x, y: y, size: size, text: frag.text,
        opacity: 0.56 + rnd() * 0.44,
        italic: !isAdj && frag.weight <= 0.5,
        caps: isAdj,
      });
      x += w + size * 0.85;
    }
  }

  var fieldEls = rows.map(function(r, i) {
    return React.createElement("text", {
      key: "mos" + i, x: r.x, y: r.y,
      fontSize: r.size, fill: cfg.ink, opacity: r.opacity,
      fontFamily: r.caps ? SANS : SERIF,
      fontStyle: r.italic ? "italic" : "normal",
      fontWeight: r.caps ? "500" : "400",
      letterSpacing: r.caps ? 0.16 : 0.06,
    }, r.text);
  });
  els.push(React.createElement("g", { key: "mosfield", mask: "url(#" + maskId + ")" }, fieldEls));

  // ── Name ──
  var nameFS = nameSz(name) * 1.15;
  var nameTrack = 2.2;
  var g2 = 0;
  while (custLineW(name, nameFS, 0.6, nameTrack) > 84 && g2 < 60) { nameFS *= 0.95; nameTrack *= 0.95; g2++; }
  els.push(React.createElement("text", {
    key: "mosname", x: 50, y: nameY, textAnchor: "middle",
    fontSize: nameFS, fill: cfg.ink, opacity: 0.95,
    fontFamily: PLAY, fontWeight: "400", letterSpacing: nameTrack,
  }, name));

  // ── Hairline rule ──
  els.push(React.createElement("line", {
    key: "mosrule", x1: 30, y1: ruleY, x2: 70, y2: ruleY,
    stroke: cfg.ink, strokeWidth: 0.06, opacity: 0.35,
  }));

  // ── Credit line — names live here, never inside the shape ──
  if (cfg.showCredit && contributors.length) {
    var moCred = creditLines(contributors, { base: 1.15, sep: " \u00B7 ", maxW: 78 });
    moCred.lines.forEach(function(ln, i) {
      els.push(React.createElement("text", {
        key: "moscred" + i, x: 50, y: credY + (i - (moCred.lines.length - 1)) * moCred.size * 1.35, textAnchor: "middle",
        fontSize: moCred.size, fill: cfg.ink, opacity: 0.5,
        fontFamily: SERIF, fontStyle: "italic", fontWeight: "300", letterSpacing: 0.2,
      }, (i === 0 ? "Words by " : "") + ln));
    });
  }

  return els;
}

// ═══════════════════════════════════════════
// STYLE: GRID — one cell per person
// The only style that gets better as contributors go up. Built for
// farewells and retirements where fifteen or twenty people sign.
// ═══════════════════════════════════════════

export var GRID_DEFAULTS = {
  ground: "#F6F1E6",
  ink: "auto",
  rules: true,
  showRelationship: true,
  quoteScale: 1,
};

export function resolveGrid(data) {
  var g = (data && data.gridStyle) || {};
  var ground = g.ground || GRID_DEFAULTS.ground;
  var picked = g.ink || GRID_DEFAULTS.ink;
  return {
    ground: ground,
    ink: (!picked || picked === "auto") ? autoTextColor(ground) : picked,
    rules: g.rules !== false,
    showRelationship: g.showRelationship !== false,
    quoteScale: clampNum(g.quoteScale, 0.7, 1.4, 1),
  };
}

// One entry per contributor: their name, how they know the person, their line
function gridEntries(data) {
  var meta = {};
  (data.contributorMeta || []).forEach(function(m) { if (m && m.name) meta[m.name] = m; });
  var names = data.contributors || [];
  return names.map(function(nm) {
    var quote = "";
    (data.stars || []).forEach(function(s) {
      if (!quote && (s.starContributors || []).indexOf(nm) >= 0 && s.decode) quote = s.decode;
    });
    if (!quote) {
      (data.rawQuotes || []).forEach(function(q) { if (!quote && q.contributor === nm) quote = (q.text || "").trim(); });
    }
    if (!quote) {
      (data.insideJokes || []).forEach(function(j) { if (!quote && j.contributor === nm) quote = (j.text || "").trim(); });
    }
    var m = meta[nm] || {};
    return { name: nm, relationship: m.relationship || "", quote: quote };
  });
}

function gridColumns(n) {
  if (n <= 4) return 2;
  if (n <= 9) return 3;
  if (n <= 16) return 4;
  if (n <= 25) return 5;
  return 6;
}

function renderGrid(data) {
  var cfg = resolveGrid(data);
  var name = data.personName || "";
  var entries = gridEntries(data);
  var n = entries.length;
  var isLightGround = luminance(cfg.ground) > 0.42;
  var els = [];
  var muted = isLightGround ? shade(cfg.ink, 0.42) : shade(cfg.ink, -0.32);

  els.push(React.createElement("rect", { key: "gbg", width: 100, height: 100, fill: cfg.ground }));

  // ── Masthead ──
  var nameFS = nameSz(name) * 1.05;
  var nameTrack = 2.4;
  var gGuard = 0;
  while (custLineW(name, nameFS, 0.58, nameTrack) > 82 && gGuard < 60) {
    nameFS *= 0.95; nameTrack *= 0.95; gGuard++;
  }
  els.push(React.createElement("text", {
    key: "gname", x: 50, y: 13, textAnchor: "middle",
    fontSize: nameFS, fill: cfg.ink, opacity: 0.96,
    fontFamily: PLAY, fontWeight: "400", letterSpacing: nameTrack,
  }, name));

  var adj = data.adjectiveFreq || [];
  if (adj.length) {
    els.push(React.createElement("text", {
      key: "gadj", x: 50, y: 17.6, textAnchor: "middle",
      fontSize: 1.35, fill: muted, opacity: 0.9,
      fontFamily: SERIF, fontStyle: "italic", letterSpacing: 0.25,
    }, adj.slice(0, 3).map(function(a) { return a.word; }).join(", ")));
  }

  els.push(React.createElement("text", {
    key: "gcount", x: 50, y: 21.8, textAnchor: "middle",
    fontSize: 0.95, fill: muted, opacity: 0.8,
    fontFamily: SANS, letterSpacing: 1.6,
  }, "IN THE WORDS OF " + n + (n === 1 ? " PERSON" : " PEOPLE")));

  if (n === 0) return els;

  // ── Grid geometry ──
  var GX = 8, GW = 84, GTOP = 26, GBOT = 95;
  var cols = gridColumns(n);
  var rows = Math.ceil(n / cols);
  var cellW = GW / cols;
  var cellH = (GBOT - GTOP) / rows;
  var padX = Math.min(2.2, cellW * 0.09);
  var innerW = cellW - padX * 2;

  // Type scales with how many cells have to fit
  var nameFSz = Math.max(0.75, Math.min(1.5, cellH * 0.115)) * cfg.quoteScale;
  var relFSz = nameFSz * 0.78;
  var quoteFSz = Math.max(0.72, Math.min(1.85, cellH * 0.14)) * cfg.quoteScale;

  // ── Rules ──
  if (cfg.rules) {
    for (var r = 0; r <= rows; r++) {
      var ry = GTOP + r * cellH;
      els.push(React.createElement("line", {
        key: "ghr" + r, x1: GX, y1: ry, x2: GX + GW, y2: ry,
        stroke: cfg.ink, strokeWidth: r === 0 ? 0.12 : 0.05, opacity: r === 0 ? 0.4 : 0.22,
      }));
    }
    for (var c = 1; c < cols; c++) {
      var cxr = GX + c * cellW;
      els.push(React.createElement("line", {
        key: "gvr" + c, x1: cxr, y1: GTOP, x2: cxr, y2: GTOP + rows * cellH,
        stroke: cfg.ink, strokeWidth: 0.05, opacity: 0.18,
      }));
    }
  }

  // ── Cells ──
  entries.forEach(function(e, i) {
    var col = i % cols, row = Math.floor(i / cols);
    var x0 = GX + col * cellW + padX;
    var y0 = GTOP + row * cellH;

    var cursor = y0 + nameFSz + 1.6;
    els.push(React.createElement("text", {
      key: "gn" + i, x: x0, y: cursor,
      fontSize: nameFSz, fill: cfg.ink, opacity: 0.95,
      fontFamily: SANS, fontWeight: "500", letterSpacing: 0.5,
    }, e.name));
    cursor += nameFSz * 0.35;

    if (cfg.showRelationship && e.relationship) {
      cursor += relFSz + 0.5;
      els.push(React.createElement("text", {
        key: "gr" + i, x: x0, y: cursor,
        fontSize: relFSz, fill: muted, opacity: 0.95,
        fontFamily: SANS, letterSpacing: 0.3,
      }, e.relationship));
    }

    if (!e.quote) return;

    // Fit the quote into what's left of the cell without dropping words
    var headerUsed = cursor - y0;
    var availH = cellH - headerUsed - 2.4;
    var lineH = quoteFSz * 1.22;
    var maxLines = Math.max(1, Math.floor(availH / lineH));
    var fit = custFit(e.quote, innerW, quoteFSz, 0.46, 0.05, maxLines);
    var qLineH = fit.size * 1.22;

    fit.lines.forEach(function(line, k) {
      els.push(React.createElement("text", {
        key: "gq" + i + "_" + k, x: x0, y: cursor + 2.2 + k * qLineH,
        fontSize: fit.size, fill: cfg.ink, opacity: 0.88,
        fontFamily: SERIF, fontStyle: "italic", fontWeight: "300", letterSpacing: 0.05,
      }, (k === 0 ? "\u201C" : "") + line + (k === fit.lines.length - 1 ? "\u201D" : "")));
    });
  });

  return els;
}

export var LAYOUT_PRESET_NAMES = [
  { id: "scattered", label: "Scattered", icon: "\u2726" },
  { id: "circle", label: "Circle", icon: "\u25CB" },
  { id: "diamond", label: "Diamond", icon: "\u25C7" },
  { id: "arc", label: "Arc", icon: "\u2312" },
  { id: "linear", label: "Cascade", icon: "\u2502" },
  { id: "butterfly", label: "Butterfly", icon: "\u2740" },
  { id: "heart", label: "Heart", icon: "\u2661" },
  { id: "infinity", label: "Infinity", icon: "\u221E" },
];

export default function CrystalCompositor(props) {
  var data = props.data;
  var style = props.crystalStyle || "inscription";
  var highlightIndex = props.highlightIndex;
  var onStarDrag = props.onStarDrag || null;
  var onQuoteDrag = props.onQuoteDrag || null;
  if (!data) return null;

  // No taglines on any design
  data = Object.assign({}, data, { headline: "" });

  var seed = 7;
  var nm = data.personName || "";
  for (var ci = 0; ci < nm.length; ci++) seed = seed * 31 + nm.charCodeAt(ci);
  var rand = sr(Math.abs(seed));

  var content;
  if (style === "monument") content = renderMonument(data);
  else if (style === "crown") content = renderCrown(data);
  else if (style === "poem") content = renderPoem(data);
  else if (style === "tribute") content = renderTribute(data);
  else if (style === "voices") content = renderVoices(data);
  else if (style === "gallery") content = renderGallery(data);
  else if (style === "fingerprint") content = renderFingerprint(data);
  else if (style === "kaleidoscope") content = renderKaleidoscope(data);
  else if (style === "starmap") content = renderStarMap(data);
  else if (style === "overlap") content = renderOverlap(data);
  else if (style === "starmap2") content = renderStarMap2(data);
  else if (style === "starlight") content = renderStarlight(data);
  else if (style === "overlap2") content = renderOverlap2(data);
  else if (style === "gallery2") content = renderGallery2(data);
  else if (style === "ember") content = renderEmber(data);
  else if (style === "bloom") content = renderBloom(data);
  else if (style === "starmap2") content = renderStarMap2(data);
  else if (style === "gallery2") content = renderGallery2(data);
  else if (style === "ember") content = renderEmber(data);
  else if (style === "bloom") content = renderBloom(data);
  else if (style === "overlap2") content = renderOverlap2(data);
  else if (style === "prism") content = renderPrism(data);
  else if (style === "decode") content = renderDecode(data);
  else if (style === "botanical") content = renderBotanical(data);
  else if (style === "statement") content = renderStatement(data);
  else if (style === "texts") content = renderTexts(data);
  else if (style === "custom") content = renderCustom(data);
  else if (style === "mosaic") content = renderMosaic(data);
  else if (style === "grid") content = renderGrid(data);
  else if (style === "editorial") content = renderEditorial(data);
  else content = renderInscription(data);

  // Highlight glow for active editing
  var highlightEls = null;
  if (highlightIndex !== null && highlightIndex !== undefined && highlightIndex >= 0) {
    var stars = data.stars || [];
    if (highlightIndex < stars.length) {
      // For constellation-layout styles, calculate star position
      if (style === "starmap2" || style === "starlight" || style === "custom") {
        var hlGeom = style === "custom" ? customGeom(resolveCustomStyle(data)) : { cx: 50, cy: style === "starlight" ? 40 : 42, radius: 24 };
        var hlPositioned = layoutConstellation(stars, hlGeom.cx, hlGeom.cy, hlGeom.radius, data.layoutPreset || "scattered", data.customPositions || null, data.customQuotePositions || null);
        if (highlightIndex < hlPositioned.length) {
          var hp = hlPositioned[highlightIndex];
          highlightEls = React.createElement("g", { key: "hl" },
            React.createElement("circle", { cx: hp.x, cy: hp.y, r: 5, fill: "none", stroke: "#C9A96E", strokeWidth: .25, opacity: .80 }),
            React.createElement("circle", { cx: hp.x, cy: hp.y, r: 3, fill: "#C9A96E", opacity: .15 }),
            React.createElement("style", null, "@keyframes hlPulse { 0%,100% { r: 3; opacity: 0.15; } 50% { r: 6; opacity: 0.08; } }")
          );
        }
      } else {
        // For non-constellation styles, show a subtle border highlight
        highlightEls = React.createElement("rect", {
          key: "hlborder", x: 1, y: 1, width: 98, height: 98,
          fill: "none", stroke: "#C9A96E", strokeWidth: .3, opacity: .40,
          rx: 1, strokeDasharray: "2 1"
        });
      }
    }
  }

  var isPoster = style === "editorial" || style === "grid" || style === "mosaic" || style === "custom" || style === "gallery" || style === "fingerprint" || style === "kaleidoscope" || style === "starmap" || style === "overlap" || style === "starmap2" || style === "starlight" || style === "overlap2" || style === "gallery2" || style === "ember" || style === "bloom" || style === "starmap2" || style === "gallery2" || style === "ember" || style === "bloom" || style === "overlap2" || style === "prism" || style === "decode" || style === "botanical" || style === "statement" || style === "texts";

  var posterBg = style === "custom" ? resolveCustomStyle(data).bg
    : style === "mosaic" ? resolveMosaic(data).ground
    : style === "grid" ? resolveGrid(data).ground
    : style === "editorial" ? "#0D0D11"
    : "#0A0A0A";

  if (isPoster) {
    // Poster styles — full SVG, no crystal overlay, deep purple bg
    var skipDust = style === "editorial" || style === "starmap2" || style === "starlight" || style === "bloom" || style === "statement" || style === "texts" || style === "custom" || style === "mosaic" || style === "grid";

    // Drag handles for constellation styles
    var dragHandles = null;
    if (onStarDrag && (style === "starmap2" || style === "starlight" || style === "custom") && data.stars) {
      var dragGeom = style === "custom" ? customGeom(resolveCustomStyle(data)) : { cx: 50, cy: style === "starlight" ? 40 : 42, radius: 24 };
      var dragPositioned = layoutConstellation(data.stars, dragGeom.cx, dragGeom.cy, dragGeom.radius, data.layoutPreset || "scattered", data.customPositions || null, data.customQuotePositions || null);
      dragHandles = dragPositioned.map(function(sp, di) {
        var handles = [];
        // Star drag handle
        handles.push(React.createElement("circle", {
          key: "drag" + di, cx: sp.x, cy: sp.y, r: 3,
          fill: "transparent", stroke: "rgba(201,169,110,0.3)", strokeWidth: 0.15, cursor: "grab",
          style: { pointerEvents: "all" },
          onMouseDown: function(e) {
            e.preventDefault();
            var svg = e.target.closest("svg");
            if (!svg) return;
            var pt = svg.createSVGPoint();
            var move = function(me) {
              pt.x = me.clientX; pt.y = me.clientY;
              var svgP = pt.matrixTransform(svg.getScreenCTM().inverse());
              onStarDrag(di, { x: Math.round(svgP.x * 10) / 10, y: Math.round(svgP.y * 10) / 10 });
            };
            var up = function() {
              document.removeEventListener("mousemove", move);
              document.removeEventListener("mouseup", up);
            };
            document.addEventListener("mousemove", move);
            document.addEventListener("mouseup", up);
          },
          onTouchStart: function(e) {
            var svg = e.target.closest("svg");
            if (!svg) return;
            var pt = svg.createSVGPoint();
            var move = function(te) {
              var touch = te.touches[0];
              pt.x = touch.clientX; pt.y = touch.clientY;
              var svgP = pt.matrixTransform(svg.getScreenCTM().inverse());
              onStarDrag(di, { x: Math.round(svgP.x * 10) / 10, y: Math.round(svgP.y * 10) / 10 });
            };
            var up = function() {
              document.removeEventListener("touchmove", move);
              document.removeEventListener("touchend", up);
            };
            document.addEventListener("touchmove", move, { passive: false });
            document.addEventListener("touchend", up);
          },
        }));
        // Quote drag handle
        if (onQuoteDrag) {
          handles.push(React.createElement("rect", {
            key: "qdrag" + di, x: sp.qx - 3, y: sp.qy - 2, width: 12, height: 6,
            fill: "transparent", stroke: "rgba(201,169,110,0.2)", strokeWidth: 0.1,
            strokeDasharray: "0.5 0.3", cursor: "move",
            style: { pointerEvents: "all" },
            onMouseDown: function(e) {
              e.preventDefault();
              var svg = e.target.closest("svg");
              if (!svg) return;
              var pt = svg.createSVGPoint();
              var move = function(me) {
                pt.x = me.clientX; pt.y = me.clientY;
                var svgP = pt.matrixTransform(svg.getScreenCTM().inverse());
                onQuoteDrag(di, { x: Math.round(svgP.x * 10) / 10, y: Math.round(svgP.y * 10) / 10 });
              };
              var up = function() {
                document.removeEventListener("mousemove", move);
                document.removeEventListener("mouseup", up);
              };
              document.addEventListener("mousemove", move);
              document.addEventListener("mouseup", up);
            },
            onTouchStart: function(e) {
              var svg = e.target.closest("svg");
              if (!svg) return;
              var pt = svg.createSVGPoint();
              var move = function(te) {
                var touch = te.touches[0];
                pt.x = touch.clientX; pt.y = touch.clientY;
                var svgP = pt.matrixTransform(svg.getScreenCTM().inverse());
                onQuoteDrag(di, { x: Math.round(svgP.x * 10) / 10, y: Math.round(svgP.y * 10) / 10 });
              };
              var up = function() {
                document.removeEventListener("touchmove", move);
                document.removeEventListener("touchend", up);
              };
              document.addEventListener("touchmove", move, { passive: false });
              document.addEventListener("touchend", up);
            },
          }));
        }
        return handles;
      }).flat();
    }

    return React.createElement("div", { style: { position: "relative", width: "100%", maxWidth: 500, margin: "0 auto" } },
      React.createElement("svg", { viewBox: "0 0 100 100", xmlns: "http://www.w3.org/2000/svg", preserveAspectRatio: "xMidYMid meet", style: { width: "100%", display: "block", borderRadius: 6, background: posterBg } },
        React.createElement("rect", { width: 100, height: 100, fill: posterBg }),
        sharedDefs(),
        skipDust ? null : makeDust(rand, 60),
        content,
        highlightEls,
        dragHandles
      )
    );
  }

  return React.createElement("div", { style: { position: "relative", width: "100%", maxWidth: 500, margin: "0 auto" } },
    React.createElement("div", { style: { position: "absolute", top: 0, left: 0, width: "100%", height: "100%", zIndex: 1 } },
      React.createElement("svg", { viewBox: "0 0 100 100", xmlns: "http://www.w3.org/2000/svg", preserveAspectRatio: "xMidYMid slice", style: { width: "100%", height: "100%", display: "block" } },
        React.createElement("rect", { width: 100, height: 100, fill: "black" }),
        sharedDefs(),
        React.createElement("rect", { width: 100, height: 100, fill: "url(#ledGlow)" }),
        makeDust(rand, 50),
        React.createElement("g", { filter: "url(#etch)" }, content)
      )
    ),
    React.createElement("img", { src: "/crystal-ref.png", alt: "", style: { position: "relative", zIndex: 2, width: "100%", display: "block", borderRadius: 6, mixBlendMode: "lighten" } })
  );
}
